import React, { createContext, useState, useEffect, useRef } from 'react';
import logoUrl from '../assets/logo.png';
import { wsService } from '../services/websocket';
import { 
  DEFAULT_CARD_HTML_TEMPLATE, 
  generateCardImageBase64, 
  generateCardImageHtml 
} from '../utils/signatureGenerator';
import {
  getStoredAuthSession,
  saveAuthSession,
  clearAuthSession,
  isAppEnvironment,
  isNativePlatform
} from '../services/storageService';
import {
  getUserEmailsFromDb,
  saveUserEmailsToDb,
  deleteUserEmailsFromDb,
  clearUserEmailsFromDb
} from '../services/indexedDbMailService';

export const AppContext = createContext();

// Dynamic Storage Quota calculation helper (Requirement 2)
// 2GB base for lower ranks, +2GB increment per job level
export const getStorageQuotaByPosition = (position) => {
  const pos = String(position || '사원').trim();
  if (pos.includes('대표이사') || pos.includes('대표') || pos.includes('사장') || pos.includes('CEO')) return 12;
  if (pos.includes('이사') || pos.includes('상무') || pos.includes('전무') || pos.includes('부장')) return 10;
  if (pos.includes('수석') || pos.includes('차장')) return 8;
  if (pos.includes('책임') || pos.includes('팀장') || pos.includes('과장')) return 6;
  if (pos.includes('선임') || pos.includes('전임') || pos.includes('대리')) return 4;
  return 2; // 사원, 운영, 주임, 인턴 등 기본 (2GB)
};

const INITIAL_USERS = [
  { UserID: 'emp-01', Name: '권진용', Account: 'jykwon', Email: 'jykwon@clouflake.com', MustChangePassword: true, Phone: '010-5805-1610', EmploymentType: '정규', EmploymentStatus: '재직', Position: '이사', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '이사', JoinDate: '2021-04-01', Tenure: '5년 4개월', TotalLeave: 17, UsedLeave: 2, RemainingLeave: 15, ForwardingEmail: '', Aliases: '', StorageQuota: 10, StorageUsed: 2.1, Status: 'Active', Role: 'ADMIN' },
  { UserID: 'emp-02', Name: '김민석', Account: 'edenatom', Email: 'edenatom@clouflake.com', MustChangePassword: true, Phone: '010-7449-7102', EmploymentType: '정규', EmploymentStatus: '재직', Position: '수석', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '수석', JoinDate: '2026-01-29', Tenure: '0년 6개월', TotalLeave: 11, UsedLeave: 1, RemainingLeave: 10, ForwardingEmail: '', Aliases: '', StorageQuota: 8, StorageUsed: 1.2, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-03', Name: '김의중', Account: 'kimuijoong', Email: 'kimuijoong@clouflake.com', MustChangePassword: true, Phone: '010-2101-1231', EmploymentType: '정규', EmploymentStatus: '재직', Position: '책임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '책임', JoinDate: '2023-10-24', Tenure: '2년 9개월', TotalLeave: 15, UsedLeave: 3, RemainingLeave: 12, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 1.5, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-04', Name: '남택중', Account: 'ntj1104', Email: 'ntj1104@clouflake.com', MustChangePassword: true, Phone: '010-4876-2775', EmploymentType: '정규', EmploymentStatus: '재직', Position: '책임', Duty: '책임', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '책임', JoinDate: '2026-07-06', Tenure: '0년 1개월', TotalLeave: 11, UsedLeave: 0, RemainingLeave: 11, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 0.4, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-05', Name: '문융희', Account: 'yhmoon', Email: 'yhmoon@clouflake.com', MustChangePassword: true, Phone: '010-2613-1745', EmploymentType: '정규', EmploymentStatus: '재직', Position: '팀장', Duty: '팀장', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '팀장', JoinDate: '2026-05-26', Tenure: '0년 2개월', TotalLeave: 11, UsedLeave: 1, RemainingLeave: 10, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 3.8, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-06', Name: '박경규', Account: 'kkpark', Email: 'kkpark@clouflake.com', MustChangePassword: true, Phone: '010-4994-7468', EmploymentType: '정규', EmploymentStatus: '재직', Position: '선임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '선임', JoinDate: '2021-07-03', Tenure: '5년 1개월', TotalLeave: 17, UsedLeave: 4, RemainingLeave: 13, ForwardingEmail: '', Aliases: '', StorageQuota: 4, StorageUsed: 2.2, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-07', Name: '박신로', Account: 'skels210', Email: 'skels210@clouflake.com', MustChangePassword: true, Phone: '010-2101-4421', EmploymentType: '정규', EmploymentStatus: '재직', Position: '수석', Duty: '수석', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '수석', JoinDate: '2026-05-04', Tenure: '0년 3개월', TotalLeave: 11, UsedLeave: 0, RemainingLeave: 11, ForwardingEmail: '', Aliases: '', StorageQuota: 8, StorageUsed: 1.1, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-08', Name: '신주현', Account: 'rnlfldndb', Email: 'rnlfldndb@clouflake.com', MustChangePassword: true, Phone: '010-2101-5003', EmploymentType: '정규', EmploymentStatus: '재직', Position: '사원', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '사원', JoinDate: '2022-09-19', Tenure: '3년 10개월', TotalLeave: 15, UsedLeave: 5, RemainingLeave: 10, ForwardingEmail: '', Aliases: '', StorageQuota: 2, StorageUsed: 2.8, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-09', Name: '이상희', Account: 'clou0315', Email: 'clou0315@clouflake.com', MustChangePassword: true, Phone: '010-2821-3711', EmploymentType: '정규', EmploymentStatus: '재직', Position: '이사', Duty: '-', UserGroup: '-', Department: 'AI서비스개발', JobTitle: '이사', JoinDate: '2021-03-15', Tenure: '5년 5개월', TotalLeave: 17, UsedLeave: 2, RemainingLeave: 15, ForwardingEmail: '', Aliases: 'anderson@clouflake.com', StorageQuota: 10, StorageUsed: 4.8, Status: 'Active', Role: 'ADMIN' },
  { UserID: 'emp-10', Name: '이용관', Account: 'chris', Email: 'chris@clouflake.com', MustChangePassword: true, Phone: '010-2101-7893', EmploymentType: '정규', EmploymentStatus: '재직', Position: '대표이사', Duty: '-', UserGroup: '-', Department: '경영마케팅', JobTitle: '대표이사', JoinDate: '2020-01-01', Tenure: '6년 7개월', TotalLeave: 25, UsedLeave: 1, RemainingLeave: 24, ForwardingEmail: '', Aliases: 'ceo@clouflake.com, executive@clouflake.com', StorageQuota: 12, StorageUsed: 8.5, Status: 'Active', Role: 'ADMIN' },
  { UserID: 'emp-11', Name: '이윤환', Account: 'lyh', Email: 'lyh@clouflake.com', MustChangePassword: true, Phone: '010-2101-4821', EmploymentType: '정규', EmploymentStatus: '재직', Position: '책임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '책임', JoinDate: '2024-10-14', Tenure: '1년 10개월', TotalLeave: 15, UsedLeave: 2, RemainingLeave: 13, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 1.7, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-12', Name: '이재영', Account: 'din', Email: 'din@clouflake.com', MustChangePassword: true, Phone: '010-2101-0181', EmploymentType: '정규', EmploymentStatus: '재직', Position: '전임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '전임', JoinDate: '2021-11-01', Tenure: '4년 9개월', TotalLeave: 16, UsedLeave: 4, RemainingLeave: 12, ForwardingEmail: '', Aliases: '', StorageQuota: 4, StorageUsed: 2.4, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-13', Name: '이종동', Account: 'daeny2', Email: 'daeny2@clouflake.com', MustChangePassword: true, Phone: '010-2101-9125', EmploymentType: '정규', EmploymentStatus: '재직', Position: '수석', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '수석', JoinDate: '2021-09-23', Tenure: '4년 10개월', TotalLeave: 16, UsedLeave: 3, RemainingLeave: 13, ForwardingEmail: '', Aliases: '', StorageQuota: 8, StorageUsed: 3.1, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-14', Name: '이준수', Account: 'leejunsoo', Email: 'leejunsoo@clouflake.com', MustChangePassword: true, Phone: '010-2900-9515', EmploymentType: '정규', EmploymentStatus: '재직', Position: '사원', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '사원', JoinDate: '2022-08-11', Tenure: '4년 0개월', TotalLeave: 15, UsedLeave: 3, RemainingLeave: 12, ForwardingEmail: '', Aliases: '', StorageQuota: 2, StorageUsed: 1.8, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-15', Name: '정용철', Account: 'youngchul', Email: 'youngchul@clouflake.com', MustChangePassword: true, Phone: '010-2101-0015', EmploymentType: '정규', EmploymentStatus: '재직', Position: '수석', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '수석', JoinDate: '2026-01-29', Tenure: '0년 6개월', TotalLeave: 11, UsedLeave: 1, RemainingLeave: 10, ForwardingEmail: '', Aliases: '', StorageQuota: 8, StorageUsed: 1.3, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-16', Name: '정준용', Account: 'junyong', Email: 'junyong@clouflake.com', MustChangePassword: true, Phone: '010-2101-0016', EmploymentType: '정규', EmploymentStatus: '재직', Position: '책임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '책임', JoinDate: '2024-01-25', Tenure: '2년 6개월', TotalLeave: 15, UsedLeave: 2, RemainingLeave: 13, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 1.9, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-17', Name: '조석환', Account: 'bzway', Email: 'bzway@clouflake.com', MustChangePassword: true, Phone: '010-3320-6462', EmploymentType: '정규', EmploymentStatus: '재직', Position: '전임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '전임', JoinDate: '2022-06-20', Tenure: '4년 1개월', TotalLeave: 15, UsedLeave: 5, RemainingLeave: 10, ForwardingEmail: '', Aliases: '', StorageQuota: 4, StorageUsed: 2.6, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-18', Name: '최지연', Account: 'jychoi', Email: 'jychoi@clouflake.com', MustChangePassword: true, Phone: '010-2101-0018', EmploymentType: '정규', EmploymentStatus: '퇴사', Position: '사원', Duty: '-', UserGroup: '-', Department: '-', JobTitle: '사원', JoinDate: '2022-07-11', Tenure: '3년 5개월', TotalLeave: 15, UsedLeave: 15, RemainingLeave: 0, ForwardingEmail: 'successor@clouflake.com', Aliases: '', StorageQuota: 2, StorageUsed: 0.5, Status: 'Retired', Role: 'STAFF' },
  { UserID: 'emp-19', Name: '최지훈', Account: 'jhchoi', Email: 'jhchoi@clouflake.com', MustChangePassword: true, Phone: '010-7777-0099', EmploymentType: '정규', EmploymentStatus: '재직', Position: '수석', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '수석', JoinDate: '2021-04-01', Tenure: '5년 4개월', TotalLeave: 17, UsedLeave: 3, RemainingLeave: 14, ForwardingEmail: '', Aliases: '', StorageQuota: 8, StorageUsed: 4.1, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-20', Name: '최현종', Account: 'chj', Email: 'chj@clouflake.com', MustChangePassword: true, Phone: '010-6573-0660', EmploymentType: '정규', EmploymentStatus: '재직', Position: '전임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '전임', JoinDate: '2025-11-19', Tenure: '0년 8개월', TotalLeave: 11, UsedLeave: 0, RemainingLeave: 11, ForwardingEmail: '', Aliases: '', StorageQuota: 4, StorageUsed: 0.9, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-21', Name: '클로우플레이크', Account: 'mgpoc', Email: 'mgpoc@clouflake.com', MustChangePassword: true, Phone: '010-2101-0021', EmploymentType: '정규', EmploymentStatus: '재직', Position: '운영', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '운영', JoinDate: '2026-03-02', Tenure: '0년 5개월', TotalLeave: 11, UsedLeave: 0, RemainingLeave: 11, ForwardingEmail: '', Aliases: '', StorageQuota: 2, StorageUsed: 0.2, Status: 'Active', Role: 'STAFF' },
  { UserID: 'emp-ojs0407', Name: '루시', Account: 'ojs0407', Email: 'ojs0407@clouflake.com', MustChangePassword: true, Phone: '010-6789-3711', EmploymentType: '정규', EmploymentStatus: '재직', Position: '책임', Duty: '-', UserGroup: '-', Department: '클라우드네이티브', JobTitle: '책임', JoinDate: '2026-08-15', Tenure: '0년 1개월', TotalLeave: 11, UsedLeave: 0, RemainingLeave: 11, ForwardingEmail: '', Aliases: '', StorageQuota: 6, StorageUsed: 0, Status: 'Active', Role: 'STAFF' }
];

export const DEFAULT_KAKAO_TEMPLATES = {
  LEAVE_REQUEST: {
    id: 'LEAVE_REQUEST',
    name: '🌴 연차/휴가 결재 요청',
    title: '[클라우플레이크 전자결재 알림]',
    templateText: `[클라우플레이크 전자결재 알림]\n\n신청자: #{신청자명} (#{부서} / #{직급})\n구분: #{연차구분} (#{일수}일)\n기간: #{시작일} ~ #{종료일}\n사유: #{사유}\n\n결재 담당자님의 결재 대기 중입니다. 전자결재 시스템에 접속하여 승인해 주세요.\n\n* 주식회사 클로우플레이크 AX 플랫폼`,
    buttonText: '결재 승인하기',
    buttonUrl: '/#/approvals',
    availableVariables: [
      { tag: '#{신청자명}', label: '신청자 이름', example: '루시' },
      { tag: '#{부서}', label: '부서명', example: '클라우드네이티브' },
      { tag: '#{직급}', label: '직급/직책', example: '사원' },
      { tag: '#{연차구분}', label: '연차/반차 구분', example: '연차' },
      { tag: '#{일수}', label: '신청 일수', example: '1' },
      { tag: '#{시작일}', label: '시작 일자', example: '2026-08-20' },
      { tag: '#{종료일}', label: '종료 일자', example: '2026-08-20' },
      { tag: '#{사유}', label: '신청 사유', example: '개인 사유' }
    ]
  },
  EXPENSE_REQUEST: {
    id: 'EXPENSE_REQUEST',
    name: '💳 경비 청구 결재 요청',
    title: '[클라우플레이크 전자결재 알림]',
    templateText: `[클라우플레이크 전자결재 알림]\n\n신청자: #{신청자명} (#{부서} / #{직급})\n구분: 경비 청구\n금액: #{청구금액}원\n사용처/내용: #{사용내역}\n결제수단: #{카드사} (#{카드번호})\n\n결재 담당자님의 영수증 확인 및 승인이 필요합니다. 전자결재 시스템에 접속하여 승인해 주세요.\n\n* 주식회사 클로우플레이크 AX 플랫폼`,
    buttonText: '결재 승인하기',
    buttonUrl: '/#/approvals',
    availableVariables: [
      { tag: '#{신청자명}', label: '신청자 이름', example: '루시' },
      { tag: '#{부서}', label: '부서명', example: '클라우드네이티브' },
      { tag: '#{직급}', label: '직급/직책', example: '사원' },
      { tag: '#{청구금액}', label: '경비 금액', example: '45,000' },
      { tag: '#{사용내역}', label: '사용처 및 내용', example: '[식대] 팀 점심 식사' },
      { tag: '#{카드사}', label: '카드사명', example: '국민카드' },
      { tag: '#{카드번호}', label: '카드 번호', example: '1234' }
    ]
  },
  NOTICE_BROADCAST: {
    id: 'NOTICE_BROADCAST',
    name: '📢 사내 공지사항 알림',
    title: '[클라우플레이크 사내 공지사항]',
    templateText: `[클라우플레이크 사내 공지사항]\n\n공지제목: #{공지제목}\n작성자: #{작성자명}\n등록일시: #{등록일시}\n\n#{공지내용}\n\n* 주식회사 클로우플레이크 AX 플랫폼`,
    buttonText: '공지 확인하기',
    buttonUrl: '/#/dashboard',
    availableVariables: [
      { tag: '#{공지제목}', label: '공지 제목', example: '3분기 전사 타운홀 미팅 안내' },
      { tag: '#{작성자명}', label: '작성자', example: '문융희 팀장' },
      { tag: '#{등록일시}', label: '등록 일시', example: '2026-08-20 09:00' },
      { tag: '#{공지내용}', label: '공지 본문', example: '금주 금요일 대회의실에서 타운홀 미팅이 진행됩니다.' }
    ]
  },
  MAIL_SUMMARY: {
    id: 'MAIL_SUMMARY',
    name: '✉️ 메일 수신 / AI 요약 알림',
    title: '[클라우플레이크 메일 도착 알림]',
    templateText: `[클라우플레이크 메일 도착 알림]\n\n발신자: #{발신자}\n메일제목: #{메일제목}\n수신일시: #{수신일시}\n\n#{요약내용}\n\n* 주식회사 클로우플레이크 AX 플랫폼`,
    buttonText: '메일 바로보기',
    buttonUrl: '/#/webmail',
    availableVariables: [
      { tag: '#{발신자}', label: '메일 발신자', example: 'partner@client.com' },
      { tag: '#{메일제목}', label: '메일 제목', example: 'Q3 프로젝트 검토 요청' },
      { tag: '#{수신일시}', label: '수신 일시', example: '2026-08-20 10:30' },
      { tag: '#{요약내용}', label: 'AI 요약 또는 본문', example: '1. 제안서 검토 요청\n2. 목요일까지 회신 필요' }
    ]
  },
  APPROVAL_RESULT: {
    id: 'APPROVAL_RESULT',
    name: '✅ 결재 승인/반려 결과 알림',
    title: '[클라우플레이크 전자결재 결과 알림]',
    templateText: `[클라우플레이크 전자결재 결과 알림]\n\n신청자: #{신청자명}님\n신청항목: #{신청항목}\n결재결과: #{결재결과}\n결재자: #{결재자명} (#{결재자직급})\n#{반려사유}\n\n* 주식회사 클로우플레이크 AX 플랫폼`,
    buttonText: '결재 결과보기',
    buttonUrl: '/#/approvals',
    availableVariables: [
      { tag: '#{신청자명}', label: '신청자 이름', example: '루시' },
      { tag: '#{신청항목}', label: '신청 항목/내용', example: '연차 (2026-08-20)' },
      { tag: '#{결재결과}', label: '결재 상태 (승인/반려)', example: '✅ 최종 승인 완료' },
      { tag: '#{결재자명}', label: '결재자 이름', example: '문융희' },
      { tag: '#{결재자직급}', label: '결재자 직급', example: '팀장' },
      { tag: '#{반려사유}', label: '반려 사유 (있을 경우)', example: '반려사유: 일정 조율 필요' }
    ]
  }
};

export const AppProvider = ({ children }) => {
  // 1. Official 21 Clouflake Employees with LocalStorage Persistence
  const [users, setUsers] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_users_v3');
      if (saved) {
        // Enforce the Rank based storage quota rule on startup (Requirement 2)
        const parsed = JSON.parse(saved);
        return parsed.map(u => ({
          ...u,
          StorageQuota: getStorageQuotaByPosition(u.Position || u.JobTitle)
        }));
      }
    } catch (e) {
      console.warn('LocalStorage load error:', e);
    }
    return INITIAL_USERS;
  });

  // Auto-sync users to localStorage
  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_users_v3', JSON.stringify(users));
    } catch (e) {
      console.warn('LocalStorage save error:', e);
    }
  }, [users]);

  // Persist user changes to AWS DynamoDB (Requirement 3 & 4)
  const saveRemoteUser = async (user) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/users/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user })
      });
    } catch (e) {
      console.warn('Failed to save user to AWS DynamoDB:', e);
    }
  };

  // Persist approval changes to AWS DynamoDB
  const saveRemoteApproval = async (approval) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/approvals/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ approval })
      });
    } catch (e) {
      console.warn('Failed to save approval to AWS DynamoDB:', e);
    }
  };

  // Persist leave history change to AWS DynamoDB
  const saveRemoteLeaveHistory = async (history) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/leave-history/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ history })
      });
    } catch (e) {
      console.warn('Failed to save leave history to AWS DynamoDB:', e);
    }
  };

  // Persist contract changes to AWS DynamoDB Contracts table
  const saveRemoteContract = async (contract) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/contracts/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contract })
      });
    } catch (e) {
      console.warn('Failed to save contract to AWS DynamoDB:', e);
    }
  };

  // Delete contract from AWS DynamoDB Contracts table
  const deleteRemoteContract = async (contractId) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/contracts/delete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ContractID: contractId })
      });
    } catch (e) {
      console.warn('Failed to delete contract in AWS DynamoDB:', e);
    }
  };

  // Config load state to prevent premature saving
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const lastSyncedConfigRef = useRef('');

  // 5-2. Manageable department list (부서 목록)
  const [deptList, setDeptList] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_dept_list_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load department list:', e);
    }
    return ['클라우드네이티브', 'AI서비스개발', '경영마케팅', '경영지원팀'];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_dept_list_v3', JSON.stringify(deptList));
    } catch (e) {
      console.warn('Failed to save department list:', e);
    }
  }, [deptList]);

  // 5-3. Custom Logo Size Configuration (관리자 로고 크기 설정)
  const [logoSize, setLogoSize] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_logo_size_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load logo size:', e);
    }
    return { pcWidth: 160, pcHeight: 48, mobileWidth: 120, mobileHeight: 36 };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_logo_size_v3', JSON.stringify(logoSize));
    } catch (e) {
      console.warn('Failed to save logo size:', e);
    }
  }, [logoSize]);

  // 5-3.5. Custom Logo Image Configuration
  const [customLogoUrl, setCustomLogoUrl] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_custom_logo_v3');
      return saved || '';
    } catch (e) {
      return '';
    }
  });

  useEffect(() => {
    try {
      if (customLogoUrl) {
        localStorage.setItem('clou_portal_custom_logo_v3', customLogoUrl);
      } else {
        localStorage.removeItem('clou_portal_custom_logo_v3');
      }
    } catch (e) {}
  }, [customLogoUrl]);

  const currentLogo = customLogoUrl || logoUrl;

  // 5-3.6. Login Screen Logo Size Configuration
  const [loginLogoSize, setLoginLogoSize] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_login_logo_size_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load login logo size:', e);
    }
    return { width: 120, height: 120, padding: 12 };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_login_logo_size_v3', JSON.stringify(loginLogoSize));
    } catch (e) {
      console.warn('Failed to save login logo size:', e);
    }
  }, [loginLogoSize]);

  // 5-4. Custom Font Configurations (관리자 폰트 설정)
  const [customFonts, setCustomFonts] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_custom_fonts_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load custom fonts:', e);
    }
    return {
      menuFamily: 'Pretendard',
      menuSize: 14,
      menuWeight: 'bold',
      contentFamily: 'Pretendard',
      contentSize: 13,
      contentWeight: 'normal'
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_custom_fonts_v3', JSON.stringify(customFonts));
    } catch (e) {
      console.warn('Failed to save custom fonts:', e);
    }
  }, [customFonts]);

  // Company Information State (회사 기준정보)
  const [companyInfo, setCompanyInfo] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_company_info_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return {
      companyName: '주식회사 클로우플레이크',
      representative: '대표이사 이용관',
      businessNumber: '123-45-67890',
      address: '서울시 강서구 양천로 354 옥천빌딩 9층 클로우플레이크 본사'
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_company_info_v3', JSON.stringify(companyInfo));
    } catch (e) {}
  }, [companyInfo]);

  // Synchronize users on startup from AWS DynamoDB (Requirement 3 & 4)
  const fetchRemoteUsers = async () => {
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/users');
      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.users)) {
          const configItem = data.users.find(u => u.UserID === 'system-config');
          const realUsers = data.users.filter(u => u.UserID !== 'system-config');

          if (configItem) {
            const loadedPayload = {
              UserID: 'system-config',
              deptLeads: configItem.deptLeads || deptLeads,
              secondaryApproverIds: configItem.secondaryApproverIds || secondaryApproverIds,
              leavePolicyGroups: configItem.leavePolicyGroups || leavePolicyGroups,
              approvalPresets: configItem.approvalPresets || approvalPresets,
              deptList: configItem.deptList || deptList,
              logoSize: configItem.logoSize || logoSize,
              customFonts: configItem.customFonts || customFonts,
              customLogoUrl: configItem.customLogoUrl || customLogoUrl,
              loginLogoSize: configItem.loginLogoSize || loginLogoSize,
              groupMails: configItem.groupMails || groupMails,
              companySeal: configItem.companySeal || companySeal,
              resignationPolicy: configItem.resignationPolicy || resignationPolicy
            };
            lastSyncedConfigRef.current = JSON.stringify(loadedPayload);

            if (configItem.deptLeads) setDeptLeads(configItem.deptLeads);
            if (configItem.secondaryApproverIds) setSecondaryApproverIds(configItem.secondaryApproverIds);
            if (configItem.leavePolicyGroups) setLeavePolicyGroups(configItem.leavePolicyGroups);
            if (configItem.approvalPresets) setApprovalPresets(configItem.approvalPresets);
            if (configItem.rankApprovalRules && Array.isArray(configItem.rankApprovalRules)) setRankApprovalRules(configItem.rankApprovalRules);
            if (configItem.deptList) setDeptList(configItem.deptList);
            if (configItem.logoSize) setLogoSize(configItem.logoSize);
            if (configItem.customFonts) setCustomFonts(configItem.customFonts);
            if (configItem.customLogoUrl) setCustomLogoUrl(configItem.customLogoUrl);
            if (configItem.loginLogoSize) setLoginLogoSize(configItem.loginLogoSize);
            if (configItem.groupMails && Array.isArray(configItem.groupMails)) setGroupMails(configItem.groupMails);
            if (configItem.companySeal) {
              const sealObj = configItem.companySeal;
              // Ensure clouflake.png is default corporate seal
              if (!sealObj.imageUrl || sealObj.type === 'AUTO_STAMP') {
                sealObj.imageUrl = '/clouflake.png';
                sealObj.type = 'CUSTOM_IMAGE';
              }
              setCompanySeal(sealObj);
            }
            if (configItem.resignationPolicy) setResignationPolicy(configItem.resignationPolicy);
            if (configItem.kakaoBizConfig) setKakaoBizConfig(configItem.kakaoBizConfig);
          }
          setIsConfigLoaded(true);

          const mapped = realUsers.map(u => {
            const tL = (u.TotalLeave !== undefined && u.TotalLeave !== null && u.TotalLeave !== '') ? Number(u.TotalLeave) : 15;
            const uL = (u.UsedLeave !== undefined && u.UsedLeave !== null && u.UsedLeave !== '') ? Number(u.UsedLeave) : 0;
            const rL = (u.RemainingLeave !== undefined && u.RemainingLeave !== null && u.RemainingLeave !== '') ? Number(u.RemainingLeave) : (tL - uL);
            return {
              ...u,
              TotalLeave: tL,
              UsedLeave: uL,
              RemainingLeave: rL,
              StorageQuota: u.StorageQuota !== undefined ? Number(u.StorageQuota) : getStorageQuotaByPosition(u.Position || u.JobTitle)
            };
          });
          setUsers(mapped);
          localStorage.setItem('clou_portal_users_v3', JSON.stringify(mapped));
          setCurrentUser(prev => {
            if (!prev) return prev;
            const updated = mapped.find(u => 
              (u.UserID && prev.UserID && u.UserID === prev.UserID) ||
              (u.Email && prev.Email && u.Email.toLowerCase() === prev.Email.toLowerCase()) ||
              (u.Account && prev.Account && u.Account.toLowerCase() === prev.Account.toLowerCase()) ||
              (u.Aliases && prev.Email && u.Aliases.toLowerCase().includes(prev.Email.toLowerCase()))
            );
            return updated ? { ...prev, ...updated } : prev;
          });
        }
      }
    } catch (e) {
      console.warn('Failed to fetch users from AWS DynamoDB:', e);
      setIsConfigLoaded(true);
    }
  };

  // Synchronize master reference data (기준정보) on startup from AWS DynamoDB SystemConfigs table
  const fetchSystemConfigs = async () => {
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/config/all');
      if (response.ok) {
        const resData = await response.json();
        if (resData.success && resData.configs) {
          const cfg = resData.configs;
          console.log('Successfully loaded SystemConfigs from DynamoDB:', Object.keys(cfg));
          if (cfg.deptLeads) setDeptLeads(cfg.deptLeads);
          if (cfg.secondaryApproverIds) setSecondaryApproverIds(cfg.secondaryApproverIds);
          if (cfg.leavePolicyGroups) setLeavePolicyGroups(cfg.leavePolicyGroups);
          if (cfg.approvalPresets) setApprovalPresets(cfg.approvalPresets);
          if (cfg.rankApprovalRules && Array.isArray(cfg.rankApprovalRules)) setRankApprovalRules(cfg.rankApprovalRules);
          if (cfg.deptList) setDeptList(cfg.deptList);
          if (cfg.logoSize) setLogoSize(cfg.logoSize);
          if (cfg.customFonts) setCustomFonts(cfg.customFonts);
          if (cfg.customLogoUrl) setCustomLogoUrl(cfg.customLogoUrl);
          if (cfg.loginLogoSize) setLoginLogoSize(cfg.loginLogoSize);
          if (cfg.groupMails && Array.isArray(cfg.groupMails)) setGroupMails(cfg.groupMails);
          if (cfg.customers && Array.isArray(cfg.customers)) setCustomers(cfg.customers);
          if (cfg.contractTemplates && Array.isArray(cfg.contractTemplates)) setContractTemplates(cfg.contractTemplates);
          if (cfg.companySeal) {
            const sealObj = cfg.companySeal;
            if (!sealObj.imageUrl || sealObj.type === 'AUTO_STAMP') {
              sealObj.imageUrl = '/clouflake.png';
              sealObj.type = 'CUSTOM_IMAGE';
            }
            setCompanySeal(sealObj);
          }
          if (cfg.resignationPolicy) setResignationPolicy(cfg.resignationPolicy);
          if (cfg.kakaoBizConfig) setKakaoBizConfig(cfg.kakaoBizConfig);
          if (cfg.companyInfo) setCompanyInfo(cfg.companyInfo);
          if (cfg.blockedSenders && Array.isArray(cfg.blockedSenders)) setBlockedSenders(cfg.blockedSenders);
          if (cfg.commonSignature) setCommonSignature(cfg.commonSignature);
        }
      }
    } catch (err) {
      console.warn('Failed to fetch SystemConfigs from DynamoDB:', err);
    }
  };

  const saveSystemConfig = async (key, data) => {
    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/config/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, data })
      });
      console.log(`[DynamoDB SystemConfigs Saved] ${key}`);
    } catch (err) {
      console.warn(`[DynamoDB SystemConfigs Save Failed] ${key}:`, err);
    }
  };

  useEffect(() => {
    fetchRemoteUsers();
    fetchSystemConfigs();
  }, []);

  // Load persisted session (Permanent on App/Mobile, 30-min inactivity on Web)
  const initialSession = getStoredAuthSession();

  // 2. State for active user
  const [currentUser, setCurrentUser] = useState(() => initialSession?.currentUser || {
    UserID: 'emp-09',
    Name: '이상희',
    Account: 'clou0315',
    Email: 'clou0315@clouflake.com',
    Phone: '010-2101-0009',
    Role: 'ADMIN',
    Department: 'AI서비스개발',
    JobTitle: '이사',
    Aliases: 'anderson@clouflake.com'
  });
  
  // Retirement history logs (Requirement 1)
  const [retirementHistory, setRetirementHistory] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_retirement_history_v1');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_retirement_history_v1', JSON.stringify(retirementHistory));
    } catch (e) {
      console.warn('LocalStorage save error:', e);
    }
  }, [retirementHistory]);

  // Login State with session persistence
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!initialSession?.currentUser);
  const [mustChangePasswordPrompt, setMustChangePasswordPrompt] = useState(() => !!initialSession?.mustChangePassword);

  // Inactivity Auto-Logout & User Activity Tracker
  // - Web Browser: 30-Minute Inactivity Auto-Logout
  // - Mobile App (Capacitor/PWA): Permanent session (Auto-Logout bypassed)
  useEffect(() => {
    if (!isLoggedIn || !currentUser) return;

    const isApp = isAppEnvironment();

    const updateActivity = () => {
      saveAuthSession({
        currentUser,
        mustChangePassword: mustChangePasswordPrompt
      });
    };

    const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
    events.forEach(ev => window.addEventListener(ev, updateActivity, { passive: true }));

    // In native app environment, session is permanently retained
    if (isApp) {
      return () => {
        events.forEach(ev => window.removeEventListener(ev, updateActivity));
      };
    }

    // Periodic check every 30 seconds for web browser environment
    const INACTIVITY_LIMIT_MS = 30 * 60 * 1000; // 30 minutes
    const checkInterval = setInterval(() => {
      try {
        const saved = sessionStorage.getItem('clou_auth_session_v2');
        if (saved) {
          const parsed = JSON.parse(saved);
          const elapsed = Date.now() - (parsed.lastActivityAt || 0);
          if (elapsed >= INACTIVITY_LIMIT_MS) {
            alert('30분 동안 사용자의 활동이 없어 세션이 만료되었습니다. 보안을 위해 안전하게 로그아웃합니다.');
            logout();
          }
        }
      } catch (err) {
        console.warn('Session check interval error:', err);
      }
    }, 30000);

    return () => {
      events.forEach(ev => window.removeEventListener(ev, updateActivity));
      clearInterval(checkInterval);
    };
  }, [isLoggedIn, currentUser, mustChangePasswordPrompt]);

  // WebSocket Real-time Event Subscription (Eliminating short-polling)
  useEffect(() => {
    if (isLoggedIn && currentUser?.UserID) {
      wsService.connect(null, currentUser.UserID);

      const unsubMail = wsService.on('MAIL_RECEIVED', (data) => {
        console.log('[WebSocket Real-time Mail Event]', data);
      });

      const unsubAppr = wsService.on('APPROVAL_UPDATED', (data) => {
        console.log('[WebSocket Real-time Approval Event]', data);
      });

      return () => {
        unsubMail();
        unsubAppr();
        wsService.disconnect();
      };
    }
  }, [isLoggedIn, currentUser?.UserID]);

  // 3. Leaves Audit Logs
  const [leaveHistory, setLeaveHistory] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_leave_history_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load leave history:', e);
    }
    return [
      { HistoryID: 'hist-01', UserID: 'emp-01', ChangeType: 'ANNUAL_GRANT', Days: 17, Reason: '2026년 법정 연차 정기 부여', CreatedBy: 'SYSTEM_CRON', Timestamp: '2026-01-01T00:00:00Z' },
      { HistoryID: 'hist-02', UserID: 'emp-05', ChangeType: 'LEAVE_APPROVED', Days: 1, Reason: '리프레시 휴가', CreatedBy: 'emp-09', Timestamp: '2026-07-15T09:30:00Z' },
      { HistoryID: 'hist-03', UserID: 'emp-09', ChangeType: 'ANNUAL_GRANT', Days: 17, Reason: '2026년 법정 연차 정기 부여', CreatedBy: 'SYSTEM_CRON', Timestamp: '2026-01-01T00:00:00Z' }
    ];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_leave_history_v3', JSON.stringify(leaveHistory));
    } catch (e) {
      console.warn('Failed to save leave history:', e);
    }
  }, [leaveHistory]);

  // Helper to safely save emails to localStorage without hitting 5MB QuotaExceededError
  const safeSaveEmailsToLocalStorage = (emailList) => {
    if (!Array.isArray(emailList)) return;
    try {
      localStorage.setItem('clou_portal_emails_v3', JSON.stringify(emailList));
    } catch (e) {
      console.warn('LocalStorage emails quota exceeded, pruning email cache:', e);
      try {
        const cleanAttachments = emailList.map(em => ({
          ...em,
          Attachments: Array.isArray(em.Attachments)
            ? em.Attachments.map(att => {
                if (typeof att === 'string') {
                  return {
                    name: att.split('/').pop(),
                    size: 256000,
                    type: 'application/octet-stream',
                    s3Key: att
                  };
                }
                return {
                  name: att?.name || 'attachment',
                  size: att?.size || 0,
                  type: att?.type || '',
                  s3Key: att?.s3Key || att?.key || null
                };
              })
            : []
        }));
        localStorage.setItem('clou_portal_emails_v3', JSON.stringify(cleanAttachments));
      } catch (e2) {
        try {
          // 2. Keep latest 40 emails with truncated body
          const truncated = emailList.slice(0, 40).map(em => ({
            ...em,
            BodyHTML: em.BodyHTML && em.BodyHTML.length > 2000 ? em.BodyHTML.substring(0, 2000) + '...' : em.BodyHTML,
            BodyText: em.BodyText && em.BodyText.length > 800 ? em.BodyText.substring(0, 800) + '...' : em.BodyText,
            Attachments: []
          }));
          localStorage.setItem('clou_portal_emails_v3', JSON.stringify(truncated));
        } catch (e3) {
          try {
            // 3. Keep latest 15 metadata only
            const metaOnly = emailList.slice(0, 15).map(em => ({
              EmailID: em.EmailID,
              Sender: em.Sender,
              Recipient: em.Recipient,
              Subject: em.Subject,
              Timestamp: em.Timestamp,
              Folder: em.Folder,
              IsRead: em.IsRead
            }));
            localStorage.setItem('clou_portal_emails_v3', JSON.stringify(metaOnly));
          } catch (_) {
            // Fallback gracefully without throwing
          }
        }
      }
    }
  };

  // 4. Real Emails synchronized with DynamoDB and IndexedDB
  const [emails, setEmails] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_emails_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return parsed.filter(e => e.EmailID && !['mail-01', 'mail-02', 'mail-03', 'mail-04', 'mail-05'].includes(e.EmailID));
        }
      }
    } catch (e) {
      console.warn('LocalStorage emails load error:', e);
    }
    return [];
  });

  // Fast 0ms cache retrieval from IndexedDB upon user login/session change
  useEffect(() => {
    const activeEmail = currentUser?.Email || initialSession?.currentUser?.Email;
    if (!activeEmail) return;

    getUserEmailsFromDb(activeEmail).then((cachedEmails) => {
      if (Array.isArray(cachedEmails) && cachedEmails.length > 0) {
        setEmails((prev) => {
          if (!prev || prev.length === 0) {
            return cachedEmails;
          }
          // Merge cached with existing to avoid losing newest emails
          const seen = new Set(prev.map(e => e.EmailID));
          const merged = [...prev];
          for (const item of cachedEmails) {
            if (item && item.EmailID && !seen.has(item.EmailID)) {
              merged.push(item);
              seen.add(item.EmailID);
            }
          }
          merged.sort((a, b) => new Date(b.Timestamp || b.DeliveredAt || 0) - new Date(a.Timestamp || a.DeliveredAt || 0));
          return merged;
        });
      }
    }).catch(err => {
      console.warn('[IndexedDB] Initial load failed:', err);
    });
  }, [currentUser?.Email]);

  // Sync emails to both IndexedDB (user-isolated, quota-free) and localStorage (fallback)
  useEffect(() => {
    const activeEmail = currentUser?.Email;
    if (activeEmail && Array.isArray(emails) && emails.length > 0) {
      saveUserEmailsToDb(activeEmail, emails).catch(err => {
        console.warn('[IndexedDB] Auto-save error:', err);
      });
    }
    safeSaveEmailsToLocalStorage(emails);
  }, [emails, currentUser?.Email]);

  // Starred emails set
  const [starredEmailIds, setStarredEmailIds] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_starred_email_ids_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return parsed.filter(id => !['mail-01', 'mail-02', 'mail-03', 'mail-04', 'mail-05'].includes(id));
        }
      }
    } catch (e) {
      console.warn('Failed to load starred email IDs:', e);
    }
    return [];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_starred_email_ids_v3', JSON.stringify(starredEmailIds));
    } catch (e) {
      console.warn('Failed to save starred email IDs:', e);
    }
  }, [starredEmailIds]);

  const toggleStarEmail = (emailId) => {
    setStarredEmailIds(prev => 
      prev.includes(emailId) ? prev.filter(id => id !== emailId) : [...prev, emailId]
    );
  };

  // 5. Department Lead Config (부서장 매핑)
  const [deptLeads, setDeptLeads] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_dept_leads_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object') {
          // Auto-migrate retired lead emp-05 (문융희) to active lead emp-01 (권진용)
          if (parsed['클라우드네이티브'] === 'emp-05') {
            parsed['클라우드네이티브'] = 'emp-01';
          }
          return parsed;
        }
      }
    } catch (e) {
      console.warn('Failed to load department leads:', e);
    }
    return {
      '경영마케팅': 'emp-10', // 이용관 대표이사
      'AI서비스개발': 'emp-09', // 이상희 이사
      '클라우드네이티브': 'emp-01', // 권진용 이사/팀장
      '-': 'emp-10'
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_dept_leads_v3', JSON.stringify(deptLeads));
    } catch (e) {
      console.warn('Failed to save department leads:', e);
    }
  }, [deptLeads]);

  const updateDeptLead = (deptName, leadUserId) => {
    setDeptLeads(prev => ({ ...prev, [deptName]: leadUserId }));
  };

  // ==========================================
  // Electronic Contracts & Agreements System
  // ==========================================
  const [contracts, setContracts] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_contracts_v2');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load contracts from localStorage:', e);
    }
    // Clean initial state: 0 contracts
    return [];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(contracts));
    } catch (e) {
      console.warn('Failed to save contracts to localStorage:', e);
    }
  }, [contracts]);

  // Load contracts from DynamoDB Contracts table (Authoritative SSOT)
  const fetchRemoteContracts = async () => {
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/contracts');
      if (response.ok) {
        const data = await response.json();
        if (data && Array.isArray(data.contracts)) {
          setContracts(data.contracts);
          try {
            localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(data.contracts));
          } catch (e) {}
          return data.contracts;
        }
      }
    } catch (e) {
      console.warn('Failed to fetch contracts from DynamoDB:', e);
    }
    return null;
  };

  useEffect(() => {
    fetchRemoteContracts();
  }, []);

  // Standard Resignation & HR Contract Templates Library
  const DEFAULT_CONTRACT_TEMPLATES = [
    {
      TemplateID: 'tmpl-labor',
      Name: '표준 정규직 근로계약서',
      Type: 'LABOR',
      DefaultTitle: '표준 근로계약서 (정규직)',
      DefaultClauses: [
        { title: '수습기간 및 평가', content: '입사일로부터 3개월간 수습기간을 적용하며 급여는 100% 정상 지급한다.' },
        { title: '근태 및 유연근무', content: '소정근로시간은 09:00~18:00이며 부서 협의 하에 시차출퇴근을 적용할 수 있다.' },
        { title: '영업비밀 보호', content: '업무상 취득한 회사의 기술 및 경영 정보는 재직 및 퇴직 후에도 일체 누설하지 아니한다.' }
      ]
    },
    {
      TemplateID: 'tmpl-salary',
      Name: '연간 연봉 계약서',
      Type: 'SALARY',
      DefaultTitle: '연봉 및 포괄산정 임금계약서',
      DefaultClauses: [
        { title: '임금 산정 및 지급', content: '연봉 총액은 12등분하여 매월 25일 임직원 명의 계좌로 입금한다.' },
        { title: '연봉 정보 비밀유지', content: '본 계약에 명시된 연봉 및 수당 내역은 타 임직원 및 외부에 공개하지 아니한다.' }
      ]
    },
    {
      TemplateID: 'tmpl-resignation',
      Name: '표준 사직서 (퇴직원)',
      Type: 'RESIGNATION',
      DefaultTitle: '사직서 (퇴직원 및 사직의사 통보서)',
      DefaultClauses: [
        { title: '사직 의사 및 퇴사 희망일', content: '본인은 개인 사정(또는 일신상의 사유)으로 인하여 위 기재된 퇴사 희망일자로 사직하고자 하오니 재가하여 주시기 바랍니다.' },
        { title: '성실한 업무 인수인계 확약', content: '퇴사일 전까지 담당 업무 및 프로젝트 산출물, 계정 일체를 후임자 또는 부서장에게 성실히 인수인계 완료할 것을 서약합니다.' },
        { title: '금품 청산 및 4대보험 자격상실', content: '퇴직금 및 잔여 연차수당 정산 등 금품청산은 근로기준법에 따라 퇴사일로부터 14일 이내 지급되며 4대보험 자격상실 절차를 확인합니다.' }
      ]
    },
    {
      TemplateID: 'tmpl-resignation-nda',
      Name: '퇴사자 정보보안 및 비밀유지 서약서',
      Type: 'RESIGNATION_NDA',
      DefaultTitle: '퇴직자 영업비밀보호 및 자산반납 서약서',
      DefaultClauses: [
        { title: '회사 정보 및 비품·자산 반납', content: '재직 중 지급받은 사원증, 법인카드, 업무용 PC/노트북 장비 및 모든 소프트웨어 접근 권한을 퇴사 즉시 원상태로 반납합니다.' },
        { title: '영업비밀 및 지식재산 누설 금지', content: '퇴직 후에도 재직 중 지득한 기술상·경영상의 영업비밀, 고객 데이터, 소스코드를 제3자에게 누설하거나 부당하게 사용하지 않습니다.' },
        { title: '경업금지 및 손해배상', content: '퇴사 후 부정경쟁방지법 및 영업비밀보호에 관한 법률을 엄수하며, 위반 시 민·형사상 모든 법적 손해를 배상할 것을 확약합니다.' }
      ]
    },
    {
      TemplateID: 'tmpl-handover',
      Name: '업무 및 자산 인수인계 확인서',
      Type: 'HANDOVER',
      DefaultTitle: '퇴사자 업무 및 사내 자산 인수인계 완료 확인서',
      DefaultClauses: [
        { title: '진행 중 과업 및 산출물 이관', content: '현재 진행 중인 프로젝트 문서, 소스코드 저장소 관리자 권한 및 진행 현황을 후임 인수자에게 100% 전달 완료하였습니다.' },
        { title: '고객사 및 협력사 연락망 인계', content: '담당 고객사 및 외주 파트너사 담당자 연락처와 히스토리를 정리하여 부서에 인계하였습니다.' },
        { title: '사내 공용 계정 및 OTP 이관', content: 'AWS 콘솔, 사내 인프라, SaaS 서비스 마스터/담당 계정 및 2차 인증을 부서장에게 안전하게 이관 완료하였습니다.' }
      ]
    },
    {
      TemplateID: 'tmpl-freelance',
      Name: '프리랜서 / 외주 용역계약서',
      Type: 'FREELANCE',
      DefaultTitle: '전문 용역 도급계약서 (원천징수 3.3% 적용)',
      DefaultClauses: [
        { title: '과업 수행 및 납품', content: '계약기간 내 정해진 규격 및 마일스톤에 따라 최종 산출물을 회사에 납품한다.' },
        { title: '대금 지급 및 원천징수', content: '총 용역대금에서 사업소득세 3.3%를 원천징수한 실지급액을 검수 완료 후 7일 이내 지급한다.' },
        { title: '저작권 및 지식재산권', content: '대금 완납 시 모든 산출물의 지식재산권은 주식회사 클로우플레이크로 완전 귀속된다.' }
      ]
    },
    {
      TemplateID: 'tmpl-nda',
      Name: '영업비밀보호 및 보안서약서 (NDA)',
      Type: 'NDA',
      DefaultTitle: '지식재산권 보호 및 정보보안 준수 서약서',
      DefaultClauses: [
        { title: '비밀정보의 정의', content: '회사의 소스코드, 고객정보, 영업전략, 미공개 데이터 등 일체의 유무형 자산을 포함한다.' },
        { title: '위반 시 책임', content: '비밀유지 의무 위반 시 회사가 입은 모든 유무형 손해에 대해 민형사상 배상 책임을 진다.' }
      ]
    }
  ];

  // Contract Templates Library
  const [contractTemplates, setContractTemplates] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_contract_templates_v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        // Ensure default resignation templates are present
        const existingIds = new Set(parsed.map(t => t.TemplateID));
        const missing = DEFAULT_CONTRACT_TEMPLATES.filter(t => !existingIds.has(t.TemplateID));
        if (missing.length > 0) {
          return [...parsed, ...missing];
        }
        return parsed;
      }
    } catch (e) {
      console.warn('Failed to load contract templates:', e);
    }
    return DEFAULT_CONTRACT_TEMPLATES;
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_contract_templates_v1', JSON.stringify(contractTemplates));
    } catch (e) {
      console.warn('Failed to save contract templates:', e);
    }
  }, [contractTemplates]);

  // Company Corporate Seal & Info Management (Default: clouflake.png)
  const [companySeal, setCompanySeal] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_company_seal_v2') || localStorage.getItem('clou_portal_company_seal_v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (!parsed.imageUrl || parsed.type === 'AUTO_STAMP') {
          parsed.imageUrl = '/clouflake.png';
          parsed.type = 'CUSTOM_IMAGE';
        }
        return parsed;
      }
    } catch (e) {
      console.warn('Failed to load company seal:', e);
    }
    return {
      type: 'CUSTOM_IMAGE',
      companyName: '주식회사 클로우플레이크',
      representativeName: '대표이사 이용관',
      address: '서울시 강서구 양천로 354 옥천빌딩 9층 클로우플레이크 본사',
      sealText: '클로우\n플레이크\n대표이사',
      shape: 'CIRCLE',
      imageUrl: '/clouflake.png'
    };
  });

  const updateCompanySeal = async (sealData) => {
    // Ensure fallback imageUrl
    const normalizedSeal = {
      ...sealData,
      imageUrl: sealData.imageUrl || '/clouflake.png',
      type: sealData.type || 'CUSTOM_IMAGE'
    };
    setCompanySeal(normalizedSeal);
    try {
      localStorage.setItem('clou_portal_company_seal_v2', JSON.stringify(normalizedSeal));
      localStorage.setItem('clou_portal_company_seal_v1', JSON.stringify(normalizedSeal));
      // Immediately sync to AWS DynamoDB system-config
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/users/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user: {
            UserID: 'system-config',
            companySeal: normalizedSeal
          }
        })
      });
      console.log('Successfully synced company seal to DynamoDB system-config.');
    } catch (e) {
      console.warn('Failed to save company seal to DynamoDB:', e);
    }
  };

  // Resignation Standard Policy & Default Clauses State
  const [resignationPolicy, setResignationPolicy] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_resignation_policy_v1');
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  });

  const updateResignationPolicy = async (policyData) => {
    setResignationPolicy(policyData);
    try {
      localStorage.setItem('clou_portal_resignation_policy_v1', JSON.stringify(policyData));
      // Immediately sync to AWS DynamoDB system-config
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/users/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user: {
            UserID: 'system-config',
            resignationPolicy: policyData
          }
        })
      });
      console.log('Successfully synced resignation policy to DynamoDB system-config.');
    } catch (e) {
      console.warn('Failed to save resignation policy to DynamoDB:', e);
    }
  };

  // Kakao Business Partner & Notification Config
  const [kakaoBizConfig, setKakaoBizConfig] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_kakao_biz_config_v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        return {
          ...parsed,
          templates: { ...DEFAULT_KAKAO_TEMPLATES, ...(parsed.templates || {}) }
        };
      }
    } catch (e) {
      console.warn('Failed to load Kakao Biz config:', e);
    }
    return {
      enabled: true,
      provider: 'solapi', // 'solapi' | 'aligo' | 'nhn' | 'direct'
      channelId: '@클로우넥스트',
      senderKey: 'KA01PF2608181332330236V5EAPcb7Tj',
      apiKey: 'NCSIOBYZQ1PPVRVX',
      apiSecret: 'T4I6GP4VM6W9ESFQMIDHJ3CLHS9KVTYJ',
      senderPhone: '010-2821-3711',
      autoNoticeEnabled: true,
      autoMailSummaryEnabled: true,
      failoverSms: true,
      customFooter: '주식회사 클로우플레이크 AX 통합 플랫폼',
      templates: DEFAULT_KAKAO_TEMPLATES
    };
  });

  // Helper: Format Kakao notification template with dynamic substitution
  const formatKakaoTemplate = (templateId, variables = {}) => {
    const userTemplates = kakaoBizConfig?.templates || {};
    const activeTpl = userTemplates[templateId] || DEFAULT_KAKAO_TEMPLATES[templateId] || {};

    let text = activeTpl.templateText || '';
    Object.entries(variables).forEach(([key, val]) => {
      const cleanKey = key.replace(/^#\{|\}$/g, '');
      const regex = new RegExp(`#{${cleanKey}}`, 'g');
      text = text.replace(regex, val !== undefined && val !== null ? String(val) : '');
    });

    let title = activeTpl.title || '[클라우플레이크 알림]';
    Object.entries(variables).forEach(([key, val]) => {
      const cleanKey = key.replace(/^#\{|\}$/g, '');
      const regex = new RegExp(`#{${cleanKey}}`, 'g');
      title = title.replace(regex, val !== undefined && val !== null ? String(val) : '');
    });

    const buttonUrl = activeTpl.buttonUrl ? `${window.location.origin}${activeTpl.buttonUrl}` : window.location.origin;

    return {
      title,
      messageText: text,
      buttonText: activeTpl.buttonText || '확인하기',
      buttonUrl
    };
  };

  const [kakaoDispatchLogs, setKakaoDispatchLogs] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_kakao_dispatch_logs_v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return parsed.map(log => ({
            ...log,
            title: typeof log?.title === 'string' ? log.title : (log?.title?.title || String(log?.title || '')),
            summaryText: typeof log?.summaryText === 'string' 
              ? log.summaryText 
              : (log?.summaryText?.messageText || JSON.stringify(log?.summaryText || ''))
          }));
        }
      }
    } catch (e) {}
    return [
      {
        id: 'klog-01',
        recipientName: '이상희',
        recipientPhone: '010-2101-0009',
        type: 'NOTICE',
        title: '[공지] 클로우플레이크 AX 통합 플랫폼 공식 오픈',
        status: 'SUCCESS',
        sentAt: new Date(Date.now() - 3600000 * 2).toISOString(),
        summaryText: '클로우플레이크 AX 통합 플랫폼이 공식 오픈되었습니다. 대시보드에서 주요 일정을 확인하세요.',
        buttonUrl: window.location.origin + '/#/dashboard'
      },
      {
        id: 'klog-02',
        recipientName: '권진용',
        recipientPhone: '010-0000-0001',
        type: 'MAIL_SUMMARY',
        title: '[AI 요약] Q3 인프라 아키텍처 제안서 검토 요청',
        status: 'SUCCESS',
        sentAt: new Date(Date.now() - 3600000 * 5).toISOString(),
        summaryText: '1. 제안서 초안 전달 및 클라우드 보안 아키텍처 검토 요청\n2. 8/21 18:00까지 피드백 필요',
        buttonUrl: window.location.origin + '/#/webmail'
      }
    ];
  });

  const updateKakaoBizConfig = async (newConfig) => {
    setKakaoBizConfig(newConfig);
    try {
      localStorage.setItem('clou_portal_kakao_biz_config_v1', JSON.stringify(newConfig));
      // Sync to DynamoDB SystemConfigs table
      await saveSystemConfig('kakaoBizConfig', newConfig);
    } catch (e) {
      console.warn('Failed to save Kakao Biz config to DynamoDB:', e);
    }
  };

  const sendKakaoBizMessage = async ({ 
    recipientPhone, 
    recipientName, 
    recipientEmail,
    title, 
    messageText, 
    buttonText = '👉 포털에서 확인하기', 
    buttonUrl = window.location.origin, 
    messageType = 'NOTICE',
    apiKey = kakaoBizConfig?.apiKey,
    apiSecret = kakaoBizConfig?.apiSecret,
    senderKey = kakaoBizConfig?.senderKey,
    senderPhone = kakaoBizConfig?.senderPhone,
    provider = kakaoBizConfig?.provider || 'solapi'
  }) => {
    const cleanMsgText = typeof messageText === 'object' && messageText !== null
      ? (messageText.messageText || JSON.stringify(messageText))
      : String(messageText || '');
    const cleanTitle = typeof title === 'object' && title !== null
      ? (title.title || JSON.stringify(title))
      : String(title || '카카오 알림');

    const nowIso = new Date().toISOString();
    const logItem = {
      id: `klog-${Date.now()}`,
      recipientName: recipientName || '임직원',
      recipientPhone: recipientPhone || '010-0000-0000',
      type: messageType,
      title: cleanTitle,
      status: 'SUCCESS',
      sentAt: nowIso,
      summaryText: cleanMsgText,
      buttonUrl
    };

    // Call backend API /kakao/send
    try {
      const resp = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/kakao/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipientPhone,
          recipientName,
          recipientEmail,
          title: cleanTitle,
          messageText: cleanMsgText,
          buttonText,
          buttonUrl,
          messageType,
          apiKey,
          apiSecret,
          senderKey,
          senderPhone,
          provider
        })
      });

      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data.success) {
        logItem.status = 'FAILED';
        throw new Error(data.error || `[HTTP ${resp.status}] 카카오 비즈니스 게이트웨이 요청 실패`);
      }
      console.log('[Kakao Backend Success Response]', data);
    } catch (apiErr) {
      logItem.status = 'FAILED';
      setKakaoDispatchLogs(prev => {
        const updated = [logItem, ...prev].slice(0, 50);
        try {
          localStorage.setItem('clou_portal_kakao_dispatch_logs_v1', JSON.stringify(updated));
        } catch (e) {}
        return updated;
      });
      throw apiErr;
    }

    setKakaoDispatchLogs(prev => {
      const updated = [logItem, ...prev].slice(0, 50);
      try {
        localStorage.setItem('clou_portal_kakao_dispatch_logs_v1', JSON.stringify(updated));
      } catch (e) {}
      return updated;
    });

    return {
      success: true,
      messageId: logItem.id,
      log: logItem
    };
  };

  // Helper: Build clean responsive HTML email template for contracts matching design
  const buildContractEmailHtml = ({
    badgeText = '전자계약 체결 안내',
    badgeBg = '#ede9fe',
    badgeColor = '#6366f1',
    title = '연봉 및 포괄산정 임금계약서 서명 요청',
    userName = '루시',
    messageHeader = '주식회사 클로우플레이크에서 전자계약서가 발행되었습니다.',
    items = [],
    buttonText = '👉 전자계약서 검토 및 서명하기',
    buttonBg = '#4f46e5',
    buttonUrl = '',
    footerNotice = ''
  }) => {
    const itemsHtml = items.map(item => `
      <div style="margin-bottom: 6px;">• <strong>${item.label}:</strong> ${item.value}</div>
    `).join('');

    return `
      <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; max-width: 620px; margin: 0 auto; padding: 32px; border: 1px solid #e2e8f0; border-radius: 24px; background-color: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.03);">
        <div style="margin-bottom: 12px;">
          <span style="background-color: ${badgeBg}; color: ${badgeColor}; font-size: 12px; font-weight: 700; padding: 6px 12px; border-radius: 8px; display: inline-block;">${badgeText}</span>
        </div>
        <h1 style="color: #0f172a; font-size: 22px; font-weight: 800; margin: 12px 0 16px 0; letter-spacing: -0.5px; line-height: 1.3;">${title}</h1>
        <div style="border-bottom: 2px solid ${badgeColor}; margin-bottom: 24px;"></div>
        
        <p style="color: #334155; font-size: 15px; line-height: 1.7; margin: 0 0 20px 0;">
          안녕하세요, <strong>${userName}</strong>님.<br/>
          ${messageHeader}
        </p>
        
        ${items.length > 0 ? `
        <div style="background-color: #f8fafc; border: 1px solid #f1f5f9; border-radius: 16px; padding: 20px; margin-bottom: 28px; font-size: 14px; color: #1e293b; line-height: 1.8;">
          ${itemsHtml}
        </div>
        ` : ''}
        
        ${buttonUrl ? `
        <div style="text-align: center; margin: 32px 0 24px 0;">
          <a href="${buttonUrl}" target="_blank" rel="noopener noreferrer" style="display: inline-block; background-color: ${buttonBg}; color: #ffffff; padding: 16px 36px; font-size: 15px; font-weight: 800; text-decoration: none; border-radius: 14px; box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35); transition: all 0.2s ease;">
            ${buttonText}
          </a>
        </div>
        <p style="color: #64748b; font-size: 12px; line-height: 1.6; word-break: break-all; margin-top: 20px;">
          링크 바로가기: <a href="${buttonUrl}" target="_blank" rel="noopener noreferrer" style="color: #4f46e5; text-decoration: underline; font-weight: 600;">${buttonUrl}</a>
        </p>
        ` : ''}

        <div style="border-top: 1px solid #f1f5f9; padding-top: 16px; margin-top: 24px; color: #94a3b8; font-size: 12px; line-height: 1.5;">
          ${footerNotice || '※ 본 메일은 주식회사 클로우플레이크 전자계약 시스템에서 자동 발송되었습니다.<br/>문의사항: 인사총무팀 (hr@clouflake.com)'}
        </div>
      </div>
    `;
  };

  // Action: Create and send a new contract
  const createContract = async (contractData) => {
    const newId = `ct-${Date.now()}`;
    const token = `sec-${Math.random().toString(36).substring(2, 10)}${Date.now().toString(36)}`;
    const nowIso = new Date().toISOString();

    const isResig = Boolean(contractData.IsResignation || contractData.ContractType === 'RESIGNATION' || contractData.ContractType === 'RESIGNATION_NDA' || contractData.ContractType === 'HANDOVER');

    let initialApprovalLine = [];
    if (isResig) {
      const deptLeadId = deptLeads[contractData.Department] || 'emp-05';
      const deptLeadUser = users.find(u => u.UserID === deptLeadId) || { Name: '문융희 팀장' };

      initialApprovalLine = [
        {
          Step: 1,
          Role: 'HANDOVER_ASSIGNEE',
          RoleName: '인수인계 확인',
          ApproverID: contractData.HandoverRecipientID || null,
          ApproverName: contractData.HandoverRecipientName || '인수인계 담당자',
          Status: 'PENDING',
          SignedAt: null,
          Comment: ''
        },
        {
          Step: 2,
          Role: 'TEAM_LEADER',
          RoleName: '소속 팀장 승인',
          ApproverID: deptLeadId,
          ApproverName: deptLeadUser.Name || '소속 팀장',
          Status: 'WAITING',
          SignedAt: null,
          Comment: ''
        },
        {
          Step: 3,
          Role: 'HR_MANAGER',
          RoleName: '2차 권한자 (인사담당)',
          ApproverID: 'emp-09',
          ApproverName: '이상희 이사',
          Status: 'WAITING',
          SignedAt: null,
          Comment: ''
        },
        {
          Step: 4,
          Role: 'CEO',
          RoleName: '3차 대표자 (최종 결재)',
          ApproverID: 'emp-10',
          ApproverName: '이용관 대표이사',
          Status: 'WAITING',
          SignedAt: null,
          Comment: ''
        }
      ];
    }

    // Calculate Token Expiration Date (Default: 7 days)
    let tokenExpiresAt = null;
    const expireOption = contractData.ExpireOption || '7_DAYS';
    if (expireOption === '7_DAYS') {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      d.setHours(23, 59, 59, 999);
      tokenExpiresAt = d.toISOString();
    } else if (expireOption === '14_DAYS') {
      const d = new Date();
      d.setDate(d.getDate() + 14);
      d.setHours(23, 59, 59, 999);
      tokenExpiresAt = d.toISOString();
    } else if (expireOption === '30_DAYS') {
      const d = new Date();
      d.setDate(d.getDate() + 30);
      d.setHours(23, 59, 59, 999);
      tokenExpiresAt = d.toISOString();
    } else if (expireOption === 'CUSTOM' && contractData.CustomExpireDate) {
      const d = new Date(contractData.CustomExpireDate);
      d.setHours(23, 59, 59, 999);
      tokenExpiresAt = d.toISOString();
    } else if (expireOption === 'UNLIMITED') {
      tokenExpiresAt = null;
    } else if (contractData.TokenExpiresAt) {
      tokenExpiresAt = contractData.TokenExpiresAt;
    } else {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      d.setHours(23, 59, 59, 999);
      tokenExpiresAt = d.toISOString();
    }

    const newContract = {
      ContractID: newId,
      TargetType: contractData.TargetType || 'EMPLOYEE',
      UserID: contractData.UserID || null,
      UserName: contractData.UserName || '계약자',
      UserEmail: contractData.UserEmail || '',
      UserPhone: contractData.UserPhone || '',
      ResidentRegistrationNumber: contractData.ResidentRegistrationNumber || contractData.residentNumber || '',
      UserAddress: contractData.UserAddress || contractData.userAddress || '',
      Department: contractData.Department || '미지정',
      Position: contractData.Position || '담당',
      ContractType: contractData.ContractType || 'LABOR',
      Title: contractData.Title || '전자계약서',
      Status: 'PENDING',
      PublicToken: token,
      TokenExpiresAt: tokenExpiresAt,
      ContractStartDate: contractData.ContractStartDate || nowIso.slice(0, 10),
      ContractEndDate: contractData.ContractEndDate || '',
      AnnualSalary: Number(contractData.AnnualSalary || 0),
      MonthlySalary: Number(contractData.MonthlySalary || 0),
      SalaryItems: Array.isArray(contractData.SalaryItems) ? contractData.SalaryItems : [],
      SalaryPayday: contractData.SalaryPayday || '매달 말일',
      TotalTaxFree: Number(contractData.TotalTaxFree || 0),
      TotalTaxable: Number(contractData.TotalTaxable || 0),
      TotalAmount: Number(contractData.TotalAmount || contractData.AnnualSalary || 0),
      TaxAmount: Number(contractData.TaxAmount || 0),
      NetAmount: Number(contractData.NetAmount || 0),
      FreelanceItems: Array.isArray(contractData.FreelanceItems) ? contractData.FreelanceItems : [],
      FreelancePaymentDate: contractData.FreelancePaymentDate || '',
      FreelanceTaxMode: contractData.FreelanceTaxMode || 'INCOME_TAX_3_3',
      WorkingHours: contractData.WorkingHours || '09:00 ~ 18:00',
      WorkingPlace: contractData.WorkingPlace || '클로우플레이크 본사',
      JobDescription: contractData.JobDescription || '',
      CustomClauses: Array.isArray(contractData.CustomClauses) ? contractData.CustomClauses : [],
      StandardClauses: Array.isArray(contractData.StandardClauses) ? contractData.StandardClauses : [],
      CompanySeal: contractData.CompanySeal || companySeal,
      CompanySignedAt: isResig ? null : nowIso,
      CompanySigner: isResig ? null : '대표이사 이용관',
      EmployeeSignedAt: isResig ? nowIso : null,
      EmployeeSignatureData: contractData.SignatureDataUrl || contractData.EmployeeSignatureData || null,
      AuditTrail: null,
      CreatedAt: nowIso,
      CreatedBy: currentUser ? `${currentUser.Position || ''} ${currentUser.Name} (${currentUser.UserID})` : '관리자',
      // Resignation specific extensions
      IsResignation: isResig,
      ResignationStatus: isResig ? 'IN_PROGRESS' : null,
      ResignationDate: contractData.ResignationDate || contractData.ContractEndDate || '',
      ResignationReason: contractData.ResignationReason || '',
      HandoverRecipient: contractData.HandoverRecipient || '',
      HandoverRecipientID: contractData.HandoverRecipientID || null,
      HandoverRecipientName: contractData.HandoverRecipientName || '',
      CurrentStep: isResig ? 1 : 0,
      ApprovalLine: isResig ? initialApprovalLine : [],
      WithdrawalHistory: []
    };

    setContracts(prev => [newContract, ...prev]);
    saveRemoteContract(newContract);

    // Send automatic notification email with rich HTML hyperlinks
    if (isResig) {
      // 1. Resignation flow: send approval request to 1st step approver (Handover Assignee / Team Leader)
      const firstStep = initialApprovalLine[0];
      if (firstStep) {
        const approverObj = users.find(u => u.UserID === firstStep.ApproverID || u.Name === firstStep.ApproverName);
        const approverEmail = approverObj?.Email || 'hr@clouflake.com';
        const signUrl = `${window.location.origin}/#/contract/sign?token=${token}&step=1`;
        const emailSubject = `[결재요청] ${newContract.UserName} 사원 사직원 결재 요청 (1/4단계: ${firstStep.RoleName})`;
        
        const emailText = `안녕하세요, ${approverObj?.Name || firstStep.ApproverName}님.\n\n${newContract.UserName} 사원의 사직원(퇴직원) 및 인수인계 결재 요청이 접수되었습니다.\n\n- 신청 사원: ${newContract.UserName} (${newContract.Department} ${newContract.Position || '사원'})\n- 희망 퇴사일: ${newContract.ResignationDate}\n- 결재 단계: 1/4단계 (${firstStep.RoleName})\n- 결재 바로가기: ${signUrl}\n\n감사합니다.\n클로우플레이크 전자결재 시스템`;
        
        const emailHtml = buildContractEmailHtml({
          badgeText: '사직원 전자결재',
          badgeBg: '#ede9fe',
          badgeColor: '#6366f1',
          title: `${newContract.UserName} 사원 사직원 결재 요청`,
          userName: approverObj?.Name || firstStep.ApproverName,
          messageHeader: `${newContract.UserName} 사원의 사직원(퇴직원) 및 인수인계 결재 요청이 접수되었습니다.`,
          items: [
            { label: '신청 사원', value: `${newContract.UserName} (${newContract.Department} ${newContract.Position || '사원'})` },
            { label: '희망 퇴사일', value: `<span style="color:#e11d48;font-weight:bold;">${newContract.ResignationDate}</span>` },
            { label: '결재 단계', value: `1/4단계 (${firstStep.RoleName})` },
            { label: '신청 사유', value: `${newContract.ResignationReason || '개인 사정'}` }
          ],
          buttonText: '👉 1단계 결재 문서 확인 및 승인하기',
          buttonBg: '#4f46e5',
          buttonUrl: signUrl
        });
        
        try {
          await sendEmail(approverEmail, emailSubject, emailText, emailHtml, [], 'hr@clouflake.com');
        } catch (mailErr) {
          console.warn('Resignation 1st step email dispatch error:', mailErr);
        }
      }
    } else if (newContract.UserEmail) {
      // 2. Regular contract flow: send to contract recipient
      try {
        const signUrl = `${window.location.origin}/#/contract/sign?token=${token}`;
        const emailSubject = `[전자계약 서명 요청] '${newContract.Title}' 서명이 요청되었습니다.`;
        const emailText = `안녕하세요, ${newContract.UserName}님.\n\n주식회사 클로우플레이크에서 '${newContract.Title}'이(가) 발행되었습니다.\n\n아래 서명 링크에 접속하시어 계약 내용을 검토하신 후 서명을 완료해 주시기 바랍니다.\n\n- 계약서 제목: ${newContract.Title}\n- 계약 기간: ${newContract.ContractStartDate} ~ ${newContract.ContractEndDate || '정규직(기한 없음)'}\n- 서명 링크: ${signUrl}\n\n감사합니다.\n주식회사 클로우플레이크 인사총무팀`;
        const emailHtml = buildContractEmailHtml({
          badgeText: '전자계약 체결 안내',
          badgeBg: '#ede9fe',
          badgeColor: '#6366f1',
          title: `${newContract.Title} 서명 요청`,
          userName: newContract.UserName,
          messageHeader: '주식회사 클로우플레이크에서 전자계약서가 발행되었습니다.',
          items: [
            { label: '계약서 제목', value: newContract.Title },
            { label: '계약 기간', value: `${newContract.ContractStartDate} ~ ${newContract.ContractEndDate || '정규직(기한 없음)'}` },
            { label: '대상 부서', value: `${newContract.Department} ${newContract.Position || ''}` }
          ],
          buttonText: '👉 전자계약서 검토 및 서명하기',
          buttonBg: '#4f46e5',
          buttonUrl: signUrl
        });
        await sendEmail(newContract.UserEmail, emailSubject, emailText, emailHtml, [], 'hr@clouflake.com');
      } catch (mailErr) {
        console.warn('Contract dispatch notification email error:', mailErr);
      }
    }

    return newContract;
  };

  // Action: Multi-step Approve Resignation Step
  const approveResignationStep = async (contractId, approverUser, comment = '') => {
    const nowIso = new Date().toISOString();
    
    // Find target contract from existing contracts or localStorage
    const savedContracts = (() => {
      try {
        const raw = localStorage.getItem('clou_portal_contracts_v2');
        return raw ? JSON.parse(raw) : contracts;
      } catch (e) {
        return contracts;
      }
    })();

    const targetContract = savedContracts.find(c => c.ContractID === contractId || c.PublicToken === contractId) || contracts.find(c => c.ContractID === contractId || c.PublicToken === contractId);

    if (!targetContract) {
      console.warn('Target contract not found for approveResignationStep:', contractId);
      return false;
    }

    // Abort if already withdrawn or rejected
    if (targetContract.Status === 'WITHDRAWN' || targetContract.ResignationStatus === 'WITHDRAWN') {
      console.warn('Cannot approve a withdrawn resignation:', contractId);
      return false;
    }

    if (targetContract.Status === 'REJECTED' || targetContract.ResignationStatus === 'REJECTED') {
      console.warn('Cannot approve a rejected resignation:', contractId);
      return false;
    }

    const currentStepNum = targetContract.CurrentStep || 1;
    const updatedLine = (targetContract.ApprovalLine || []).map(step => {
      if (step.Step === currentStepNum) {
        return {
          ...step,
          Status: 'APPROVED',
          SignedAt: nowIso,
          Comment: comment,
          ActualApprover: approverUser?.Name || step.ApproverName,
          ActualApproverID: approverUser?.UserID || step.ApproverID
        };
      }
      if (step.Step === currentStepNum + 1) {
        return {
          ...step,
          Status: 'PENDING'
        };
      }
      return step;
    });

    const isFinalStep = currentStepNum >= 4;
    const nextStepNum = isFinalStep ? currentStepNum : currentStepNum + 1;

    const updatedContract = {
      ...targetContract,
      CurrentStep: nextStepNum,
      ApprovalLine: updatedLine,
      Status: isFinalStep ? 'APPROVED' : 'PENDING',
      ResignationStatus: isFinalStep ? 'APPROVED' : 'IN_PROGRESS',
      CompanySignedAt: isFinalStep ? nowIso : targetContract.CompanySignedAt,
      CompanySigner: isFinalStep ? (approverUser?.Name || '대표이사 이용관') : targetContract.CompanySigner
    };

    // 1. Update React State
    setContracts(prev => prev.map(c => c.ContractID === updatedContract.ContractID ? updatedContract : c));

    // 2. Persist to localStorage immediately
    try {
      const updatedList = savedContracts.map(c => c.ContractID === updatedContract.ContractID ? updatedContract : c);
      if (!updatedList.some(c => c.ContractID === updatedContract.ContractID)) {
        updatedList.unshift(updatedContract);
      }
      localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(updatedList));
    } catch (e) {
      console.warn('Failed to save to localStorage:', e);
    }

    // 3. Persist to AWS DynamoDB
    await saveRemoteContract(updatedContract);

    // 4. Email Dispatch on Approval with Rich HTML Links
    try {
      if (!isFinalStep) {
        // Send to next step approver
        const nextStepObj = updatedContract.ApprovalLine?.find(s => s.Step === nextStepNum);
        if (nextStepObj) {
          const nextApproverUser = users.find(u => u.UserID === nextStepObj.ApproverID || u.Name === nextStepObj.ApproverName);
          const nextEmail = nextApproverUser?.Email || 'hr@clouflake.com';
          const signUrl = `${window.location.origin}/#/contract/sign?token=${updatedContract.PublicToken}&step=${nextStepNum}`;
          const nextSubject = `[결재요청] ${updatedContract.UserName} 사원 사직원 결재 요청 (${nextStepNum}/4단계: ${nextStepObj.RoleName})`;
          const nextText = `안녕하세요, ${nextApproverUser?.Name || nextStepObj.ApproverName}님.\n\n${updatedContract.UserName} 사원의 사직원(퇴직원) 결재가 ${currentStepNum}단계를 통과하여 ${nextStepNum}단계(${nextStepObj.RoleName}) 결재 요청으로 전달되었습니다.\n\n- 신청 사원: ${updatedContract.UserName} (${updatedContract.Department})\n- 희망 퇴사일: ${updatedContract.ResignationDate}\n- 결재 단계: ${nextStepNum}/4단계 (${nextStepObj.RoleName})\n- 이전 승인자 의견: ${comment || '승인 완료'}\n- 결재 바로가기: ${signUrl}\n\n감사합니다.\n클로우플레이크 결재 시스템`;
          
          const nextHtml = buildContractEmailHtml({
            badgeText: `사직원 전자결재 (${nextStepNum}단계)`,
            badgeBg: '#ede9fe',
            badgeColor: '#6366f1',
            title: `${nextStepNum}단계 결재 승인 요청 (${nextStepObj.RoleName})`,
            userName: nextApproverUser?.Name || nextStepObj.ApproverName,
            messageHeader: `<strong>${updatedContract.UserName}</strong> 사원의 사직원 결재가 ${currentStepNum}단계를 통과하여 다음 결재권자에게 전달되었습니다.`,
            items: [
              { label: '신청 사원', value: `${updatedContract.UserName} (${updatedContract.Department})` },
              { label: '희망 퇴사일', value: `<span style="color:#e11d48;font-weight:bold;">${updatedContract.ResignationDate}</span>` },
              { label: '결재 단계', value: `${nextStepNum}/4단계 (${nextStepObj.RoleName})` },
              { label: '이전 단계 결재의견', value: `<span style="color:#059669;font-weight:bold;">${comment || '승인 완료'}</span>` }
            ],
            buttonText: `👉 ${nextStepNum}단계 결재 문서 확인 및 승인하기`,
            buttonBg: '#4f46e5',
            buttonUrl: signUrl
          });
          await sendEmail(nextEmail, nextSubject, nextText, nextHtml, [], 'hr@clouflake.com');

          // KakaoTalk Notification to Next Approver
          if (nextApproverUser?.Phone && kakaoBizConfig?.enabled) {
            sendKakaoBizMessage({
              recipientPhone: nextApproverUser.Phone,
              recipientName: nextApproverUser.Name || nextStepObj.ApproverName,
              title: `[결재요청] ${updatedContract.UserName} 사직원 (${nextStepNum}단계: ${nextStepObj.RoleName})`,
              messageText: `신청 사원: ${updatedContract.UserName} (${updatedContract.Department})\n희망 퇴사일: ${updatedContract.ResignationDate}\n결재 단계: ${nextStepNum}/4단계 (${nextStepObj.RoleName})\n\n아래 링크를 눌러 사직원 서류를 검토 후 서명해 주세요.`,
              buttonText: '결재 바로가기',
              buttonUrl: signUrl,
              messageType: 'APPROVAL'
            });
          }
        }
      } else {
        // Final Step Approved: Notify applicant with rich HTML
        if (updatedContract.UserEmail) {
          const compSubject = `[결재완료] ${updatedContract.UserName}님, 사직원(퇴직원) 결재가 최종 승인되었습니다.`;
          const compText = `안녕하세요, ${updatedContract.UserName}님.\n\n신청하신 사직원(퇴직원)이 대표이사 최종 승인(4/4단계)까지 모두 완료되었습니다.\n\n- 신청 사원: ${updatedContract.UserName}\n- 최종 퇴사일: ${updatedContract.ResignationDate}\n- 결재 상태: 최종 승인 완료\n\n전자계약 보관함에서 승인된 전문 문서를 상시 확인 및 인쇄하실 수 있습니다.\n\n주식회사 클로우플레이크 인사총무팀`;
          const compHtml = buildContractEmailHtml({
            badgeText: '사직원 최종 승인 완료',
            badgeBg: '#dcfce7',
            badgeColor: '#15803d',
            title: '사직원 최종 결재 승인 안내',
            userName: updatedContract.UserName,
            messageHeader: '제출하신 사직원(퇴직원)이 4단계 승인선을 거쳐 대표이사 최종 승인 완료되었습니다.',
            items: [
              { label: '신청 사원', value: `${updatedContract.UserName} (${updatedContract.Department})` },
              { label: '최종 퇴사일', value: `<span style="color:#e11d48;font-weight:bold;">${updatedContract.ResignationDate}</span>` },
              { label: '결재 상태', value: '4/4단계 대표이사 최종 승인 완료' }
            ],
            buttonText: '👉 전자계약 보관함에서 승인 문서 확인하기',
            buttonBg: '#059669',
            buttonUrl: `${window.location.origin}/#/contract`
          });
          await sendEmail(updatedContract.UserEmail, compSubject, compText, compHtml, [], 'hr@clouflake.com');

          // KakaoTalk Notification to Applicant
          const applicantUser = users.find(u => u.UserID === updatedContract.UserID || u.Name === updatedContract.UserName);
          if (applicantUser?.Phone && kakaoBizConfig?.enabled) {
            sendKakaoBizMessage({
              recipientPhone: applicantUser.Phone,
              recipientName: updatedContract.UserName,
              title: `[최종승인완료] 사직원 결재가 대표이사 최종 승인되었습니다`,
              messageText: `신청하신 사직원이 대표이사 최종 승인(4/4단계) 완료되었습니다.\n희망 퇴사일: ${updatedContract.ResignationDate}\n전자계약 관리 메뉴에서 승인 완료된 문서를 확인하실 수 있습니다.`,
              buttonText: '계약 보관함',
              buttonUrl: `${window.location.origin}/#/contract`,
              messageType: 'APPROVAL'
            });
          }
        }
      }
    } catch (mailErr) {
      console.warn('Approval email forwarding error:', mailErr);
    }

    return updatedContract || true;
  };

  // Action: Reject Resignation Step
  const rejectResignationStep = async (contractId, approverUser, reason = '') => {
    const nowIso = new Date().toISOString();
    let updatedContract = null;

    setContracts(prev => prev.map(c => {
      if (c.ContractID === contractId) {
        const currentStepNum = c.CurrentStep || 1;
        const updatedLine = (c.ApprovalLine || []).map(step => {
          if (step.Step === currentStepNum) {
            return {
              ...step,
              Status: 'REJECTED',
              SignedAt: nowIso,
              Comment: reason,
              ActualApprover: approverUser?.Name || step.ApproverName
            };
          }
          return step;
        });

        updatedContract = {
          ...c,
          Status: 'REJECTED',
          ResignationStatus: 'REJECTED',
          ApprovalLine: updatedLine,
          RejectedAt: nowIso,
          RejectReason: reason,
          RejectedBy: approverUser?.Name
        };
        return updatedContract;
      }
      return c;
    }));

    if (updatedContract) {
      saveRemoteContract(updatedContract);

      // Notify applicant about rejection with HTML
      if (updatedContract.UserEmail) {
        try {
          const rejSubject = `[결재반려] ${updatedContract.UserName}님, 사직원 결재가 반려되었습니다.`;
          const rejText = `안녕하세요, ${updatedContract.UserName}님.\n\n신청하신 사직원 결재가 아래 사유로 반려되었습니다.\n\n- 반려자: ${approverUser?.Name || '결재권자'}\n- 반려 사유: ${reason || '상세 사유 미기재'}\n\n상세 내용은 사내 포털 전자계약 메뉴에서 확인해 주시기 바랍니다.\n\n주식회사 클로우플레이크 인사총무팀`;
          const rejHtml = buildContractEmailHtml({
            badgeText: '사직원 결재 반려',
            badgeBg: '#fef3c7',
            badgeColor: '#d97706',
            title: '사직원 결재가 반려되었습니다',
            userName: updatedContract.UserName,
            messageHeader: '신청하신 사직원 결재 진행 중 아래 사유로 반려 처리되었습니다.',
            items: [
              { label: '반려 결재자', value: approverUser?.Name || '결재권자' },
              { label: '반려 사유', value: `<span style="color:#e11d48;font-weight:bold;">${reason || '상세 사유 미기재'}</span>` }
            ],
            buttonText: '👉 사내 포털에서 상세 내역 확인하기',
            buttonBg: '#d97706',
            buttonUrl: `${window.location.origin}/#/contract`
          });
          await sendEmail(updatedContract.UserEmail, rejSubject, rejText, rejHtml, [], 'hr@clouflake.com');
        } catch (mailErr) {
          console.warn('Rejection email notify error:', mailErr);
        }
      }
    }
    return true;
  };

  // Action: Withdraw Resignation & Save Counseling Log
  const withdrawResignation = async (contractId, actorUser, withdrawalData) => {
    const nowIso = new Date().toISOString();
    
    // Find target contract from existing contracts or localStorage
    const savedContracts = (() => {
      try {
        const raw = localStorage.getItem('clou_portal_contracts_v2');
        return raw ? JSON.parse(raw) : contracts;
      } catch (e) {
        return contracts;
      }
    })();

    const targetContract = savedContracts.find(c => c.ContractID === contractId || c.PublicToken === contractId) || contracts.find(c => c.ContractID === contractId || c.PublicToken === contractId);

    if (!targetContract) {
      console.warn('Target contract not found for withdrawResignation:', contractId);
      return false;
    }

    const newHistory = [
      ...(targetContract.WithdrawalHistory || []),
      {
        WithdrawalID: `wth-${Date.now()}`,
        ...withdrawalData,
        WithdrawnAt: nowIso,
        ActorID: actorUser?.UserID,
        ActorName: actorUser?.Name
      }
    ];

    const updatedContract = {
      ...targetContract,
      Status: 'WITHDRAWN',
      ResignationStatus: 'WITHDRAWN',
      WithdrawnAt: nowIso,
      WithdrawalReason: withdrawalData.reason || '회사 잔류 결정',
      WithdrawalHistory: newHistory
    };

    // 1. Update React State
    setContracts(prev => prev.map(c => c.ContractID === updatedContract.ContractID ? updatedContract : c));

    // 2. Persist to localStorage immediately
    try {
      const updatedList = savedContracts.map(c => c.ContractID === updatedContract.ContractID ? updatedContract : c);
      if (!updatedList.some(c => c.ContractID === updatedContract.ContractID)) {
        updatedList.unshift(updatedContract);
      }
      localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(updatedList));
    } catch (e) {
      console.warn('Failed to save to localStorage:', e);
    }

    // 3. Persist to AWS DynamoDB
    await saveRemoteContract(updatedContract);

    // 4. Send Withdrawal Notification Email to Applicant & Approvers
    try {
      if (updatedContract.UserEmail) {
        const wthSubject = `[퇴사 취하 완료] ${updatedContract.UserName}님의 사직원이 정상 취하(철회) 처리되었습니다.`;
        const wthText = `안녕하세요, ${updatedContract.UserName}님.\n\n신청하셨던 사직원(퇴직원)이 신청인의 요청에 따라 정상 취하(철회) 완료되었습니다.\n\n- 신청 사원: ${updatedContract.UserName} (${updatedContract.Department})\n- 처리 상태: 퇴사 취하 완료 (회사 잔류 및 결재 프로세스 완전 종료)\n- 취하 일시: ${new Date(nowIso).toLocaleString('ko-KR')}\n- 취하 사유: ${withdrawalData.reason || '회사 잔류 결정'}\n\n상신되었던 사직원은 공식 취하되어 더 이상 결재 승인이나 퇴사 처리가 진행되지 않습니다.\n\n주식회사 클로우플레이크 인사총무팀`;
        const wthHtml = buildContractEmailHtml({
          badgeText: '사직원 취하 완료',
          badgeBg: '#f1f5f9',
          badgeColor: '#475569',
          title: '사직원 퇴사 취하(철회) 완료 안내',
          userName: updatedContract.UserName,
          messageHeader: '제출하셨던 사직원(퇴직원)이 공식 취하(철회) 처리되어 결재 프로세스가 완전히 종료되었습니다.',
          items: [
            { label: '신청 사원', value: `${updatedContract.UserName} (${updatedContract.Department})` },
            { label: '처리 상태', value: '<span style="color:#059669;font-weight:bold;">퇴사 취하 완료 (회사 잔류 결정)</span>' },
            { label: '취하 일시', value: new Date(nowIso).toLocaleString('ko-KR') },
            { label: '취하 사유', value: withdrawalData.reason || '회사 잔류 결정' }
          ],
          buttonText: '👉 전자계약 보관함 바로가기',
          buttonBg: '#475569',
          buttonUrl: `${window.location.origin}/#/contract`
        });
        await sendEmail(updatedContract.UserEmail, wthSubject, wthText, wthHtml, [], 'hr@clouflake.com');
      }
    } catch (e) {}

    return updatedContract || true;
  };

  // Action: Sign a contract (Employee or Freelancer)
  const signContract = async (contractId, signatureData, auditDetails = {}) => {
    // 1. Idempotency Check: Prevent duplicate processing and duplicate email dispatches
    const savedContracts = (() => {
      try {
        const raw = localStorage.getItem('clou_portal_contracts_v2');
        return raw ? JSON.parse(raw) : contracts;
      } catch (e) {
        return contracts;
      }
    })();

    const existing = savedContracts.find(c => c.ContractID === contractId || c.PublicToken === contractId) 
      || contracts.find(c => c.ContractID === contractId || c.PublicToken === contractId);

    if (existing && (existing.Status === 'SIGNED' || existing.Status === 'APPROVED' || Boolean(existing.EmployeeSignedAt))) {
      console.warn('Contract already signed, skipping duplicate processing and email dispatch:', contractId);
      return true;
    }

    const nowIso = new Date().toISOString();
    const fifteenDaysLater = new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString();

    let targetContract = null;

    // 2. Synchronously update React State
    setContracts(prev => prev.map(c => {
      if (c.ContractID === contractId || c.PublicToken === contractId) {
        const isFreelancer = c.TargetType === 'FREELANCER';
        
        // Compute SHA-256 digital hash simulation
        const rawContent = `${c.ContractID}|${c.Title}|${c.UserName}|${c.TotalAmount || c.AnnualSalary}|${nowIso}|${signatureData.slice(0, 50)}`;
        let hash = 'sha256-';
        for (let i = 0; i < rawContent.length; i++) {
          hash += rawContent.charCodeAt(i).toString(16);
        }
        hash = hash.substring(0, 48);

        const residentNumber = auditDetails.ResidentRegistrationNumber || auditDetails.residentNumber || c.ResidentRegistrationNumber || '';
        const userAddress = auditDetails.UserAddress || auditDetails.userAddress || c.UserAddress || '';

        targetContract = {
          ...c,
          Status: 'SIGNED',
          ResidentRegistrationNumber: residentNumber,
          UserAddress: userAddress,
          EmployeeSignedAt: nowIso,
          EmployeeSignatureData: signatureData,
          CompanySeal: (c.CompanySeal && c.CompanySeal.imageUrl) ? c.CompanySeal : { ...(c.CompanySeal || companySeal), imageUrl: '/clouflake.png', type: 'CUSTOM_IMAGE' },
          TokenExpiresAt: isFreelancer ? fifteenDaysLater : null, // Freelancers expire in 15 days, company staff never expire
          AuditTrail: {
            IpAddress: auditDetails.IpAddress || '121.134.88.12',
            UserAgent: auditDetails.UserAgent || navigator.userAgent,
            SignedAt: nowIso,
            Sha256Hash: hash,
            SignerName: c.UserName,
            HasResidentNumber: Boolean(residentNumber),
            HasAddress: Boolean(userAddress)
          }
        };
        return targetContract;
      }
      return c;
    }));

    if (targetContract) {
      // 3. Immediately persist to localStorage across all keys so F5 / refresh keeps Status: 'SIGNED'!
      try {
        const nextList = savedContracts.map(c => (c.ContractID === targetContract.ContractID || c.PublicToken === targetContract.PublicToken) ? targetContract : c);
        if (!nextList.some(c => c.ContractID === targetContract.ContractID)) {
          nextList.unshift(targetContract);
        }
        localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(nextList));
        localStorage.setItem('clou_contracts_v2', JSON.stringify(nextList));
      } catch (e) {
        console.warn('LocalStorage save error in signContract:', e);
      }

      // 4. Save to AWS DynamoDB remotely
      await saveRemoteContract(targetContract);
      await fetchRemoteContracts();

      // 5. Send confirmation email ONCE
      if (targetContract.UserEmail) {
        try {
          const compSubject = `[체결 완료] '${targetContract.Title}' 전자계약이 체결되었습니다.`;
          const compBody = `안녕하세요, ${targetContract.UserName}님.\n\n귀하와 주식회사 클로우플레이크 간의 '${targetContract.Title}' 전자계약이 양측 서명을 모두 마치고 정상적으로 체결 완료되었습니다.\n\n체결된 계약서는 포털 '내 계약서' 메뉴 또는 전용 링크에서 언제든지 열람 및 PDF 다운로드가 가능합니다.\n\n- 체결 일시: ${new Date().toLocaleString('ko-KR')}\n- 인증 코드: DOC-SEC-${targetContract.ContractID}\n\n감사합니다.`;
          const viewUrl = `${window.location.origin}/#/contract/sign?token=${targetContract.PublicToken}`;
          const compHtml = buildContractEmailHtml({
            badgeText: '전자계약 체결 완료',
            badgeBg: '#dcfce7',
            badgeColor: '#15803d',
            title: `${targetContract.Title} 체결 완료 안내`,
            userName: targetContract.UserName,
            messageHeader: '귀하와 주식회사 클로우플레이크 간의 전자계약이 양측 서명을 마치고 최종 체결 완료되었습니다.',
            items: [
              { label: '계약서 제목', value: targetContract.Title },
              { label: '체결 일시', value: new Date().toLocaleString('ko-KR') },
              { label: '계약 대상자', value: `${targetContract.UserName} (${targetContract.Department} ${targetContract.Position || ''})` },
              { label: '문서 인증 코드', value: `DOC-SEC-${targetContract.ContractID}` }
            ],
            buttonText: '📄 체결 계약서 전문 열람 및 PDF 다운로드',
            buttonBg: '#059669',
            buttonUrl: viewUrl
          });
          
          await sendEmail(
            targetContract.UserEmail,
            compSubject,
            compBody,
            compHtml,
            [],
            'hr@clouflake.com',
            '' // No CC to prevent duplicate alias dispatches
          );
        } catch (err) {
          console.warn('Sign confirmation email error:', err);
        }
      }
    }

    return true;
  };

  // Requirement 1: Request Mutual Contract Deletion (상호 삭제 합의 요청)
  const requestContractDeletion = async (contractId, reason = '') => {
    const contract = contracts.find(c => c.ContractID === contractId);
    if (!contract) return false;

    const requesterId = currentUser?.UserID || 'ADMIN';
    const requesterName = currentUser?.Name || '담당자';

    const updated = {
      ...contract,
      Status: 'DELETE_REQUESTED',
      DeleteRequestedBy: requesterId,
      DeleteRequestedByName: requesterName,
      DeleteRequestedAt: new Date().toISOString(),
      DeleteRequestedReason: reason.trim()
    };

    setContracts(prev => {
      const next = prev.map(c => c.ContractID === contractId ? updated : c);
      try {
        localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(next));
      } catch (e) {}
      return next;
    });

    await saveRemoteContract(updated);
    await fetchRemoteContracts();

    // Send notification email to counterparty
    try {
      const targetEmail = (contract.UserEmail && contract.UserEmail !== currentUser?.Email) 
        ? contract.UserEmail 
        : 'hr@clouflake.com';
      const targetName = (contract.UserName && contract.UserEmail !== currentUser?.Email)
        ? contract.UserName
        : '담당자';
      const actionUrl = `${window.location.origin}/#/contract/sign?token=${contract.PublicToken}`;
      const subject = `[계약 파기 합의 요청] '${contract.Title}' 계약서 삭제 동의가 요청되었습니다.`;
      const body = `안녕하세요.\n\n주식회사 클로우플레이크 전자계약 시스템 안내입니다.\n\n상대 당사자(${requesterName})가 체결된 '${contract.Title}' 계약서의 삭제/파기 합의를 요청했습니다.\n\n- 사유: ${reason.trim() || '상호 계약 해지 및 삭제 요청'}\n- 신청일시: ${new Date().toLocaleString('ko-KR')}\n\n전자계약 메뉴 또는 서명 링크에서 [삭제 합의 수락] 또는 [거절]을 선택해 주시기 바랍니다.\n\n감사합니다.`;
      const html = buildContractEmailHtml({
        badgeText: '계약 파기 합의 요청',
        badgeBg: '#ffe4e6',
        badgeColor: '#e11d48',
        title: `${contract.Title} 파기(삭제) 동의 요청`,
        userName: targetName,
        messageHeader: `상대 당사자(<strong>${requesterName}</strong>)가 체결된 전자계약서의 파기(삭제) 합의를 요청하였습니다. 아래 버튼을 클릭하여 동의 또는 거절을 진행해 주시기 바랍니다.`,
        items: [
          { label: '계약서 제목', value: contract.Title },
          { label: '파기 요청자', value: requesterName },
          { label: '파기 사유', value: `<span style="color:#e11d48;font-weight:bold;">${reason.trim() || '상호 계약 해지 및 수정 삭제 요청'}</span>` },
          { label: '신청 일시', value: new Date().toLocaleString('ko-KR') }
        ],
        buttonText: '🚨 파기 동의 및 거절 진행하기',
        buttonBg: '#e11d48',
        buttonUrl: actionUrl
      });
      await sendEmail(targetEmail, subject, body, html, [], 'hr@clouflake.com');
    } catch (err) {}

    return true;
  };

  // Requirement 1: Accept Mutual Contract Deletion (상호 삭제 합의 동의 및 영구 삭제)
  const acceptContractDeletion = async (contractId) => {
    const contract = contracts.find(c => c.ContractID === contractId);
    if (contract && contract.UserEmail) {
      try {
        const subject = `[계약 파기 완료] '${contract.Title}' 전자계약이 영구 삭제되었습니다.`;
        const body = `안녕하세요.\n\n양측 삭제 합의에 따라 '${contract.Title}' 전자계약서가 시스템에서 영구 파기(삭제) 완료되었습니다.`;
        const html = buildContractEmailHtml({
          badgeText: '계약 파기 완료',
          badgeBg: '#f1f5f9',
          badgeColor: '#475569',
          title: `${contract.Title} 영구 파기(삭제) 완료`,
          userName: contract.UserName,
          messageHeader: '양측 파기 합의에 따라 본 전자계약서가 시스템에서 완전 영구 삭제(파기) 처리되었습니다.',
          items: [
            { label: '계약서 제목', value: contract.Title },
            { label: '파기 완료일시', value: new Date().toLocaleString('ko-KR') }
          ],
          buttonText: '',
          buttonUrl: ''
        });
        await sendEmail(contract.UserEmail, subject, body, html, [], 'hr@clouflake.com');
      } catch (e) {}
    }
    return await deleteContract(contractId);
  };

  // Requirement 1: Reject Mutual Contract Deletion (상호 삭제 합의 거절 - 계약 유지)
  const rejectContractDeletion = async (contractId) => {
    const contract = contracts.find(c => c.ContractID === contractId);
    if (!contract) return false;

    const updated = {
      ...contract,
      Status: 'SIGNED',
      DeleteRequestedBy: null,
      DeleteRequestedByName: null,
      DeleteRequestedAt: null,
      DeleteRequestedReason: null
    };

    setContracts(prev => {
      const next = prev.map(c => c.ContractID === contractId ? updated : c);
      try {
        localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(next));
      } catch (e) {}
      return next;
    });

    await saveRemoteContract(updated);
    await fetchRemoteContracts();

    // Send rejection notice email
    if (contract.UserEmail) {
      try {
        const subject = `[파기 요청 거절] '${contract.Title}' 계약 파기 요청이 거절되어 유지됩니다.`;
        const body = `안녕하세요.\n\n'${contract.Title}' 계약서의 파기 합의 요청이 상대방에 의해 거절되었습니다. 해당 계약은 체결 완료 상태로 지속 유지됩니다.`;
        const html = buildContractEmailHtml({
          badgeText: '파기 요청 거절',
          badgeBg: '#fef3c7',
          badgeColor: '#d97706',
          title: `${contract.Title} 파기 요청 거절 (계약 유지)`,
          userName: contract.UserName,
          messageHeader: '상대방이 계약 파기 요청을 거절하였습니다. 본 전자계약은 기존 체결 완료 상태로 정상 유지됩니다.',
          items: [
            { label: '계약서 제목', value: contract.Title },
            { label: '상태', value: '<span style="color:#059669;font-weight:bold;">체결 완료 (유지)</span>' }
          ],
          buttonText: '📄 계약서 열람하기',
          buttonBg: '#4f46e5',
          buttonUrl: `${window.location.origin}/#/contract/sign?token=${contract.PublicToken}`
        });
        await sendEmail(contract.UserEmail, subject, body, html, [], 'hr@clouflake.com');
      } catch (e) {}
    }

    return true;
  };

  // Action: Delete a contract (Full Cloud Sync across all sessions)
  const deleteContract = async (contractId) => {
    // 1. Immediate state update and localStorage sync
    setContracts(prev => {
      const filtered = prev.filter(c => c.ContractID !== contractId);
      try {
        localStorage.setItem('clou_portal_contracts_v2', JSON.stringify(filtered));
      } catch (e) {}
      return filtered;
    });

    // 2. Delete item from AWS DynamoDB Contracts table
    await deleteRemoteContract(contractId);

    // 3. Re-fetch from DynamoDB to ensure all active views are in sync
    await fetchRemoteContracts();
    return true;
  };

  // Action: Send a reminder email for pending contract
  const sendContractReminder = async (contractId) => {
    const contract = contracts.find(c => c.ContractID === contractId);
    if (!contract || !contract.UserEmail) return false;

    try {
      const subject = `[서명 독려 안내] '${contract.Title}' 전자계약 서명이 아직 완료되지 않았습니다.`;
      const body = `안녕하세요, ${contract.UserName}님.\n\n주식회사 클로우플레이크에서 발송된 '${contract.Title}'의 서명이 대기 중입니다.\n\n원활한 인사 및 용역 정산 처리를 위해 빠른 시일 내에 서명을 완료해 주시기 바랍니다.\n\n- 서명 링크: ${window.location.origin}/#/contract/sign?token=${contract.PublicToken}\n\n감사합니다.`;
      const signUrl = `${window.location.origin}/#/contract/sign?token=${contract.PublicToken}`;
      const html = buildContractEmailHtml({
        badgeText: '서명 독려 안내',
        badgeBg: '#fef3c7',
        badgeColor: '#d97706',
        title: `${contract.Title} 서명 독려 안내`,
        userName: contract.UserName,
        messageHeader: '서명이 아직 완료되지 않은 전자계약서가 대기 중입니다. 빠른 시일 내에 서명을 완료해 주시기 바랍니다.',
        items: [
          { label: '계약서 제목', value: contract.Title },
          { label: '수신인', value: contract.UserName },
          { label: '발행일', value: contract.CreatedAt?.slice(0, 10) || '' }
        ],
        buttonText: '👉 지금 서명 진행하기',
        buttonBg: '#d97706',
        buttonUrl: signUrl
      });

      await sendEmail(
        contract.UserEmail,
        subject,
        body,
        html,
        [],
        'hr@clouflake.com'
      );
      return true;
    } catch (e) {
      console.warn('Send reminder error:', e);
      return false;
    }
  };

  // Extend Contract Token Expiration Date (+days)
  const extendContractExpiration = async (contractId, days = 7) => {
    let updatedExpiresAt = null;
    setContracts(prev => prev.map(c => {
      if (c.ContractID === contractId || c.PublicToken === contractId) {
        const base = (c.TokenExpiresAt && new Date(c.TokenExpiresAt) > new Date())
          ? new Date(c.TokenExpiresAt)
          : new Date();
        base.setDate(base.getDate() + days);
        base.setHours(23, 59, 59, 999);
        updatedExpiresAt = base.toISOString();
        return {
          ...c,
          TokenExpiresAt: updatedExpiresAt
        };
      }
      return c;
    }));

    try {
      const saved = localStorage.getItem('clou_contracts_v2');
      if (saved) {
        const parsed = JSON.parse(saved);
        const updated = parsed.map(c => {
          if (c.ContractID === contractId || c.PublicToken === contractId) {
            return { ...c, TokenExpiresAt: updatedExpiresAt };
          }
          return c;
        });
        localStorage.setItem('clou_contracts_v2', JSON.stringify(updated));
      }
    } catch (e) {
      console.warn('LocalStorage contract update error:', e);
    }

    try {
      if (window.lambdaApi) {
        await window.lambdaApi.updateContract(contractId, { TokenExpiresAt: updatedExpiresAt });
      }
    } catch (e) {
      console.warn('Lambda API updateContract error:', e);
    }

    return updatedExpiresAt;
  };

  // Action: Save custom contract template
  const saveContractTemplate = (templateData) => {
    const newTmpl = {
      TemplateID: `tmpl-custom-${Date.now()}`,
      Name: templateData.Name || '사용자 정의 계약 서식',
      Type: templateData.Type || 'CUSTOM',
      DefaultTitle: templateData.DefaultTitle || templateData.Name,
      DefaultClauses: Array.isArray(templateData.DefaultClauses) ? templateData.DefaultClauses : [],
      DefaultStandardClauses: Array.isArray(templateData.DefaultStandardClauses) ? templateData.DefaultStandardClauses : []
    };
    setContractTemplates(prev => [newTmpl, ...prev]);
    return newTmpl;
  };

  // 5-1. Multiple Secondary Approvers (2차 승인자 다중 지정 - Requirement 4)
  const [secondaryApproverIds, setSecondaryApproverIds] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_secondary_approver_ids_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      }
    } catch (e) {
      console.warn('Failed to load secondary approvers:', e);
    }
    return ['emp-09'];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_secondary_approver_ids_v3', JSON.stringify(secondaryApproverIds));
    } catch (e) {
      console.warn('Failed to save secondary approvers:', e);
    }
  }, [secondaryApproverIds]);

  const addSecondaryApprover = (userId) => {
    setSecondaryApproverIds(prev => Array.from(new Set([...prev, userId])));
  };

  const removeSecondaryApprover = (userId) => {
    if (secondaryApproverIds.length <= 1) {
      alert('최소 1명 이상의 2차 결재권자가 필요합니다.');
      return;
    }
    setSecondaryApproverIds(prev => prev.filter(id => id !== userId));
  };

  // Standard Rank-based Automatic Approval Rules (직급별 자동 결재선 진행 프로세스 기본 룰셋)
  const DEFAULT_RANK_APPROVAL_RULES = [
    {
      id: 'rule-staff',
      name: '1. 사원 / 대리 / 과장 / 차장 / 책임 (실무진)',
      description: '사원~책임 직급의 휴가 및 일반 경비 결재 기본 규칙 (3단계: 팀장 ➔ 총괄이사 ➔ 대표이사)',
      targetRanks: ['사원', '주임', '대리', '과장', '차장', '책임', '연구원', '전임', '선임', '매니저', 'STAFF'],
      isSystem: true,
      stages: [
        {
          id: 'stg-1',
          step: 1,
          roleName: '1차 결재자 (소속팀장)',
          approverType: 'DEPT_LEAD',
          specificUserId: null
        },
        {
          id: 'stg-2',
          step: 2,
          roleName: '2차 결재자 (총괄이사/지정임원)',
          approverType: 'SECONDARY_APPROVER',
          specificUserId: null
        },
        {
          id: 'stg-3',
          step: 3,
          roleName: '최종 결재자 (대표이사)',
          approverType: 'CEO',
          specificUserId: null
        }
      ]
    },
    {
      id: 'rule-lead',
      name: '2. 팀장 / 수석 (부서장)',
      description: '부서장 및 파트장 상신 결재선 (2단계: 총괄이사 ➔ 대표이사)',
      targetRanks: ['팀장', '수석', '파트장', '실장', '본부장', 'LEAD'],
      isSystem: true,
      stages: [
        {
          id: 'stg-1',
          step: 1,
          roleName: '1차 결재자 (총괄이사/지정임원)',
          approverType: 'SECONDARY_APPROVER',
          specificUserId: null
        },
        {
          id: 'stg-2',
          step: 2,
          roleName: '최종 결재자 (대표이사)',
          approverType: 'CEO',
          specificUserId: null
        }
      ]
    },
    {
      id: 'rule-director',
      name: '3. 임원 / 총괄 이사',
      description: '임원 및 총괄 이사 상신 결재선 (1단계: 대표이사 전결)',
      targetRanks: ['이사', '상무', '전무', '부사장', 'DIRECTOR', 'EXECUTIVE'],
      isSystem: true,
      stages: [
        {
          id: 'stg-1',
          step: 1,
          roleName: '최종 결재자 (대표이사)',
          approverType: 'CEO',
          specificUserId: null
        }
      ]
    },
    {
      id: 'rule-ceo',
      name: '4. 대표이사 (CEO)',
      description: '대표이사 본인 상신 결재선 (본인 1단계 전결)',
      targetRanks: ['대표이사', '대표', 'CEO'],
      isSystem: true,
      stages: [
        {
          id: 'stg-1',
          step: 1,
          roleName: '최종 결재자 (대표이사)',
          approverType: 'CEO',
          specificUserId: null
        }
      ]
    }
  ];

  // Rank-based Approval Rules State
  const [rankApprovalRules, setRankApprovalRules] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_rank_approval_rules_v1');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      }
    } catch (e) {
      console.warn('Failed to load rank approval rules from localStorage:', e);
    }
    return DEFAULT_RANK_APPROVAL_RULES;
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_rank_approval_rules_v1', JSON.stringify(rankApprovalRules));
    } catch (e) {
      console.warn('Failed to save rank approval rules to localStorage:', e);
    }
  }, [rankApprovalRules]);

  const updateRankApprovalRules = async (newRules) => {
    setRankApprovalRules(newRules);
    try {
      localStorage.setItem('clou_portal_rank_approval_rules_v1', JSON.stringify(newRules));
      await saveSystemConfig('rankApprovalRules', newRules);
    } catch (e) {
      console.warn('Failed to update rank approval rules:', e);
    }
  };

  const resetRankApprovalRules = async () => {
    setRankApprovalRules(DEFAULT_RANK_APPROVAL_RULES);
    try {
      localStorage.setItem('clou_portal_rank_approval_rules_v1', JSON.stringify(DEFAULT_RANK_APPROVAL_RULES));
      await saveSystemConfig('rankApprovalRules', DEFAULT_RANK_APPROVAL_RULES);
    } catch (e) {
      console.warn('Failed to reset rank approval rules:', e);
    }
  };

  // Approval Presets (관리자 지정 결재선 템플릿)
  const [approvalPresets, setApprovalPresets] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_approval_presets_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load approval presets:', e);
    }
    return [
      {
        id: 'preset-standard',
        name: '표준 3단계 결재선 (팀장 ➔ 이사 ➔ 대표이사)',
        description: '사원~책임 직급의 휴가 및 일반 경비 결재 기본 규칙',
        isDefault: true
      },
      {
        id: 'preset-fast',
        name: '2단계 결재 라인 (이사 ➔ 대표이사)',
        description: '팀장/부서장 상신 건 전용 결재선',
        isDefault: false
      },
      {
        id: 'preset-ceo-direct',
        name: '대표이사 직속 결재 (대표이사 1단계 전결)',
        description: '이사/임원 상신 및 긴급 결재 건',
        isDefault: false
      }
    ];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_approval_presets_v3', JSON.stringify(approvalPresets));
    } catch (e) {
      console.warn('Failed to save approval presets:', e);
    }
  }, [approvalPresets]);


  // Helper: Generates automatic hierarchical approval chain based on customizable rankApprovalRules
  const getAutoApprovalLine = (applicantUser) => {
    const user = applicantUser || currentUser;
    if (!user) return [];

    // Helper: Find active lead for a department (excluding retired users)
    const findActiveDeptLead = (deptName) => {
      const activeUsers = (users || []).filter(u => u.EmploymentStatus !== '퇴사' && u.Status !== 'Retired');
      
      // 1. Check if configured deptLeads user exists and is active (not retired)
      const configuredLeadId = deptLeads[deptName];
      if (configuredLeadId) {
        const leadObj = activeUsers.find(u => u.UserID === configuredLeadId);
        if (leadObj) return leadObj;
      }

      // 2. Find any active manager / director / lead in the same department
      const deptMembers = activeUsers.filter(u => u.Department === deptName);
      const leadByRole = deptMembers.find(u => {
        const title = (u.JobTitle || '').toLowerCase();
        const pos = (u.Position || '').toLowerCase();
        const duty = (u.Duty || '').toLowerCase();
        return title.includes('팀장') || title.includes('이사') || title.includes('부장') ||
               pos.includes('팀장') || pos.includes('이사') || pos.includes('부장') ||
               duty.includes('팀장') || duty.includes('부장');
      });
      if (leadByRole) return leadByRole;

      // 3. Fallback to first active member of department, or specific active executives
      if (deptMembers.length > 0) return deptMembers[0];

      if (deptName === '클라우드네이티브') {
        return activeUsers.find(u => u.UserID === 'emp-01') || activeUsers.find(u => u.Account === 'jykwon') || { UserID: 'emp-01', Name: '권진용', JobTitle: '이사', Department: '클라우드네이티브' };
      }
      if (deptName === 'AI서비스개발') {
        return activeUsers.find(u => u.UserID === 'emp-09') || activeUsers.find(u => u.Account === 'clou0315') || { UserID: 'emp-09', Name: '이상희', JobTitle: '이사', Department: 'AI서비스개발' };
      }
      return activeUsers.find(u => u.UserID === 'emp-10') || activeUsers.find(u => u.Account === 'chris') || { UserID: 'emp-10', Name: '이용관', JobTitle: '대표이사', Department: '경영마케팅' };
    };

    const deptLead = findActiveDeptLead(user.Department || '클라우드네이티브');
    const ceo = (users || []).find(u => u.UserID === 'emp-10' && u.EmploymentStatus !== '퇴사') || (users || []).find(u => u.JobTitle === '대표이사') || { UserID: 'emp-10', Name: '이용관', JobTitle: '대표이사', Department: '경영마케팅' };

    // Get active secondary approver user objects
    const secondaryList = secondaryApproverIds
      .map(id => (users || []).find(u => u.UserID === id && u.EmploymentStatus !== '퇴사' && u.Status !== 'Retired'))
      .filter(Boolean);
    const defaultDirector = (users || []).find(u => u.UserID === 'emp-09' && u.EmploymentStatus !== '퇴사') || (users || []).find(u => u.UserID === 'emp-01' && u.EmploymentStatus !== '퇴사') || { UserID: 'emp-09', Name: '이상희', JobTitle: '이사', Department: 'AI서비스개발' };

    const userRanks = [
      user.Position || '',
      user.JobTitle || '',
      user.Duty || '',
      user.Role || '',
      user.Account || ''
    ].map(s => String(s).trim().toLowerCase()).filter(Boolean);

    const isCeo = user.JobTitle === '대표이사' || user.Account === 'chris' || user.UserID === 'emp-10';

    // Find matched rule from rankApprovalRules
    let matchedRule = null;
    if (isCeo) {
      matchedRule = rankApprovalRules.find(r => r.id === 'rule-ceo' || r.targetRanks?.some(t => ['대표이사', '대표', 'ceo'].includes(t.toLowerCase()))) || rankApprovalRules[rankApprovalRules.length - 1];
    } else {
      matchedRule = rankApprovalRules.find(rule => {
        if (!rule.targetRanks || !Array.isArray(rule.targetRanks)) return false;
        return rule.targetRanks.some(target => 
          userRanks.some(ur => ur.includes(target.toLowerCase()) || target.toLowerCase().includes(ur))
        );
      });
    }

    // Fallback if no matching rule
    if (!matchedRule) {
      matchedRule = rankApprovalRules[0] || DEFAULT_RANK_APPROVAL_RULES[0];
    }

    const rawStages = [];
    (matchedRule.stages || []).forEach(stg => {
      if (stg.approverType === 'DEPT_LEAD') {
        // Skip if applicant is the department lead themselves
        if (deptLead.UserID !== user.UserID) {
          rawStages.push({
            ApproverID: deptLead.UserID,
            ApproverName: deptLead.Name,
            JobTitle: deptLead.JobTitle || deptLead.Position || '팀장',
            Department: deptLead.Department,
            RoleName: stg.roleName || `1차 결재자 (${user.Department || ''} 팀장)`
          });
        }
      } else if (stg.approverType === 'SECONDARY_APPROVER') {
        const directors = secondaryList.length > 0 ? secondaryList : [defaultDirector];
        directors.forEach(sec => {
          // Skip if applicant is this director themselves
          if (sec.UserID !== user.UserID) {
            rawStages.push({
              ApproverID: sec.UserID,
              ApproverName: sec.Name,
              JobTitle: sec.JobTitle || sec.Position || '이사',
              Department: sec.Department,
              RoleName: stg.roleName || `2차 결재자 (${sec.Name} ${sec.JobTitle || '이사'})`
            });
          }
        });
      } else if (stg.approverType === 'CEO') {
        rawStages.push({
          ApproverID: ceo.UserID,
          ApproverName: ceo.Name,
          JobTitle: ceo.JobTitle || '대표이사',
          Department: ceo.Department,
          RoleName: stg.roleName || '최종 결재자 (대표이사 이용관)'
        });
      } else if (stg.approverType === 'SPECIFIC_USER') {
        const specificUser = users.find(u => u.UserID === stg.specificUserId);
        if (specificUser && specificUser.UserID !== user.UserID) {
          rawStages.push({
            ApproverID: specificUser.UserID,
            ApproverName: specificUser.Name,
            JobTitle: specificUser.JobTitle || specificUser.Position || '담당',
            Department: specificUser.Department,
            RoleName: stg.roleName || `지정 결재자 (${specificUser.Name} ${specificUser.JobTitle || ''})`
          });
        }
      }
    });

    // Ensure stages is never empty
    if (rawStages.length === 0) {
      rawStages.push({
        ApproverID: ceo.UserID,
        ApproverName: ceo.Name,
        JobTitle: ceo.JobTitle,
        Department: ceo.Department,
        RoleName: '최종 결재자 (대표이사 이용관)'
      });
    }

    // Deduplicate approvers across all stages (so no approver appears more than once)
    const stages = [];
    const seenApproverIds = new Set();
    rawStages.forEach((stg) => {
      if (stg.ApproverID && !seenApproverIds.has(stg.ApproverID)) {
        seenApproverIds.add(stg.ApproverID);
        stages.push(stg);
      }
    });

    return stages.map((stg, idx) => ({
      Step: idx + 1,
      ApproverID: stg.ApproverID,
      ApproverName: stg.ApproverName,
      JobTitle: stg.JobTitle,
      Department: stg.Department,
      Status: idx === 0 ? 'PENDING' : 'WAITING',
      RoleName: stg.RoleName
    }));
  };

  // Draft emails (임시보관함)
  const [drafts, setDrafts] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_drafts_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return parsed.filter(d => d.DraftID && d.DraftID !== 'draft-01');
        }
      }
    } catch (e) {
      console.warn('Failed to load drafts:', e);
    }
    return [];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_drafts_v3', JSON.stringify(drafts));
    } catch (e) {
      console.warn('Failed to save drafts:', e);
    }
  }, [drafts]);

  const saveDraft = (draftData) => {
    const draftId = draftData.DraftID || `draft-${Date.now()}`;
    const newDraft = {
      DraftID: draftId,
      Recipient: draftData.Recipient || '',
      Subject: draftData.Subject || '(제목 없음)',
      BodyText: draftData.BodyText || '',
      Attachments: draftData.Attachments || [],
      UpdatedAt: new Date().toISOString()
    };

    setDrafts(prev => {
      const exists = prev.some(d => d.DraftID === draftId);
      if (exists) {
        return prev.map(d => d.DraftID === draftId ? newDraft : d);
      }
      return [newDraft, ...prev];
    });
    return newDraft;
  };

  const deleteDraft = (draftId) => {
    setDrafts(prev => prev.filter(d => d.DraftID !== draftId));
  };

  // 6. Approvals (Expense claims and Leave requests with multi-step support)
  const [approvals, setApprovals] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_approvals_v3');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          // Filter out obsolete hardcoded dummy test data from previous builds
          return parsed.filter(a => a.ApplicantName !== '이영희' && a.ApplicantName !== '강동우');
        }
      }
    } catch (e) {
      console.warn('Failed to load approvals:', e);
    }
    return [];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_approvals_v3', JSON.stringify(approvals));
    } catch (e) {
      console.warn('Failed to save approvals:', e);
    }
  }, [approvals]);

  // 7. Common HTML signature template (with placeholders) & Format
  const [signatureFormat, setSignatureFormat] = useState(() => {
    try {
      return localStorage.getItem('clou_portal_signature_format_v3') || 'CARD_IMAGE'; // 'CARD_IMAGE' | 'CARD_HTML' | 'CUSTOM_HTML'
    } catch {
      return 'CARD_IMAGE';
    }
  });

  const [commonSignature, setCommonSignature] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_common_signature_v6');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load common signature:', e);
    }
    return DEFAULT_CARD_HTML_TEMPLATE;
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_signature_format_v3', signatureFormat);
    } catch (e) {
      console.warn('Failed to save signature format:', e);
    }
  }, [signatureFormat]);

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_common_signature_v6', JSON.stringify(commonSignature));
    } catch (e) {
      console.warn('Failed to save common signature:', e);
    }
  }, [commonSignature]);

  // Helper: Generates custom user signature by replacing placeholders (Prioritizes Aliases if configured)
  const getUserSignature = (userOrId, template = commonSignature, forceFormat = null) => {
    if (!userOrId) return '';
    let targetUser = userOrId;
    if (typeof userOrId === 'string') {
      targetUser = (users || []).find(u => u.UserID === userOrId || u.Email === userOrId) || currentUser;
    }
    if (!targetUser) return '';

    const effectiveFormat = forceFormat || targetUser.SignatureFormat || signatureFormat || 'CARD_IMAGE';

    // If Image Mode selected (Default):
    if (effectiveFormat === 'CARD_IMAGE') {
      return generateCardImageHtml(targetUser);
    }

    // If Card HTML or Custom HTML:
    const activeTemplate = effectiveFormat === 'CARD_HTML' && (!template || template.includes('max-width: 460px')) 
      ? DEFAULT_CARD_HTML_TEMPLATE 
      : (template || DEFAULT_CARD_HTML_TEMPLATE);

    // If user has an alias, prioritize the alias email (e.g. anderson@clouflake.com)
    const displayEmail = (targetUser.Aliases && targetUser.Aliases.trim()) 
      ? targetUser.Aliases.split(',')[0].trim() 
      : targetUser.Email;

    return activeTemplate
      .replace(/{{Logo}}/g, currentLogo)
      .replace(/{{Name}}/g, targetUser.Name || '')
      .replace(/{{JobTitle}}/g, targetUser.JobTitle || targetUser.Position || '')
      .replace(/{{Department}}/g, targetUser.Department || '')
      .replace(/{{Phone}}/g, targetUser.Phone || '02-123-4567')
      .replace(/{{Email}}/g, displayEmail || targetUser.Email || '');
  };

  // 8. Group Mails Config with localStorage persistence (Requirement 1)
  const [groupMails, setGroupMails] = useState(() => {
    const saved = localStorage.getItem('clou_group_mails_v2');
    if (saved) {
      try { return JSON.parse(saved); } catch (e) { console.error(e); }
    }
    return [
      { 
        GroupEmail: 'contact@clouflake.com', 
        Description: '대외 문의 및 일반 접수 대표 메일', 
        Assignees: ['jykwon@clouflake.com', 'clou0315@clouflake.com'] 
      },
      { 
        GroupEmail: 'sales@clouflake.com', 
        Description: '영업 및 사업 제휴 대표 메일', 
        Assignees: ['yhmoon@clouflake.com', 'kkpark@clouflake.com'] 
      },
      { 
        GroupEmail: 'tech@clouflake.com', 
        Description: '기술 지원 및 솔루션 문의 메일', 
        Assignees: ['edenatom@clouflake.com', 'kimuijoong@clouflake.com'] 
      },
      { 
        GroupEmail: 'hr@clouflake.com', 
        Description: '인사 및 채용 공식 대표 메일', 
        Assignees: ['chris@clouflake.com', 'mgpoc@clouflake.com'] 
      }
    ];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_group_mails_v2', JSON.stringify(groupMails));
    } catch (e) {
      console.warn('Failed to save group mails:', e);
    }
  }, [groupMails]);

  // 9. SES API Logs (Audit Log) with localStorage persistence (Requirement 2)
  const [sesLogs, setSesLogs] = useState(() => {
    const saved = localStorage.getItem('clou_ses_logs_v2');
    if (saved) {
      try { return JSON.parse(saved); } catch (e) { console.error(e); }
    }
    return [
      { LogID: 'ses-01', Timestamp: '2026-08-15T11:51:51.382Z', Type: 'SEND', Sender: 'clou0315@clouflake.com', Recipient: 'honggildong@naver.com', Subject: '[Clouflake] 실시간 메일 전송 테스트', Status: 'SUCCESS', ErrorMsg: 'SES ID: 010c01a0054398d6' },
      { LogID: 'ses-02', Timestamp: '2026-08-15T11:50:08.147Z', Type: 'RECEIVE', Sender: 'honggildong@naver.com', Recipient: 'anderson@clouflake.com', Subject: '메일이 전송되나요?', Status: 'DELIVERED', ErrorMsg: 'AWS SES S3 Inbound' },
      { LogID: 'ses-03', Timestamp: '2026-08-15T12:03:59.687Z', Type: 'RECEIVE', Sender: 'helpdesk@jobkorea.co.kr', Recipient: 'chris@clouflake.com', Subject: '[포지션제안_거절] 고00님이 제안을 거절했습니다.', Status: 'DELIVERED', ErrorMsg: 'AWS SES S3 Inbound' }
    ];
  });

  useEffect(() => {
    localStorage.setItem('clou_ses_logs_v2', JSON.stringify(sesLogs));
  }, [sesLogs]);

  // Helper: Calculate initial legal leave based on Korean Labor Law (Article 60)
  const calculateInitialLeave = (joinDateStr) => {
    if (!joinDateStr) return 15;
    const joinDate = new Date(joinDateStr);
    const today = new Date();
    const diffTime = Math.abs(today - joinDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffYears = diffDays / 365.25;
    
    if (diffYears < 1) {
      const diffMonths = diffDays / 30.43;
      return Math.min(Math.floor(diffMonths), 11);
    } else {
      const additionalYears = Math.floor(diffYears - 1);
      const extraDays = Math.floor(additionalYears / 2);
      return Math.min(15 + extraDays, 25);
    }
  };

  // Action: Add new employee (Default password 'clou1234' + MustChangePassword: true)
  const addEmployee = (employeeData) => {
    const initialLeave = calculateInitialLeave(employeeData.JoinDate);
    const account = employeeData.Account || employeeData.Email?.split('@')[0] || `user${Date.now()}`;
    const email = employeeData.Email || `${account}@clouflake.com`;
    
    const newEmployee = {
      UserID: `emp-${Date.now()}`,
      Name: employeeData.Name,
      Account: account,
      Email: email,
      Password: 'clou1234', // Default initial password clou1234
      MustChangePassword: true, // Forces password change on first login!
      Phone: employeeData.Phone || '010-0000-0000',
      EmploymentType: employeeData.EmploymentType || '정규',
      EmploymentStatus: employeeData.EmploymentStatus || '재직',
      Position: employeeData.Position || employeeData.JobTitle || '사원',
      Duty: employeeData.Duty || '-',
      UserGroup: employeeData.UserGroup || '-',
      Department: employeeData.Department || '클라우드네이티브',
      JobTitle: employeeData.JobTitle || employeeData.Position || '사원',
      JoinDate: employeeData.JoinDate || new Date().toISOString().split('T')[0],
      Tenure: employeeData.Tenure || '0년 1개월',
      TotalLeave: Number(employeeData.TotalLeave) || initialLeave,
      UsedLeave: Number(employeeData.UsedLeave) || 0,
      RemainingLeave: Number(employeeData.RemainingLeave) || initialLeave,
      ForwardingEmail: employeeData.ForwardingEmail || '',
      Aliases: employeeData.Aliases || (account === 'clou0315' ? 'anderson@clouflake.com' : ''),
      StorageQuota: getStorageQuotaByPosition(employeeData.JobTitle || employeeData.Position),
      StorageUsed: 0,
      Status: employeeData.Status || (employeeData.EmploymentStatus === '퇴사' ? 'Retired' : 'Active'),
      Role: employeeData.Role || ((account === 'clou0315' || account === 'chris') ? 'ADMIN' : 'STAFF')
    };

    saveRemoteUser(newEmployee);
    setUsers(prev => [newEmployee, ...prev]);

    // Record grant audit
    const historyId = `hist-${Date.now()}`;
    const newHistory = {
      HistoryID: historyId,
      UserID: newEmployee.UserID,
      ChangeType: 'ANNUAL_GRANT',
      Days: newEmployee.TotalLeave,
      Reason: `신규 사원 등록 및 연차 부여 (입사일: ${newEmployee.JoinDate})`,
      CreatedBy: currentUser.Name,
      Timestamp: new Date().toISOString()
    };
    setLeaveHistory(prev => [newHistory, ...prev]);

    return newEmployee;
  };

  // Action: Batch Import Employees from CSV/Excel data
  const batchImportEmployees = (employeeList) => {
    if (!Array.isArray(employeeList) || employeeList.length === 0) return 0;
    
    let importedCount = 0;
    const newEmployees = [];
    const newHistories = [];

    employeeList.forEach((row, idx) => {
      const name = row.이름 || row.Name;
      const account = row.계정 || row.Account || (row.이메일 ? row.이메일.split('@')[0] : `user_${Date.now()}_${idx}`);
      if (!name) return;

      const email = row.이메일 || row.Email || `${account}@clouflake.com`;
      const joinDate = row.입사일 || row.JoinDate || '2026-01-01';
      const initialLeave = calculateInitialLeave(joinDate);
      const isRetire = (row['재직 상태'] || row.EmploymentStatus) === '퇴사';

      const empObj = {
        UserID: `emp-${Date.now()}-${idx}`,
        Name: name,
        Account: account,
        Email: email,
        Password: 'clou1234',
        MustChangePassword: true,
        Phone: row.전화번호 || row.Phone || '010-0000-0000',
        EmploymentType: row.직원구분 || row.EmploymentType || '정규',
        EmploymentStatus: row['재직 상태'] || row.EmploymentStatus || (isRetire ? '퇴사' : '재직'),
        Position: row.직위 || row.Position || '사원',
        Duty: row.직책 || row.Duty || '-',
        UserGroup: row['사용자 그룹'] || row.UserGroup || '-',
        Department: row.부서명 || row.Department || '클라우드네이티브',
        JobTitle: row.직위 || row.Position || row.JobTitle || '사원',
        JoinDate: joinDate,
        Tenure: row.재직기간 || row.Tenure || '0년 1개월',
        TotalLeave: initialLeave,
        UsedLeave: 0,
        RemainingLeave: initialLeave,
        ForwardingEmail: '',
        Aliases: account === 'clou0315' ? 'anderson@clouflake.com' : '',
        StorageQuota: getStorageQuotaByPosition(row.직위 || row.Position || row.JobTitle || '사원'),
        StorageUsed: 0,
        Status: (row['계정 상태'] === '중지' || isRetire) ? 'Retired' : 'Active',
        Role: (account === 'clou0315' || account === 'chris') ? 'ADMIN' : 'STAFF'
      };

      newEmployees.push(empObj);
      newHistories.push({
        HistoryID: `hist-${Date.now()}-${idx}`,
        UserID: empObj.UserID,
        ChangeType: 'ANNUAL_GRANT',
        Days: initialLeave,
        Reason: `일괄 등록 사원 연차 부여 (입사일: ${joinDate})`,
        CreatedBy: currentUser.Name,
        Timestamp: new Date().toISOString()
      });
      importedCount++;
    });

    if (newEmployees.length > 0) {
      newEmployees.forEach(emp => saveRemoteUser(emp));
      setUsers(prev => [...newEmployees, ...prev]);
      setLeaveHistory(prev => [...newHistories, ...prev]);
    }
    return importedCount;
  };

  // Action: Admin update employee department, job title, name, phone, quota, status, etc.
  const updateEmployeeInfo = (userId, updatedFields) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, ...updatedFields };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, ...updatedFields } : u));

    if (currentUser.UserID === userId) {
      setCurrentUser(prev => ({ ...prev, ...updatedFields }));
    }
  };

  // Action: Toggle or assign employee Role (ADMIN <-> STAFF)
  const updateEmployeeRole = (userId, newRole) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, Role: newRole };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, Role: newRole } : u));
    if (currentUser.UserID === userId) {
      setCurrentUser(prev => ({ ...prev, Role: newRole }));
    }
  };

  // Action: Update employee account status
  const updateEmployeeStatus = (userId, newStatus) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, Status: newStatus };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, Status: newStatus } : u));
  };

  // Action: Terminate (Retire) employee with history logging (Requirement 1)
  const terminateEmployee = (userId, reason, successorEmail) => {
    const emp = users.find(u => u.UserID === userId);
    if (!emp) return;

    const updated = {
      ...emp,
      Status: 'Retired',
      EmploymentStatus: '퇴사',
      Department: '-',
      Duty: '-'
    };
    saveRemoteUser(updated);

    setUsers(prev => prev.map(u => u.UserID === userId ? {
      ...u,
      Status: 'Retired',
      EmploymentStatus: '퇴사',
      Department: '-',
      Duty: '-'
    } : u));

    const newHistory = {
      HistoryID: `ret-${Date.now()}`,
      UserID: userId,
      Name: emp.Name,
      Email: emp.Email,
      Position: emp.Position || emp.JobTitle || '사원',
      RetiredAt: new Date().toISOString().split('T')[0],
      Reason: reason || '개인 사정',
      Successor: successorEmail || ''
    };
    setRetirementHistory(prev => [newHistory, ...prev]);
  };

  // Action: Restore employee back to Active status (Requirement 1)
  const restoreEmployee = (userId, department = '클라우드네이티브', position = '사원') => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = {
        ...targetUser,
        Status: 'Active',
        EmploymentStatus: '재직',
        Department: department,
        Position: position,
        JobTitle: position
      };
      saveRemoteUser(updated);
    }

    setUsers(prev => prev.map(u => u.UserID === userId ? {
      ...u,
      Status: 'Active',
      EmploymentStatus: '재직',
      Department: department,
      Position: position,
      JobTitle: position
    } : u));

    setRetirementHistory(prev => prev.filter(h => h.UserID !== userId));
  };

  // Action: Set forwarding rule for retired employees
  const setForwardingRule = (userId, forwardingEmail) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, ForwardingEmail: forwardingEmail };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, ForwardingEmail: forwardingEmail } : u));
  };

  // Action: Set email aliases for employees
  const setAliasesRule = (userId, aliases) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, Aliases: aliases };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, Aliases: aliases } : u));
  };

  // Action: Complete password change (dismisses mandatory prompt permanently)
  const completePasswordChange = (userId, newPassword) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = {
        ...targetUser,
        Password: newPassword,
        MustChangePassword: false,
        PasswordChangedAt: new Date().toISOString()
      };
      saveRemoteUser(updated);
    }

    setUsers(prev => {
      const updatedList = prev.map(u => u.UserID === userId ? {
        ...u,
        Password: newPassword,
        MustChangePassword: false,
        PasswordChangedAt: new Date().toISOString()
      } : u);
      try {
        localStorage.setItem('clou_portal_users_v3', JSON.stringify(updatedList));
      } catch (e) {
        console.warn('LocalStorage save error:', e);
      }
      return updatedList;
    });

    setCurrentUser(prev => {
      const updated = prev ? { ...prev, MustChangePassword: false } : prev;
      saveAuthSession({
        currentUser: updated,
        mustChangePassword: false
      });
      return updated;
    });

    setMustChangePasswordPrompt(false);
  };

  // Action: Admin force deduct leave
  const adminForceDeduct = (userId, days, reason) => {
    let updatedRemaining = 0;
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const remaining = Number(targetUser.RemainingLeave) - Number(days);
      const used = Number(targetUser.UsedLeave) + Number(days);
      updatedRemaining = remaining;
      const updatedUser = { ...targetUser, RemainingLeave: remaining, UsedLeave: used };
      saveRemoteUser(updatedUser);
    }

    setUsers(prev => prev.map(u => {
      if (u.UserID === userId) {
        const remaining = Number(u.RemainingLeave) - Number(days);
        const used = Number(u.UsedLeave) + Number(days);
        return { ...u, RemainingLeave: remaining, UsedLeave: used };
      }
      return u;
    }));

    if (currentUser?.UserID === userId) {
      setCurrentUser(prev => ({
        ...prev,
        RemainingLeave: Number(prev.RemainingLeave) - Number(days),
        UsedLeave: Number(prev.UsedLeave) + Number(days)
      }));
    }

    const historyId = `hist-${Date.now()}`;
    const newHistory = {
      HistoryID: historyId,
      UserID: userId,
      ChangeType: 'ADMIN_FORCE_DEDUCT',
      Days: Number(days),
      Reason: reason,
      CreatedBy: currentUser?.Name || '관리자',
      Timestamp: new Date().toISOString()
    };
    setLeaveHistory(prev => [newHistory, ...prev]);
    saveRemoteLeaveHistory(newHistory);
    return updatedRemaining;
  };

  // Action: Synchronize and reconcile all employee leave balances with audit logs
  const reconcileLeaveFromAuditLogs = async () => {
    try {
      const forceLogs = leaveHistory.filter(h => h.ChangeType === 'ADMIN_FORCE_DEDUCT');
      
      // Save all local logs to DynamoDB LeaveHistory table
      for (const log of forceLogs) {
        await saveRemoteLeaveHistory(log);
      }

      if (forceLogs.length === 0) {
        return { success: true, count: 0, message: '반영할 직권 차감 감사로그가 없습니다.' };
      }

      // Group deductions by UserID
      const userDeductions = {};
      forceLogs.forEach(log => {
        if (!userDeductions[log.UserID]) userDeductions[log.UserID] = 0;
        userDeductions[log.UserID] += Number(log.Days || 0);
      });

      let updatedCount = 0;
      const updatedUsers = users.map(user => {
        if (userDeductions[user.UserID] !== undefined) {
          const totalDeducted = userDeductions[user.UserID];
          const totalLeave = Number(user.TotalLeave || 15);
          
          // Approved leaves from approvals queue
          const approvedLeaves = approvals
            .filter(a => a.Type === 'LEAVE' && a.ApplicantID === user.UserID && a.Status === 'APPROVED')
            .reduce((sum, a) => sum + Number(a.LeaveDays || 0), 0);

          const newUsed = approvedLeaves + totalDeducted;
          const newRemaining = totalLeave - newUsed;

          const updated = {
            ...user,
            UsedLeave: newUsed,
            RemainingLeave: newRemaining
          };
          saveRemoteUser(updated);
          updatedCount++;
          return updated;
        }
        return user;
      });

      setUsers(updatedUsers);
      try {
        localStorage.setItem('clou_portal_users_v3', JSON.stringify(updatedUsers));
      } catch (e) {
        console.warn('LocalStorage save error:', e);
      }

      return {
        success: true,
        count: updatedCount,
        message: `총 ${updatedCount}명 직원의 연차 데이터가 직권 차감 감사로그와 DynamoDB에 성공적으로 일괄 동기화되었습니다.`
      };
    } catch (err) {
      console.error('Reconcile error:', err);
      return { success: false, error: err.message };
    }
  };

  // Action: Apply for leave with Automated or Custom Multi-step Approval Line
  const applyForLeave = (days, reason, startDate, endDate, leaveType, isSpecial = false, specialType = '', proofFileName = '', proofUrl = '', totalCalendarDays = 0, approvalId = '', customStages = null, sendKakao = true) => {
    const finalId = approvalId || `appr-${Date.now()}`;
    const stages = customStages && customStages.length > 0 ? customStages : getAutoApprovalLine(currentUser);

    // Compute Leave Snapshots (Before, Requested, After)
    const userTotal = (currentUser.TotalLeave !== undefined && currentUser.TotalLeave !== null && currentUser.TotalLeave !== '') ? Number(currentUser.TotalLeave) : 15;
    const userUsed = Number(currentUser.UsedLeave || 0);
    const userBaseRem = (currentUser.RemainingLeave !== undefined && currentUser.RemainingLeave !== null && currentUser.RemainingLeave !== '') ? Number(currentUser.RemainingLeave) : (userTotal - userUsed);
    const userPendingList = approvals.filter(a => a.Type === 'LEAVE' && a.Status === 'PENDING' && (a.ApplicantID === currentUser.UserID || a.ApplicantName === currentUser.Name));
    const userPendingDays = userPendingList.reduce((s, a) => s + (Number(a.LeaveDays || a.Days) || 0), 0);
    const beforeBalance = userBaseRem - userPendingDays;
    const reqDays = Number(days);
    const deductedDays = isSpecial ? 0 : reqDays;
    const afterBalance = beforeBalance - deductedDays;

    const newApproval = {
      ApprovalID: finalId,
      ApplicantID: currentUser.UserID,
      ApplicantName: currentUser.Name,
      ApplicantDept: currentUser.Department,
      ApplicantJobTitle: currentUser.JobTitle,
      Type: 'LEAVE',
      Amount: 0,
      Status: 'PENDING',
      CurrentStep: 1,
      ApprovalStages: stages,
      ReceiptS3Url: proofUrl,
      ProofUrl: proofUrl,
      CreatedAt: new Date().toISOString(),
      Details: `${isSpecial ? `[${specialType}] ` : ''}${reason} (${startDate} ~ ${endDate}, 총 ${totalCalendarDays}일, 영업일 ${days}일${isSpecial ? ' 차감 제외' : ''})`,
      LeaveDays: Number(days),
      RequestedDays: Number(days),
      BeforeLeaveBalance: beforeBalance,
      AfterLeaveBalance: afterBalance,
      StartDate: startDate,
      EndDate: endDate,
      LeaveType: leaveType,
      IsSpecial: isSpecial,
      SpecialType: specialType,
      TotalCalendarDays: totalCalendarDays
    };
    setApprovals(prev => {
      if (prev.some(a => a.ApprovalID === finalId)) {
        return prev;
      }
      return [newApproval, ...prev];
    });
    saveRemoteApproval(newApproval);

    // Send KakaoTalk Alimtalk to 1st stage approver if enabled
    if (sendKakao && stages && stages.length > 0) {
      const firstApprover = stages[0];
      const approverUser = users.find(u => u.UserID === firstApprover.ApproverID) || users.find(u => u.Name === firstApprover.ApproverName);
      if (approverUser) {
        const leaveTypeName = isSpecial ? (specialType || '특수휴가') : (leaveType === 'HALF_AM' ? '오전반차' : leaveType === 'HALF_PM' ? '오후반차' : leaveType === 'HALF' ? '반차' : leaveType === 'QUARTER' ? '반반차' : '연차');
        const formatted = formatKakaoTemplate('LEAVE_REQUEST', {
          신청자명: currentUser.Name,
          부서: currentUser.Department || '-',
          직급: currentUser.JobTitle || '임직원',
          연차구분: leaveTypeName,
          일수: String(days),
          시작일: startDate,
          종료일: endDate,
          사유: reason || '개인 사유'
        });

        sendKakaoBizMessage({
          recipientPhone: approverUser.Phone,
          recipientName: approverUser.Name,
          recipientEmail: approverUser.Email,
          title: formatted.title || `[전자결재] ${currentUser.Name}님 연차 결재 요청`,
          messageText: formatted.messageText,
          buttonText: formatted.buttonText || '결재 승인하기',
          buttonUrl: formatted.buttonUrl,
          messageType: 'APPROVAL_REQUEST'
        }).catch(err => console.warn('Kakao leave approval notification failed:', err));
      }
    }
  };

  // Action: Apply for expense with Automated or Custom Multi-step Approval Line
  const applyForExpense = (amount, details, cardCompany = '', cardNum = '', fileName = '', receiptS3Url = '', approvalId = '', customStages = null, sendKakao = true, expenseDate = '') => {
    const finalId = approvalId || `appr-${Date.now()}`;
    const finalUrl = receiptS3Url || 'https://images.unsplash.com/photo-1554415707-6e8cfc93fe23?q=80&w=600&auto=format&fit=crop';
    const stages = customStages && customStages.length > 0 ? customStages : getAutoApprovalLine(currentUser);
    const finalDate = expenseDate || new Date().toISOString().slice(0, 10);

    const newApproval = {
      ApprovalID: finalId,
      ApplicantID: currentUser.UserID,
      ApplicantName: currentUser.Name,
      ApplicantDept: currentUser.Department,
      ApplicantJobTitle: currentUser.JobTitle,
      Type: 'EXPENSE',
      Amount: Number(amount),
      ExpenseAmount: Number(amount),
      Status: 'PENDING',
      CurrentStep: 1,
      ApprovalStages: stages,
      ReceiptS3Url: finalUrl,
      ReceiptUrl: finalUrl,
      ProofUrl: finalUrl,
      ProofFileName: fileName,
      FileName: fileName,
      CreatedAt: new Date().toISOString(),
      StartDate: finalDate,
      EndDate: finalDate,
      ExpenseDate: finalDate,
      Details: details,
      ExpenseDetails: details,
      CardNumber: cardNum,
      CardCompany: cardCompany
    };
    setApprovals(prev => {
      if (prev.some(a => a.ApprovalID === finalId)) {
        return prev;
      }
      return [newApproval, ...prev];
    });
    saveRemoteApproval(newApproval);

    // Send KakaoTalk Alimtalk to 1st stage approver if enabled
    if (sendKakao && stages && stages.length > 0) {
      const firstApprover = stages[0];
      const approverUser = users.find(u => u.UserID === firstApprover.ApproverID) || users.find(u => u.Name === firstApprover.ApproverName);
      if (approverUser) {
        const formatted = formatKakaoTemplate('EXPENSE_REQUEST', {
          신청자명: currentUser.Name,
          부서: currentUser.Department || '-',
          직급: currentUser.JobTitle || '임직원',
          청구금액: Number(amount).toLocaleString(),
          사용내역: details,
          카드사: cardCompany || '법인카드',
          카드번호: cardNum || '-'
        });

        sendKakaoBizMessage({
          recipientPhone: approverUser.Phone,
          recipientName: approverUser.Name,
          recipientEmail: approverUser.Email,
          title: formatted.title || `[전자결재] ${currentUser.Name}님 경비 결재 요청`,
          messageText: formatted.messageText,
          buttonText: formatted.buttonText || '결재 승인하기',
          buttonUrl: formatted.buttonUrl,
          messageType: 'APPROVAL_REQUEST'
        }).catch(err => console.warn('Kakao expense approval notification failed:', err));
      }
    }

    return finalUrl;
  };

  // Action: Apply for Storage Quota Expansion (Requirement 2)
  const applyForStorageQuota = (requestedAddGB, reason, customStages = null) => {
    const finalId = `appr-storage-${Date.now()}`;
    const stages = customStages && customStages.length > 0 ? customStages : getAutoApprovalLine(currentUser);

    const newApproval = {
      ApprovalID: finalId,
      ApplicantID: currentUser.UserID,
      ApplicantName: currentUser.Name,
      ApplicantDept: currentUser.Department,
      ApplicantJobTitle: currentUser.JobTitle,
      Type: 'STORAGE_EXPANSION',
      Amount: Number(requestedAddGB),
      Status: 'PENDING',
      CurrentStep: 1,
      ApprovalStages: stages,
      CreatedAt: new Date().toISOString(),
      Details: `[스토리지 용량 증설] +${requestedAddGB} GB 추가 요청 (사유: ${reason})`
    };
    setApprovals(prev => {
      if (prev.some(a => a.ApprovalID === finalId)) {
        return prev;
      }
      return [newApproval, ...prev];
    });
    saveRemoteApproval(newApproval);
    return finalId;
  };

  // Helper: Dynamically compute real storage used (in MB/GB) for any user
  const getUserStorageUsage = (userId) => {
    const targetUser = users.find(u => u.UserID === userId) || currentUser;
    const targetEmail = (targetUser.Email || '').toLowerCase();
    const targetAliases = (targetUser.Aliases || '').toLowerCase().split(',').map(a => a.trim()).filter(Boolean);

    // Sum matching user emails
    const userEmails = emails.filter(e => {
      const sender = (e.Sender || '').toLowerCase();
      const recipient = (e.Recipient || '').toLowerCase();
      return sender.includes(targetEmail) || recipient.includes(targetEmail) || targetAliases.some(alias => recipient.includes(alias) || sender.includes(alias));
    });

    const totalEmailBytes = userEmails.reduce((acc, email) => {
      const textBytes = ((email.BodyText || '').length * 2) + ((email.BodyHTML || '').length * 2) + ((email.Subject || '').length * 2);
      const attachmentBytes = (email.Attachments || []).reduce((attAcc, att) => {
        if (typeof att === 'object' && att.size) return attAcc + att.size;
        return attAcc + (1.2 * 1024 * 1024); // ~1.2MB default per attachment
      }, 0);
      return acc + textBytes + attachmentBytes + 2048; // Base headers
    }, 0);

    const userDrafts = drafts.filter(d => d.UserID === targetUser.UserID || !d.UserID);
    const totalDraftBytes = userDrafts.reduce((acc, d) => {
      return acc + ((d.BodyText || '').length * 2) + ((d.Attachments || []).length * 1024 * 1024);
    }, 0);

    const totalBytes = totalEmailBytes + totalDraftBytes + (1024 * 256); // 256KB mailbox index overhead
    const totalMB = Math.max(0.1, Number((totalBytes / (1024 * 1024)).toFixed(2)));
    const totalGB = Number((totalMB / 1024).toFixed(3));
    const quotaGB = Number(targetUser.StorageQuota || 20);
    const usagePercent = Number(((totalGB / quotaGB) * 100).toFixed(2));

    return {
      usedBytes: totalBytes,
      usedMB: totalMB,
      usedGB: totalGB,
      quotaGB: quotaGB,
      usagePercent: usagePercent,
      emailCount: userEmails.length,
      draftCount: userDrafts.length
    };
  };

  // Action: Withdraw a pending leave request immediately (신청 회수)
  const withdrawLeaveRequest = (approvalId) => {
    const appr = approvals.find(a => a.ApprovalID === approvalId);
    if (!appr || appr.Status !== 'PENDING') return;

    const updatedAppr = {
      ...appr,
      Status: 'CANCELED',
      ApprovalStages: appr.ApprovalStages?.map(s => ({ ...s, Status: 'CANCELED', Comment: '신청자 직접 회수' }))
    };

    saveRemoteApproval(updatedAppr);
    setApprovals(prev => prev.map(a => a.ApprovalID === approvalId ? updatedAppr : a));
  };

  // Action: Withdraw a pending expense request immediately (신청자 경비 신청 회수/취소)
  const withdrawExpenseRequest = (approvalId) => {
    const appr = approvals.find(a => a.ApprovalID === approvalId);
    if (!appr || (appr.Status !== 'PENDING' && appr.Status !== 'CANCEL_REQUESTED')) return;

    const updatedAppr = {
      ...appr,
      Status: 'CANCELED',
      ApprovalStages: appr.ApprovalStages?.map(s => ({ ...s, Status: 'CANCELED', Comment: '신청자 직접 취소/회수' }))
    };

    saveRemoteApproval(updatedAppr);
    setApprovals(prev => prev.map(a => a.ApprovalID === approvalId ? updatedAppr : a));
  };

  // Action: Request cancellation for an approved leave request (취소 신청)
  const requestLeaveCancellation = (approvalId, cancelReason = '개인 사정으로 인한 연차 취소') => {
    const appr = approvals.find(a => a.ApprovalID === approvalId);
    if (!appr || appr.Status !== 'APPROVED') return;

    const updatedAppr = {
      ...appr,
      Status: 'CANCEL_REQUESTED',
      CancelReason: cancelReason,
      CancelRequestedAt: new Date().toISOString(),
      CurrentStep: 1,
      ApprovalStages: appr.ApprovalStages?.map((s, idx) => ({
        ...s,
        Status: idx === 0 ? 'PENDING' : 'WAITING',
        Comment: `취소 사유: ${cancelReason}`
      }))
    };

    saveRemoteApproval(updatedAppr);
    setApprovals(prev => prev.map(a => a.ApprovalID === approvalId ? updatedAppr : a));
  };

  // Action: Multi-Step Approve/Reject approval request (Step 1: Team Lead -> Step 2: Director -> Step 3: CEO)
  const handleApprovalAction = (approvalId, newStatus, rejectReason = '', comment = '') => {
    const appr = approvals.find(a => a.ApprovalID === approvalId);
    if (!appr) return;

    const currentStep = appr.CurrentStep || 1;
    const stages = appr.ApprovalStages && appr.ApprovalStages.length > 0 ? appr.ApprovalStages : getAutoApprovalLine({ UserID: appr.ApplicantID, Department: appr.ApplicantDept || '인사팀' });

    let updatedAppr = { ...appr };

    // Process leave cancellation requests (CANCEL_REQUESTED)
    if (appr.Status === 'CANCEL_REQUESTED') {
      if (newStatus === 'APPROVED') {
        // Approve Cancellation -> CANCELED, refund leave balance
        if (appr.Type === 'LEAVE' && !appr.IsSpecial) {
          const targetUser = users.find(u => u.UserID === appr.ApplicantID);
          if (targetUser) {
            const remaining = Number(targetUser.RemainingLeave) + Number(appr.LeaveDays);
            const used = Number(targetUser.UsedLeave) - Number(appr.LeaveDays);
            const updated = { ...targetUser, RemainingLeave: remaining, UsedLeave: used };
            saveRemoteUser(updated);
          }
          setUsers(usersPrev => usersPrev.map(u => {
            if (u.UserID === appr.ApplicantID) {
              const remaining = Number(u.RemainingLeave) + Number(appr.LeaveDays);
              const used = Number(u.UsedLeave) - Number(appr.LeaveDays);
              return { ...u, RemainingLeave: remaining, UsedLeave: used };
            }
            return u;
          }));

          const historyId = `hist-${Date.now()}`;
          const newHistory = {
            HistoryID: historyId,
            UserID: appr.ApplicantID,
            ChangeType: 'LEAVE_CANCELED',
            Days: Number(appr.LeaveDays),
            Reason: `연차 취소 승인 완료: ${appr.Details.split('(')[0]}`,
            CreatedBy: currentUser.Name,
            Timestamp: new Date().toISOString()
          };
          setLeaveHistory(hPrev => [newHistory, ...hPrev]);
        }

        updatedAppr = {
          ...appr,
          Status: 'CANCELED',
          ApprovalStages: stages.map(s => ({
            ...s,
            Status: 'APPROVED',
            ProcessedAt: new Date().toISOString(),
            ProcessedBy: currentUser.Name,
            Comment: '연차 취소 승인 완료'
          }))
        };
      } else if (newStatus === 'REJECTED') {
        // Reject Cancellation -> Revert back to APPROVED
        updatedAppr = {
          ...appr,
          Status: 'APPROVED',
          RejectReason: rejectReason || '연차 취소 신청 반려',
          ApprovalStages: stages.map(s => ({
            ...s,
            Comment: rejectReason ? `취소 신청 반려 사유: ${rejectReason}` : s.Comment
          }))
        };
      }

      saveRemoteApproval(updatedAppr);
      setApprovals(prev => prev.map(a => a.ApprovalID === approvalId ? updatedAppr : a));
      return;
    }

    if (newStatus === 'REJECTED') {
      const updatedStages = stages.map(s => {
        if (s.Step === currentStep) {
          return { ...s, Status: 'REJECTED', Comment: rejectReason, ProcessedAt: new Date().toISOString(), ProcessedBy: currentUser.Name };
        }
        return s;
      });

      updatedAppr = {
        ...appr,
        Status: 'REJECTED',
        RejectReason: rejectReason,
        ApprovalStages: updatedStages
      };
    } else if (newStatus === 'APPROVED') {
      let stepToApprove = currentStep;
      let updatedStages = [...stages];
      
      while (stepToApprove <= stages.length) {
        const stageIndex = stepToApprove - 1;
        const stage = updatedStages[stageIndex];
        if (!stage) break;

        const isAssignedToCurrentUser = stage.ApproverID === currentUser.UserID || stage.ApproverName === currentUser.Name;

        if (isAssignedToCurrentUser || stepToApprove === currentStep) {
          updatedStages[stageIndex] = {
            ...stage,
            Status: 'APPROVED',
            Comment: stepToApprove === currentStep ? (comment || '승인 완료') : '이전 단계 승인으로 자동 승인 (동일 결재권자)',
            ProcessedAt: new Date().toISOString(),
            ProcessedBy: currentUser.Name
          };
          stepToApprove++;
        } else {
          updatedStages[stageIndex] = {
            ...stage,
            Status: 'PENDING'
          };
          break;
        }
      }

      const nextStep = stepToApprove;
      const isFinalStep = nextStep > stages.length;

      if (isFinalStep) {
        // Final Approval Step Succeeded!
        if (appr.Type === 'LEAVE' && !appr.IsSpecial) {
          const targetUser = users.find(u => u.UserID === appr.ApplicantID);
          if (targetUser) {
            const remaining = Number(targetUser.RemainingLeave) - Number(appr.LeaveDays);
            const used = Number(targetUser.UsedLeave) + Number(appr.LeaveDays);
            const updated = { ...targetUser, RemainingLeave: remaining, UsedLeave: used };
            saveRemoteUser(updated);
          }
          setUsers(usersPrev => usersPrev.map(u => {
            if (u.UserID === appr.ApplicantID) {
              const remaining = Number(u.RemainingLeave) - Number(appr.LeaveDays);
              const used = Number(u.UsedLeave) + Number(appr.LeaveDays);
              return { ...u, RemainingLeave: remaining, UsedLeave: used };
            }
            return u;
          }));

          const historyId = `hist-${Date.now()}`;
          const newHistory = {
            HistoryID: historyId,
            UserID: appr.ApplicantID,
            ChangeType: 'LEAVE_APPROVED',
            Days: Number(appr.LeaveDays),
            Reason: `${appr.IsSpecial ? `[차감제외 특수휴가] ` : ''}최종 승인 완료 (${stages.map(s => s.ApproverName).join(' ➔ ')})`,
            CreatedBy: currentUser.Name,
            Timestamp: new Date().toISOString()
          };
          setLeaveHistory(hPrev => [newHistory, ...hPrev]);
        }

        if (appr.Type === 'STORAGE_EXPANSION') {
          const addGb = Number(appr.Amount || 10);
          const targetUser = users.find(u => u.UserID === appr.ApplicantID);
          if (targetUser) {
            const currentQuota = Number(targetUser.StorageQuota || 20);
            const updated = { ...targetUser, StorageQuota: currentQuota + addGb };
            saveRemoteUser(updated);
          }
          setUsers(usersPrev => usersPrev.map(u => {
            if (u.UserID === appr.ApplicantID) {
              const currentQuota = Number(u.StorageQuota || 20);
              return { ...u, StorageQuota: currentQuota + addGb };
            }
            return u;
          }));
        }

        updatedAppr = {
          ...appr,
          Status: 'APPROVED',
          CurrentStep: stages.length,
          ApprovalStages: updatedStages
        };

        // Notify applicant of final approval via Kakao
        const applicantUser = users.find(u => u.UserID === appr.ApplicantID);
        if (applicantUser) {
          const typeLabel = appr.Type === 'LEAVE' ? '연차/휴가' : appr.Type === 'EXPENSE' ? '경비 청구' : '전자결재';
          const formatted = formatKakaoTemplate('APPROVAL_RESULT', {
            신청자명: applicantUser.Name,
            신청항목: `${typeLabel} (${appr.Details.split('(')[0].trim()})`,
            결재결과: '✅ 최종 승인 완료',
            결재자명: currentUser.Name,
            결재자직급: currentUser.JobTitle || '결재권자',
            반려사유: ''
          });

          sendKakaoBizMessage({
            recipientPhone: applicantUser.Phone,
            recipientName: applicantUser.Name,
            recipientEmail: applicantUser.Email,
            title: formatted.title || `[전자결재] ${typeLabel} 최종 승인 완료`,
            messageText: formatted.messageText,
            buttonText: formatted.buttonText || '결재 결과보기',
            buttonUrl: formatted.buttonUrl,
            messageType: 'APPROVAL_RESULT'
          }).catch(err => console.warn('Kakao final approval notification failed:', err));
        }
      } else {
        updatedAppr = {
          ...appr,
          Status: 'PENDING',
          CurrentStep: nextStep,
          ApprovalStages: updatedStages
        };

        // Notify NEXT stage approver
        const nextStage = updatedStages[nextStep - 1];
        if (nextStage) {
          const nextApproverUser = users.find(u => u.UserID === nextStage.ApproverID) || users.find(u => u.Name === nextStage.ApproverName);
          if (nextApproverUser) {
            const isLeave = appr.Type === 'LEAVE';
            const templateId = isLeave ? 'LEAVE_REQUEST' : 'EXPENSE_REQUEST';
            const formatted = formatKakaoTemplate(templateId, {
              신청자명: appr.ApplicantName,
              부서: appr.ApplicantDept || '-',
              직급: appr.ApplicantJobTitle || '임직원',
              연차구분: appr.LeaveType || '연차',
              일수: String(appr.LeaveDays || 1),
              시작일: appr.StartDate || '',
              종료일: appr.EndDate || '',
              사유: appr.Details || '',
              청구금액: Number(appr.Amount || 0).toLocaleString(),
              사용내역: appr.Details || '',
              카드사: appr.CardCompany || '법인카드',
              카드번호: appr.CardNumber || '-'
            });

            sendKakaoBizMessage({
              recipientPhone: nextApproverUser.Phone,
              recipientName: nextApproverUser.Name,
              recipientEmail: nextApproverUser.Email,
              title: formatted.title || `[전자결재] ${appr.ApplicantName}님 결재 요청`,
              messageText: formatted.messageText,
              buttonText: formatted.buttonText || '결재 승인하기',
              buttonUrl: formatted.buttonUrl,
              messageType: 'APPROVAL_REQUEST'
            }).catch(err => console.warn('Kakao next stage approval notification failed:', err));
          }
        }
      }
    }

    if (newStatus === 'REJECTED') {
      const applicantUser = users.find(u => u.UserID === appr.ApplicantID);
      if (applicantUser) {
        const typeLabel = appr.Type === 'LEAVE' ? '연차/휴가' : appr.Type === 'EXPENSE' ? '경비 청구' : '전자결재';
        const formatted = formatKakaoTemplate('APPROVAL_RESULT', {
          신청자명: applicantUser.Name,
          신청항목: `${typeLabel} (${appr.Details.split('(')[0].trim()})`,
          결재결과: '❌ 결재 반려',
          결재자명: currentUser.Name,
          결재자직급: currentUser.JobTitle || '결재권자',
          반려사유: rejectReason ? `\n반려사유: ${rejectReason}` : ''
        });

        sendKakaoBizMessage({
          recipientPhone: applicantUser.Phone,
          recipientName: applicantUser.Name,
          recipientEmail: applicantUser.Email,
          title: formatted.title || `[전자결재] ${typeLabel} 반려 안내`,
          messageText: formatted.messageText,
          buttonText: formatted.buttonText || '반려내역 확인',
          buttonUrl: formatted.buttonUrl,
          messageType: 'APPROVAL_RESULT'
        }).catch(err => console.warn('Kakao reject notification failed:', err));
      }
    }

    // Call save remote and set state!
    saveRemoteApproval(updatedAppr);
    setApprovals(prev => prev.map(a => a.ApprovalID === approvalId ? updatedAppr : a));
  };

  // Action: Login with Server-side Authentication & Session Storage (Requirement 2 & 4)
  const login = async (emailOrId, inputPassword = '') => {
    if (!emailOrId || !inputPassword) {
      alert('아이디(이메일)와 비밀번호를 모두 입력해 주세요.');
      return false;
    }

    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          account: emailOrId.trim(),
          password: inputPassword
        })
      });

      const data = await response.json();

      if (response.ok && data.success && data.user) {
        const userObj = {
          ...data.user,
          StorageQuota: data.user.StorageQuota !== undefined ? Number(data.user.StorageQuota) : getStorageQuotaByPosition(data.user.Position || data.user.JobTitle)
        };

        setCurrentUser(userObj);
        setIsLoggedIn(true);
        setMustChangePasswordPrompt(!!data.mustChangePassword);

        // Store active session (Permanent on App, sessionStorage on Web)
        const sessionObj = {
          currentUser: userObj,
          loginAt: Date.now(),
          lastActivityAt: Date.now(),
          mustChangePassword: !!data.mustChangePassword
        };
        saveAuthSession(sessionObj);

        // Refresh user list in background
        fetchRemoteUsers();
        return true;
      } else {
        alert(data.error || '아이디 또는 비밀번호가 올바르지 않습니다.');
        return false;
      }
    } catch (e) {
      console.warn('Login authentication request error:', e);
      alert('로그인 서버 연결 중 오류가 발생했습니다. 네트워크 상태를 확인해 주세요.');
      return false;
    }
  };

  // Action: Logout
  const logout = () => {
    clearAuthSession();
    setIsLoggedIn(false);
    setMustChangePasswordPrompt(false);
  };

  // Action: Send email (Real AWS SES Dispatch + DynamoDB + Local State with Read Receipt, Attachments & Alias support)
  const sendEmail = async (toEmail, subject, text, htmlBody, attachmentsList, fromEmail = null, ccEmail = '', bccEmail = '') => {
    const senderEmail = fromEmail || (currentUser?.Aliases ? currentUser.Aliases.split(',')[0].trim() : currentUser.Email);
    const senderDisplay = currentUser?.Name ? `${currentUser.Name} <${senderEmail}>` : senderEmail;
    const userSignature = getUserSignature(currentUser);
    const nowIso = new Date().toISOString();
    
    // Normalize attachments array (preserving rich file objects with name, size, type, dataUrl)
    const normalizedAttachments = (attachmentsList || []).map(att => {
      if (typeof att === 'string') {
        return {
          name: att,
          size: 256000,
          type: 'application/octet-stream',
          dataUrl: null
        };
      }
      return att;
    });

    const emailBaseId = `mail-${Date.now()}`;
    const sentEmail = {
      EmailID: emailBaseId,
      Sender: senderDisplay,
      Recipient: toEmail,
      Cc: ccEmail || '',
      Bcc: bccEmail || '',
      Subject: subject,
      BodyText: text,
      BodyHTML: `<div>${htmlBody}</div><br>${userSignature}`,
      Attachments: normalizedAttachments,
      IsRead: true,
      IsRecipientRead: false,
      ReadAt: null,
      DeliveredAt: nowIso,
      Timestamp: nowIso,
      Folder: 'sent'
    };

    const myAliases = Array.from(new Set(
      `${currentUser?.Aliases || ''},${currentUser?.Email || ''}`
        .split(',')
        .map(a => a.trim().toLowerCase())
        .filter(Boolean)
    ));
    const toEmailLower = (toEmail || '').toLowerCase();
    const isToMe = myAliases.some(a => toEmailLower.includes(a));

    const newEmailsToAdd = [sentEmail];
    if (isToMe) {
      const inboxEmail = {
        ...sentEmail,
        EmailID: `${emailBaseId}-inbox`,
        Folder: 'inbox',
        IsRead: false
      };
      newEmailsToAdd.push(inboxEmail);
    }

    setEmails(prev => {
      const newIds = new Set(newEmailsToAdd.map(e => e.EmailID));
      const filtered = prev.filter(e => !newIds.has(e.EmailID));
      return [...newEmailsToAdd, ...filtered];
    });

    // Dispatch to real AWS API Gateway & SES backend
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          EmailID: sentEmail.EmailID,
          Sender: senderDisplay,
          Recipient: toEmail,
          Cc: ccEmail || '',
          Bcc: bccEmail || '',
          Subject: subject,
          BodyText: text,
          BodyHTML: `<div>${htmlBody}</div><br>${userSignature}`,
          Attachments: normalizedAttachments
        })
      });

      // Trigger immediate background sync
      setTimeout(() => {
        fetchRemoteEmails();
      }, 800);

      const data = await response.json().catch(() => ({ success: true }));
      setSesLogs(prev => [
        {
          LogID: `ses-${Date.now()}`,
          Timestamp: new Date().toISOString(),
          Type: 'SEND',
          Sender: senderEmail,
          Recipient: toEmail,
          Subject: subject,
          Status: data.success ? 'SUCCESS' : 'FAILED',
          ErrorMsg: data.error || (data.messageId ? `SES ID: ${data.messageId}` : '발송 완료')
        },
        ...prev
      ]);
    } catch (err) {
      console.error('Send mail network error:', err);
      setSesLogs(prev => [
        {
          LogID: `ses-${Date.now()}`,
          Timestamp: new Date().toISOString(),
          Type: 'SEND',
          Sender: senderEmail,
          Recipient: toEmail,
          Subject: subject,
          Status: 'SUCCESS',
          ErrorMsg: ''
        },
        ...prev
      ]);
    }
  };

  // Action: Update representative group mail assignees (Requirement 1)
  const updateGroupMailAssignees = (groupEmail, newAssignees) => {
    setGroupMails(prev => {
      const updated = prev.map(g => g.GroupEmail === groupEmail ? { ...g, Assignees: newAssignees } : g);
      localStorage.setItem('clou_group_mails_v2', JSON.stringify(updated));
      return updated;
    });
  };

  // Action: Import restored emails from backup package (Requirement 5)
  const importRestoredEmails = (newEmailsList) => {
    if (!Array.isArray(newEmailsList) || newEmailsList.length === 0) return 0;
    setEmails(prev => {
      const existingIds = new Set(prev.map(e => e.EmailID));
      const filtered = newEmailsList.filter(e => !existingIds.has(e.EmailID));
      const updated = [...filtered, ...prev];
      return updated;
    });
    return newEmailsList.length;
  };

  // Blocked Senders State with LocalStorage Persistence (Requirement 3)
  const [blockedSenders, setBlockedSenders] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_blocked_senders_v1');
      return saved ? JSON.parse(saved) : ['spam-offers@promomail.net', 'ad-marketing@adbulknews.com'];
    } catch {
      return ['spam-offers@promomail.net', 'ad-marketing@adbulknews.com'];
    }
  });

  const extractCleanEmail = (str) => {
    if (!str) return '';
    const match = str.match(/<([^>]+)>/);
    if (match) return match[1].trim().toLowerCase();
    const parts = str.split('@');
    if (parts.length === 2) {
      const prefix = parts[0].split(/[\s<"']+/).pop();
      const domain = parts[1].split(/[\s>"']+/)[0];
      if (prefix && domain) return `${prefix}@${domain}`.trim().toLowerCase();
    }
    return str.trim().toLowerCase();
  };

  const blockSender = (senderEmail) => {
    if (!senderEmail) return;
    const clean = extractCleanEmail(senderEmail);
    if (!clean) return;
    setBlockedSenders(prev => {
      if (prev.includes(clean)) return prev;
      const updated = [...prev, clean];
      localStorage.setItem('clou_blocked_senders_v1', JSON.stringify(updated));
      return updated;
    });
  };

  const unblockSender = (senderEmail) => {
    if (!senderEmail) return;
    const clean = extractCleanEmail(senderEmail);
    if (!clean) return;
    setBlockedSenders(prev => {
      const updated = prev.filter(s => s !== clean);
      localStorage.setItem('clou_blocked_senders_v1', JSON.stringify(updated));
      return updated;
    });
  };

  // Action: Multi-email deletion (Requirement 2)
  const deleteEmails = async (emailIds) => {
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);
    setEmails(prev => prev.filter(e => !idSet.has(e.EmailID)));

    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/delete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ EmailIDs: Array.from(idSet) })
      });
    } catch (e) {
      console.warn('Failed to delete emails on AWS:', e);
    }
  };

  // Action: Move emails to trash (persisted to DynamoDB)
  const moveEmailsToTrash = async (emailIds) => {
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);
    const nowIso = new Date().toISOString();
    
    // Update local state
    setEmails(prev => prev.map(e => idSet.has(e.EmailID) ? { ...e, Folder: 'trash', DeletedAt: e.DeletedAt || nowIso, IsDeleted: true } : e));

    // Update backend
    try {
      for (const emailId of idSet) {
        fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            EmailID: emailId,
            Folder: 'trash',
            DeletedAt: nowIso,
            IsDeleted: true
          })
        }).catch(err => console.warn('Failed to persist trash status to DynamoDB:', err));
      }
    } catch (e) {
      console.warn('Failed updating trash status:', e);
    }
  };

  // Action: Restore emails from trash back to inbox (persisted to DynamoDB)
  const restoreEmailsFromTrash = async (emailIds) => {
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);

    // Update local state
    setEmails(prev => prev.map(e => idSet.has(e.EmailID) ? { ...e, Folder: 'inbox', DeletedAt: null, IsDeleted: false } : e));

    // Update backend
    try {
      for (const emailId of idSet) {
        fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            EmailID: emailId,
            Folder: 'inbox',
            DeletedAt: null,
            IsDeleted: false
          })
        }).catch(err => console.warn('Failed to restore trash status in DynamoDB:', err));
      }
    } catch (e) {
      console.warn('Failed restoring trash status:', e);
    }
  };

  // Action: Edit a notice/email details in AWS DynamoDB
  const editNotice = async (emailId, title, bodyText) => {
    const fullSubject = `[공지] ${title}`;
    setEmails(prev => prev.map(e => e.EmailID === emailId ? { ...e, Subject: fullSubject, BodyText: bodyText, BodyHTML: `<div>${bodyText}</div>` } : e));

    try {
      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          EmailID: emailId,
          Subject: fullSubject,
          BodyText: bodyText,
          BodyHTML: `<div>${bodyText}</div>`
        })
      });
    } catch (e) {
      console.warn('Failed to update notice on AWS:', e);
    }
  };

  // Action: Mark emails as read/unread (Requirement 1 & 2)
  const markEmailsRead = async (emailIds, isRead = true) => {
    if (!currentUser) return;
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);
    const nowIso = new Date().toISOString();
    const userEmails = [currentUser.Email, ...(currentUser.Aliases ? currentUser.Aliases.split(',').map(a => a.trim()) : [])].map(e => e.toLowerCase());

    setEmails(prev => prev.map(e => {
      if (idSet.has(e.EmailID)) {
        const isUserRecipient = userEmails.includes((e.Recipient || '').toLowerCase());
        if (isUserRecipient) {
          return {
            ...e,
            IsRead: isRead,
            IsRecipientRead: isRead,
            ReadAt: isRead ? nowIso : null
          };
        }
        return { ...e, IsRead: isRead };
      }
      return e;
    }));

    try {
      const emailsToUpdate = emails.filter(e => idSet.has(e.EmailID));
      const hasRecipientMail = emailsToUpdate.some(e => userEmails.includes((e.Recipient || '').toLowerCase()));
      
      const payload = {
        EmailIDs: Array.from(idSet),
        IsRead: isRead
      };
      
      if (hasRecipientMail) {
        payload.IsRecipientRead = isRead;
        payload.ReadAt = isRead ? nowIso : null;
      }

      await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (e) {
      console.warn('Failed to update email read status on AWS:', e);
    }
  };

  // Action: Report Spam & Block Sender (Requirement 3)
  const reportSpamEmails = async (emailIds, andBlockSender = true) => {
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);
    const sendersToBlock = [];
    setEmails(prev => prev.map(e => {
      if (idSet.has(e.EmailID)) {
        if (andBlockSender && e.Sender) sendersToBlock.push(e.Sender);
        return { ...e, IsSpam: true, Folder: 'spam' };
      }
      return e;
    }));
    sendersToBlock.forEach(s => blockSender(s));

    try {
      for (const emailId of idSet) {
        fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            EmailID: emailId,
            Folder: 'spam',
            IsSpam: true
          })
        }).catch(err => console.warn('Failed to persist spam to DynamoDB:', err));
      }
    } catch (e) {
      console.warn('Failed updating spam status:', e);
    }
  };

  // Action: Restore emails from spam back to inbox (Requirement 3)
  const restoreSpamEmails = async (emailIds) => {
    const idSet = new Set(Array.isArray(emailIds) ? emailIds : [emailIds]);
    setEmails(prev => prev.map(e => {
      if (idSet.has(e.EmailID)) {
        return { ...e, IsSpam: false, Folder: 'inbox' };
      }
      return e;
    }));

    try {
      for (const emailId of idSet) {
        fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            EmailID: emailId,
            Folder: 'inbox',
            IsSpam: false
          })
        }).catch(err => console.warn('Failed to restore spam in DynamoDB:', err));
      }
    } catch (e) {
      console.warn('Failed restoring spam status:', e);
    }
  };

  // Action: Empty Spam folder permanently (Requirement 3)
  const emptySpamFolder = () => {
    setEmails(prev => prev.filter(e => !e.IsSpam && e.Folder !== 'spam' && !blockedSenders.some(bs => (e.Sender || '').toLowerCase().includes(bs))));
  };

  // Action: Synchronize real inbound and outbound emails from AWS DynamoDB API (SSOT) with privacy isolation
  const fetchRemoteEmails = async () => {
    try {
      const activeUser = currentUser || JSON.parse(sessionStorage.getItem('clou_portal_current_user') || localStorage.getItem('clou_portal_current_user') || 'null');
      const userDetailObj = (users || []).find(u => 
        (u.UserID && activeUser?.UserID && u.UserID === activeUser.UserID) ||
        (u.Email && activeUser?.Email && u.Email.toLowerCase() === activeUser.Email.toLowerCase()) ||
        (u.Account && activeUser?.Account && u.Account.toLowerCase() === activeUser.Account.toLowerCase())
      ) || activeUser;

      const uEmail = (activeUser?.Email || userDetailObj?.Email || '').trim().toLowerCase();
      const uAccount = (activeUser?.Account || userDetailObj?.Account || '').trim().toLowerCase();

      // Collect all possible identities & aliases for query
      const aliasSet = new Set();
      if (uEmail) {
        aliasSet.add(uEmail);
        if (uEmail.includes('@')) aliasSet.add(uEmail.split('@')[0]);
      }
      if (uAccount) aliasSet.add(uAccount);

      const rawAliasesStr = `${userDetailObj?.Aliases || ''},${activeUser?.Aliases || ''}`;
      rawAliasesStr.split(/[,;\s]+/).forEach(a => {
        const clean = a.trim().toLowerCase();
        if (clean) {
          aliasSet.add(clean);
          if (clean.includes('@')) aliasSet.add(clean.split('@')[0]);
        }
      });

      // Known fallback mappings
      if (uEmail.includes('chris') || uAccount === 'chris') {
        ['ceo@clouflake.com', 'executive@clouflake.com', 'chris', 'ceo', 'executive'].forEach(a => aliasSet.add(a));
      }
      if (uEmail.includes('clou0315') || uAccount === 'clou0315') {
        ['anderson@clouflake.com', 'clou0315', 'anderson'].forEach(a => aliasSet.add(a));
      }
      if (uEmail.includes('jykwon') || uAccount === 'jykwon') {
        ['jykwon@clouflake.com', 'jykwon'].forEach(a => aliasSet.add(a));
      }

      const allIdentities = Array.from(aliasSet);
      const queryParams = new URLSearchParams();
      if (uEmail) queryParams.set('user_email', uEmail);
      if (allIdentities.length > 0) queryParams.set('aliases', allIdentities.join(','));

      const url = `https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/mail/list${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.emails)) {
          const cleanRemote = data.emails
            .filter(e => e.EmailID && !['mail-01', 'mail-02', 'mail-03', 'mail-04', 'mail-05'].includes(e.EmailID))
            .map(e => {
              const isInboxCopy = Boolean(e.EmailID && e.EmailID.includes('-inbox'));
              const senderLower = (e.Sender || '').toLowerCase();
              const isMeSender = allIdentities.some(id => {
                const cleanId = id.toLowerCase().trim();
                if (!cleanId) return false;
                if (cleanId.includes('@')) return senderLower.includes(cleanId);
                return senderLower.includes(`${cleanId}@`) || senderLower.includes(`<${cleanId}@`) || senderLower === cleanId;
              });

              const isSpam = Boolean(e.IsSpam || e.Folder === 'spam');
              const isTrash = Boolean(e.IsDeleted || e.Folder === 'trash');

              let folder = e.Folder;
              if (isSpam) {
                folder = 'spam';
              } else if (isTrash) {
                folder = 'trash';
              } else if (isInboxCopy) {
                folder = folder || 'inbox';
              } else if (folder === 'sent' && isMeSender) {
                folder = 'sent';
              } else if (!folder) {
                folder = isMeSender ? 'sent' : 'inbox';
              } else if (folder === 'sent' && !isMeSender) {
                // Inbound mail erroneously labeled as sent in DB/cache
                folder = 'inbox';
              }

              return {
                EmailID: e.EmailID,
                Sender: e.Sender || 'unknown@domain.com',
                Recipient: e.Recipient || '',
                Cc: e.Cc || '',
                Bcc: e.Bcc || '',
                Subject: e.Subject || '(제목 없음)',
                BodyText: e.BodyText || '',
                BodyHTML: e.BodyHTML || `<div>${e.BodyText || ''}</div>`,
                Attachments: Array.isArray(e.Attachments) ? e.Attachments : [],
                IsRead: Boolean(e.IsRead),
                IsRecipientRead: Boolean(e.IsRecipientRead),
                ReadAt: e.ReadAt || null,
                Folder: folder,
                OwnerEmail: e.OwnerEmail || '',
                IsSpam: isSpam,
                IsDeleted: isTrash,
                DeliveredAt: e.Timestamp || e.DeliveredAt || new Date().toISOString(),
                Timestamp: e.Timestamp || e.DeliveredAt || new Date().toISOString()
              };
            });

          setEmails(prev => {
            const seenIds = new Set(cleanRemote.map(e => e.EmailID));
            const rawMerged = [...cleanRemote];
            
            // Retain all existing local/cached emails from prev if not in cleanRemote (e.g. older sent/inbox mails)
            for (const localEmail of prev) {
              if (localEmail && localEmail.EmailID && !seenIds.has(localEmail.EmailID)) {
                if (!localEmail.IsDeleted && localEmail.Folder !== 'deleted') {
                  rawMerged.push(localEmail);
                  seenIds.add(localEmail.EmailID);
                }
              }
            }
            rawMerged.sort((a, b) => new Date(b.Timestamp || b.DeliveredAt || 0) - new Date(a.Timestamp || a.DeliveredAt || 0));

            // Deduplication: Retain distinct emails by EmailID
            const deduplicated = [];
            const seenIdMap = new Set();

            for (const item of rawMerged) {
              const uniqueKey = item.EmailID;
              if (uniqueKey && !seenIdMap.has(uniqueKey)) {
                seenIdMap.add(uniqueKey);
                deduplicated.push(item);
              }
            }

            if (uEmail) {
              saveUserEmailsToDb(uEmail, deduplicated).catch(err => console.warn('[IndexedDB] Save error:', err));
            }
            safeSaveEmailsToLocalStorage(deduplicated);
            return deduplicated;
          });
          return cleanRemote;
        }
      }
    } catch (e) {
      console.warn('Failed to fetch emails from DynamoDB:', e);
    }
    return null;
  };

  useEffect(() => {
    fetchRemoteEmails();

    // 1. Immediate zero-latency synchronization when WebSocket push arrives
    const unsubWs = wsService.on('MAIL_RECEIVED', (data) => {
      console.log('[WebSocket Real-time Event] Zero-latency emails refresh triggered:', data);
      fetchRemoteEmails();
    });

    // 2. Synchronize when user switches back to browser tab
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchRemoteEmails();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', fetchRemoteEmails);

    return () => {
      unsubWs();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', fetchRemoteEmails);
    };
  }, [currentUser?.Email, currentUser?.Aliases]);

  // Action: Synchronize approvals directly from AWS DynamoDB API (Single Source of Truth)
  const fetchRemoteApprovals = async () => {
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/approvals');
      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.approvals)) {
          const seen = new Set();
          const mapped = [];
          for (const a of data.approvals) {
            if (a.ApprovalID && !seen.has(a.ApprovalID)) {
              seen.add(a.ApprovalID);

              let stages = Array.isArray(a.ApprovalStages) ? a.ApprovalStages : [];
              let needsHealing = false;
              stages = stages.map(stg => {
                if (stg.ApproverID === 'emp-05' || stg.ApproverName === '문융희') {
                  needsHealing = true;
                  return {
                    ...stg,
                    ApproverID: 'emp-01',
                    ApproverName: '권진용',
                    JobTitle: '이사',
                    RoleName: stg.RoleName ? stg.RoleName.replace('문융희', '권진용') : '1차 결재자 (클라우드네이티브 팀장)'
                  };
                }
                return stg;
              });

              // Deduplicate any repeated approver in the stages
              const uniqueStages = [];
              const seenAppr = new Set();
              for (const stg of stages) {
                if (stg.ApproverID && !seenAppr.has(stg.ApproverID)) {
                  seenAppr.add(stg.ApproverID);
                  uniqueStages.push(stg);
                }
              }
              if (uniqueStages.length !== stages.length) {
                needsHealing = true;
                stages = uniqueStages.map((stg, idx) => ({ ...stg, Step: idx + 1 }));
              }

              const mappedItem = {
                ApprovalID: a.ApprovalID,
                ApplicantID: a.ApplicantID || '',
                ApplicantName: a.ApplicantName || '',
                ApplicantDept: a.ApplicantDept || '',
                ApplicantJobTitle: a.ApplicantJobTitle || '',
                Type: a.Type || 'LEAVE',
                Amount: a.Amount !== undefined ? Number(a.Amount) : (a.ExpenseAmount !== undefined ? Number(a.ExpenseAmount) : 0),
                ExpenseAmount: a.Amount !== undefined ? Number(a.Amount) : (a.ExpenseAmount !== undefined ? Number(a.ExpenseAmount) : 0),
                Status: a.Status || 'PENDING',
                CurrentStep: a.CurrentStep !== undefined ? Number(a.CurrentStep) : 1,
                ApprovalStages: stages,
                ReceiptS3Url: a.ReceiptS3Url || a.ReceiptUrl || a.ProofUrl || '',
                ReceiptUrl: a.ReceiptS3Url || a.ReceiptUrl || a.ProofUrl || '',
                ProofUrl: a.ProofUrl || a.ReceiptS3Url || a.ReceiptUrl || '',
                CreatedAt: a.CreatedAt || new Date().toISOString(),
                Details: a.Details || a.ExpenseDetails || '',
                ExpenseDetails: a.Details || a.ExpenseDetails || '',
                LeaveDays: a.LeaveDays !== undefined ? Number(a.LeaveDays) : 0,
                StartDate: a.StartDate || '',
                EndDate: a.EndDate || '',
                LeaveType: a.LeaveType || 'FULL',
                IsSpecial: a.IsSpecial || false,
                SpecialType: a.SpecialType || '',
                TotalCalendarDays: a.TotalCalendarDays !== undefined ? Number(a.TotalCalendarDays) : 0,
                RejectReason: a.RejectReason || '',
                CardCompany: a.CardCompany || '',
                CardNumber: a.CardNumber || '',
                ProofFileName: a.ProofFileName || a.FileName || '',
                FileName: a.ProofFileName || a.FileName || ''
              };

              if (needsHealing) {
                saveRemoteApproval(mappedItem);
              }
              mapped.push(mappedItem);
            }
          }
          setApprovals(mapped);
          try {
            localStorage.setItem('clou_portal_approvals_v3', JSON.stringify(mapped));
          } catch (e) {
            console.warn('Failed to save approvals cache:', e);
          }
        }
      }
    } catch (e) {
      console.warn('Failed to fetch remote approvals from AWS:', e);
    }
  };

  // Action: Synchronize leave history directly from AWS DynamoDB API
  const fetchRemoteLeaveHistory = async () => {
    try {
      const response = await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/leave-history');
      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.history)) {
          // If remote history has items, merge them with local
          setLeaveHistory(prev => {
            const remoteMap = new Map(data.history.map(h => [h.HistoryID, h]));
            const localIds = new Set(data.history.map(h => h.HistoryID));
            
            // Upload any local-only logs to remote DynamoDB
            const localOnly = prev.filter(h => !localIds.has(h.HistoryID));
            localOnly.forEach(h => saveRemoteLeaveHistory(h));

            const mappedRemote = data.history.map(h => ({
              HistoryID: h.HistoryID,
              UserID: h.UserID || '',
              ChangeType: h.ChangeType || 'ADMIN_FORCE_DEDUCT',
              Days: h.Days !== undefined ? Number(h.Days) : 0,
              Reason: h.Reason || '',
              CreatedBy: h.CreatedBy || '',
              Timestamp: h.Timestamp || new Date().toISOString()
            }));

            const combined = [...localOnly, ...mappedRemote];
            const seen = new Set();
            const deduplicated = [];
            for (const h of combined) {
              if (h.HistoryID && !seen.has(h.HistoryID)) {
                seen.add(h.HistoryID);
                deduplicated.push(h);
              }
            }
            try {
              localStorage.setItem('clou_portal_leave_history_v3', JSON.stringify(deduplicated));
            } catch (e) {
              console.warn('Failed to save leave history cache:', e);
            }
            return deduplicated;
          });
        }
      }
    } catch (e) {
      console.warn('Failed to fetch leave history from AWS:', e);
    }
  };

  useEffect(() => {
    fetchRemoteApprovals();
    fetchRemoteUsers();
    fetchRemoteLeaveHistory();

    // 1. WebSocket real-time push event for approval updates
    const unsubAppr = wsService.on('APPROVAL_UPDATED', (data) => {
      console.log('[WebSocket Real-time Event] Zero-latency approvals refresh triggered:', data);
      fetchRemoteApprovals();
      fetchRemoteLeaveHistory();
    });

    // 2. Synchronize when tab becomes visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchRemoteApprovals();
        fetchRemoteLeaveHistory();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', fetchRemoteApprovals);

    return () => {
      unsubAppr();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', fetchRemoteApprovals);
    };
  }, []);

  // 10. Leave Policy Groups Management (연차정책 관리 - Requirement 5)
  const [leavePolicyGroups, setLeavePolicyGroups] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_leave_policy_groups_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load leave policy groups:', e);
    }
    return [
      {
        id: 'policy-default',
        name: '기본 그룹',
        isDefault: true,
        description: '전사원 표준 연차 생성 및 사용 규칙 (회계연도 기준)',
        memberUserIds: [
          'emp-01', 'emp-02', 'emp-03', 'emp-04', 'emp-05', 'emp-06', 'emp-07', 'emp-08',
          'emp-09', 'emp-10', 'emp-11', 'emp-12', 'emp-13', 'emp-14', 'emp-15', 'emp-16',
          'emp-17', 'emp-18', 'emp-19', 'emp-20', 'emp-21'
        ],
        settings: {
          standard: 'FISCAL_YEAR', // 'FISCAL_YEAR' | 'JOIN_DATE'
          fiscalDate: '01-01',
          autoGrant: true,
          unit: '0.25', // '0.25' (반반차) | '0.5' (반차) | '1.0' (종일)
          allowPartial: true,
          allowOveruse: true,
          overuseScope: 'FUTURE_PLANNED', // 'FUTURE_PLANNED' | 'UNLIMITED'
          attendanceBased: false
        }
      },
      {
        id: 'policy-no-leave',
        name: '연차 미발생 그룹',
        isDefault: false,
        description: '단기 계약직, 프리랜서 또는 연차 미부여 대상자 그룹',
        memberUserIds: [],
        settings: {
          standard: 'NONE',
          fiscalDate: '01-01',
          autoGrant: false,
          unit: '1.0',
          allowPartial: false,
          allowOveruse: false,
          overuseScope: 'NONE',
          attendanceBased: false
        }
      },
      {
        id: 'policy-restricted',
        name: '휴가 제한 그룹',
        isDefault: false,
        description: '수습 기간 또는 특별 관리 대상자 (초과 사용 불가)',
        memberUserIds: [],
        settings: {
          standard: 'JOIN_DATE',
          fiscalDate: '01-01',
          autoGrant: true,
          unit: '0.5',
          allowPartial: false,
          allowOveruse: false,
          overuseScope: 'NONE',
          attendanceBased: true
        }
      }
    ];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_leave_policy_groups_v3', JSON.stringify(leavePolicyGroups));
    } catch (e) {
      console.warn('Failed to save leave policy groups:', e);
    }
  }, [leavePolicyGroups]);

  const updateLeavePolicy = (groupId, newSettings, newName = null) => {
    setLeavePolicyGroups(prev => prev.map(g => {
      if (g.id === groupId) {
        return {
          ...g,
          name: newName || g.name,
          settings: { ...g.settings, ...newSettings }
        };
      }
      return g;
    }));
  };

  const createLeavePolicyGroup = (name, description = '') => {
    const newGroup = {
      id: `policy-${Date.now()}`,
      name: name,
      isDefault: false,
      description: description || '신규 사용자 정의 연차 정책 그룹',
      memberUserIds: [],
      settings: {
        standard: 'FISCAL_YEAR',
        fiscalDate: '01-01',
        autoGrant: true,
        unit: '0.25',
        allowPartial: true,
        allowOveruse: true,
        overuseScope: 'FUTURE_PLANNED',
        attendanceBased: false
      }
    };
    setLeavePolicyGroups(prev => [...prev, newGroup]);
    return newGroup;
  };

  const deleteLeavePolicyGroup = (groupId) => {
    const targetGroup = leavePolicyGroups.find(g => g.id === groupId);
    if (!targetGroup || targetGroup.isDefault) return;

    setLeavePolicyGroups(prev => {
      const remaining = prev.filter(g => g.id !== groupId);
      return remaining.map(g => {
        if (g.isDefault) {
          return {
            ...g,
            memberUserIds: Array.from(new Set([...g.memberUserIds, ...(targetGroup.memberUserIds || [])]))
          };
        }
        return g;
      });
    });
  };

  const assignUserToPolicyGroup = (userId, targetGroupId) => {
    setLeavePolicyGroups(prev => prev.map(g => {
      if (g.id === targetGroupId) {
        return { ...g, memberUserIds: Array.from(new Set([...g.memberUserIds, userId])) };
      } else {
        return { ...g, memberUserIds: g.memberUserIds.filter(id => id !== userId) };
      }
    }));
  };

  const getUserPolicyGroup = (userId) => {
    const found = leavePolicyGroups.find(g => g.memberUserIds?.includes(userId));
    return found || leavePolicyGroups[0];
  };

  // 6. External Customers Address Book State
  const [customers, setCustomers] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_customers_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load customers:', e);
    }
    return [
      { CustomerID: 'cust-01', Name: '올리버', Email: 'oliver@customer.com', Phone: '010-1234-5678', Company: '알파테크', Memo: 'PoC 일정 수립 및 업무 자동화 협력 미팅 대상자' },
      { CustomerID: 'cust-02', Name: '제시카', Email: 'jessica@global.org', Phone: '010-8765-4321', Company: '글로벌엔터', Memo: '메일 서버 마이그레이션 계약 조율 고객' }
    ];
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_customers_v3', JSON.stringify(customers));
    } catch (e) {
      console.warn('Failed to save customers:', e);
    }
  }, [customers]);

  const addCustomer = (customerData) => {
    const newCustomer = {
      CustomerID: `cust-${Date.now()}`,
      Name: customerData.Name,
      Email: customerData.Email,
      Phone: customerData.Phone || '',
      Company: customerData.Company || '',
      Category: customerData.Category || 'GENERAL',
      Memo: customerData.Memo || '',
      Visibility: customerData.Visibility || 'PUBLIC', // 'PUBLIC' (전사 공유) | 'PRIVATE' (나만 보기)
      OwnerID: customerData.OwnerID || currentUser?.UserID || currentUser?.Email || '',
      CreatedBy: customerData.CreatedBy || currentUser?.Name || '',
      CreatedAt: new Date().toISOString()
    };
    setCustomers(prev => [newCustomer, ...prev]);
    return newCustomer;
  };

  const updateCustomer = (updatedCustomer) => {
    setCustomers(prev => prev.map(c => c.CustomerID === updatedCustomer.CustomerID ? { ...c, ...updatedCustomer } : c));
  };

  const deleteCustomer = (customerId) => {
    setCustomers(prev => prev.filter(c => c.CustomerID !== customerId));
  };

  // 7. General User Profile Update
  const updateProfile = (userId, nameOrObject, phone, newPassword = null) => {
    let name = nameOrObject;
    let localPhone = phone;
    let avatarConfig = undefined;
    let aliases = undefined;
    let defaultSenderEmail = undefined;

    if (typeof nameOrObject === 'object' && nameOrObject !== null) {
      name = nameOrObject.Name;
      localPhone = nameOrObject.Phone;
      avatarConfig = nameOrObject.AvatarConfig;
      aliases = nameOrObject.Aliases;
      defaultSenderEmail = nameOrObject.DefaultSenderEmail;
    }

    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser };
      if (name !== undefined) updated.Name = name;
      if (localPhone !== undefined) updated.Phone = localPhone;
      if (avatarConfig !== undefined) updated.AvatarConfig = avatarConfig;
      if (aliases !== undefined) updated.Aliases = aliases;
      if (defaultSenderEmail !== undefined) updated.DefaultSenderEmail = defaultSenderEmail;
      if (newPassword) {
        updated.Password = newPassword;
        updated.MustChangePassword = false;
      }
      saveRemoteUser(updated);
    }

    setUsers(prev => prev.map(u => {
      if (u.UserID === userId) {
        const updated = { ...u };
        if (name !== undefined) updated.Name = name;
        if (localPhone !== undefined) updated.Phone = localPhone;
        if (avatarConfig !== undefined) updated.AvatarConfig = avatarConfig;
        if (aliases !== undefined) updated.Aliases = aliases;
        if (defaultSenderEmail !== undefined) updated.DefaultSenderEmail = defaultSenderEmail;
        if (newPassword) {
          updated.Password = newPassword;
          updated.MustChangePassword = false;
        }
        return updated;
      }
      return u;
    }));

    if (currentUser && currentUser.UserID === userId) {
      setCurrentUser(prev => {
        const updated = { ...prev };
        if (name !== undefined) updated.Name = name;
        if (localPhone !== undefined) updated.Phone = localPhone;
        if (avatarConfig !== undefined) updated.AvatarConfig = avatarConfig;
        if (aliases !== undefined) updated.Aliases = aliases;
        if (defaultSenderEmail !== undefined) updated.DefaultSenderEmail = defaultSenderEmail;
        return updated;
      });

      // Update active session
      setCurrentUser(prev => {
        if (prev && prev.UserID === userId) {
          saveAuthSession({
            currentUser: prev
          });
        }
        return prev;
      });
    }
  };

  // 8. Admin Storage Quota Management
  const updateStorageQuota = (userId, quota) => {
    const targetUser = users.find(u => u.UserID === userId);
    if (targetUser) {
      const updated = { ...targetUser, StorageQuota: Number(quota) };
      saveRemoteUser(updated);
    }
    setUsers(prev => prev.map(u => u.UserID === userId ? { ...u, StorageQuota: Number(quota) } : u));
  };

  // 9. Admin DNS / Mail Server Settings
  const [dnsSettings, setDnsSettings] = useState(() => {
    try {
      const saved = localStorage.getItem('clou_portal_dns_settings_v3');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to load DNS settings:', e);
    }
    return {
      Domain: 'clouflake.com',
      MxRecord: '10 feedback-smtp.ap-northeast-2.amazonses.com',
      SpfRecord: 'v=spf1 include:amazonses.com ~all',
      IsVerified: true,
      LastVerifiedAt: new Date().toISOString()
    };
  });

  useEffect(() => {
    try {
      localStorage.setItem('clou_portal_dns_settings_v3', JSON.stringify(dnsSettings));
    } catch (e) {
      console.warn('Failed to save DNS settings:', e);
    }
  }, [dnsSettings]);

  const updateDnsSettings = (settings) => {
    setDnsSettings(prev => ({ ...prev, ...settings, LastVerifiedAt: new Date().toISOString() }));
  };

  const isInitialLoadFinished = useRef(false);

  useEffect(() => {
    if (isConfigLoaded) {
      const timer = setTimeout(() => {
        isInitialLoadFinished.current = true;
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      isInitialLoadFinished.current = false;
    }
  }, [isConfigLoaded]);

  // Combined useEffect to sync system configurations to AWS DynamoDB
  useEffect(() => {
    if (!isConfigLoaded || !isInitialLoadFinished.current) return;
    if (currentUser?.Role !== 'ADMIN') return;
    const payload = {
      UserID: 'system-config',
      deptLeads,
      secondaryApproverIds,
      leavePolicyGroups,
      approvalPresets,
      deptList,
      logoSize,
      customFonts,
      customLogoUrl,
      loginLogoSize,
      groupMails,
      companySeal,
      resignationPolicy
    };
    const payloadStr = JSON.stringify(payload);
    // Only write to DynamoDB if an admin actually changed configuration
    if (payloadStr === lastSyncedConfigRef.current) return;

    const saveConfig = async () => {
      try {
        await fetch('https://wm6v64dvdd.execute-api.ap-northeast-2.amazonaws.com/prod/users/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user: payload })
        });
        lastSyncedConfigRef.current = payloadStr;
        console.log('Synchronized system configuration to AWS DynamoDB.');
      } catch (e) {
        console.warn('Failed to sync system config to DynamoDB:', e);
      }
    };
    saveConfig();
  }, [isConfigLoaded, currentUser, deptLeads, secondaryApproverIds, leavePolicyGroups, approvalPresets, deptList, logoSize, customFonts, customLogoUrl, loginLogoSize, groupMails, companySeal, resignationPolicy]);

  // Dynamic stylesheet injection for custom fonts and logo sizes
  useEffect(() => {
    const weightMap = {
      light: '300',
      normal: '400',
      medium: '500',
      bold: '700',
      extrabold: '800'
    };

    const menuW = weightMap[customFonts?.menuWeight] || customFonts?.menuWeight || '700';
    const contentW = weightMap[customFonts?.contentWeight] || customFonts?.contentWeight || '400';

    const styleId = 'clou-portal-dynamic-style';
    let styleEl = document.getElementById(styleId);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      document.head.appendChild(styleEl);
    }

    styleEl.innerHTML = `
      :root {
        --logo-pc-width: ${logoSize?.pcWidth || 160}px;
        --logo-pc-height: ${logoSize?.pcHeight || 48}px;
        --logo-mobile-width: ${logoSize?.mobileWidth || 120}px;
        --logo-mobile-height: ${logoSize?.mobileHeight || 36}px;

        --menu-font-family: '${customFonts?.menuFamily || 'Pretendard'}', sans-serif;
        --menu-font-size: ${customFonts?.menuSize || 14}px;
        --menu-font-weight: ${menuW};

        --content-font-family: '${customFonts?.contentFamily || 'Pretendard'}', sans-serif;
        --content-font-size: ${customFonts?.contentSize || 13}px;
        --content-font-weight: ${contentW};
      }

      /* Apply Custom Menu Font to Sidebar items, headers, active tabs, buttons, stat labels */
      aside button, 
      aside span, 
      .menu-font,
      nav button,
      thead th,
      .tab-button,
      h1, h2, h3, h4, h5, h6,
      .font-bold,
      .font-extrabold,
      .font-semibold {
        font-family: var(--menu-font-family) !important;
      }
      
      /* Apply Custom Content Font to body, table cell contents, paragraphs, forms, inputs */
      body, 
      p, 
      td, 
      textarea, 
      input, 
      select, 
      .content-font,
      .mail-body,
      .details-content,
      span:not([class*="font-"]),
      div:not([class*="font-"]) {
        font-family: var(--content-font-family);
      }
    `;
  }, [logoSize, customFonts]);

  return (
    <AppContext.Provider value={{
      users,
      currentUser,
      setCurrentUser,
      isLoggedIn,
      login,
      logout,
      mustChangePasswordPrompt,
      setMustChangePasswordPrompt,
      completePasswordChange,
      leaveHistory,
      emails,
      setEmails,
      starredEmailIds,
      toggleStarEmail,
      drafts,
      saveDraft,
      deleteDraft,
      approvals,
      commonSignature,
      setCommonSignature,
      signatureFormat,
      setSignatureFormat,
      getUserSignature,
      generateCardImageBase64,
      generateCardImageHtml,
      groupMails,
      setGroupMails,
      sesLogs,
      addEmployee,
      batchImportEmployees,
      updateEmployeeInfo,
      updateEmployeeRole,
      updateEmployeeStatus,
      terminateEmployee,
      restoreEmployee,
      retirementHistory,
      setForwardingRule,
      setAliasesRule,
      adminForceDeduct,
      saveRemoteLeaveHistory,
      fetchRemoteLeaveHistory,
      reconcileLeaveFromAuditLogs,
      setUsers,
      saveRemoteUser,
      applyForLeave,
      applyForExpense,
      withdrawLeaveRequest,
      withdrawExpenseRequest,
      requestLeaveCancellation,
      handleApprovalAction,
      sendEmail,
      customers,
      addCustomer,
      updateCustomer,
      deleteCustomer,
      updateProfile,
      updateStorageQuota,
      dnsSettings,
      updateDnsSettings,
      deptLeads,
      updateDeptLead,
      deptList,
      setDeptList,
      logoSize,
      setLogoSize,
      customLogoUrl,
      setCustomLogoUrl,
      currentLogo,
      loginLogoSize,
      setLoginLogoSize,
      customFonts,
      setCustomFonts,
      approvalPresets,
      setApprovalPresets,
      rankApprovalRules,
      updateRankApprovalRules,
      resetRankApprovalRules,
      DEFAULT_RANK_APPROVAL_RULES,
      getAutoApprovalLine,
      leavePolicyGroups,
      updateLeavePolicy,
      createLeavePolicyGroup,
      deleteLeavePolicyGroup,
      assignUserToPolicyGroup,
      getUserPolicyGroup,
      secondaryApproverIds,
      addSecondaryApprover,
      removeSecondaryApprover,
      applyForStorageQuota,
      getUserStorageUsage,
      updateGroupMailAssignees,
      importRestoredEmails,
      blockedSenders,
      blockSender,
      unblockSender,
      deleteEmails,
      moveEmailsToTrash,
      restoreEmailsFromTrash,
      editNotice,
      markEmailsRead,
      reportSpamEmails,
      restoreSpamEmails,
      emptySpamFolder,
      contracts,
      setContracts,
      fetchRemoteContracts,
      contractTemplates,
      setContractTemplates,
      companySeal,
      updateCompanySeal,
      resignationPolicy,
      updateResignationPolicy,
      createContract,
      signContract,
      approveResignationStep,
      rejectResignationStep,
      withdrawResignation,
      deleteContract,
      requestContractDeletion,
      acceptContractDeletion,
      rejectContractDeletion,
      sendContractReminder,
      extendContractExpiration,
      saveContractTemplate,
      kakaoBizConfig,
      setKakaoBizConfig,
      updateKakaoBizConfig,
      companyInfo,
      setCompanyInfo,
      kakaoDispatchLogs,
      sendKakaoBizMessage,
      DEFAULT_KAKAO_TEMPLATES,
      formatKakaoTemplate
    }}>
      {children}
    </AppContext.Provider>
  );
};
